/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * PanLuma API
 * Enterprise productivity application API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type { AddJobInterviewerApiV1RecruitingJobsJobIdInterviewersPostBody } from '../models/addJobInterviewerApiV1RecruitingJobsJobIdInterviewersPostBody';

import type { AddParticipantRequest } from '../models/addParticipantRequest';

import type { BulkMoveRequest } from '../models/bulkMoveRequest';

import type { BulkRejectRequest } from '../models/bulkRejectRequest';

import type { CancelInterviewApiV1RecruitingInterviewsInterviewIdCancelPostBody } from '../models/cancelInterviewApiV1RecruitingInterviewsInterviewIdCancelPostBody';

import type { CandidateFilterFacets } from '../models/candidateFilterFacets';

import type { CandidateListResponse } from '../models/candidateListResponse';

import type { CandidateResponse } from '../models/candidateResponse';

import type { CloseJobApiV1RecruitingJobsJobIdClosePostBody } from '../models/closeJobApiV1RecruitingJobsJobIdClosePostBody';

import type { CreateApplicationApiV1RecruitingApplicationsPostBody } from '../models/createApplicationApiV1RecruitingApplicationsPostBody';

import type { CreateCandidateApiV1RecruitingCandidatesPostBody } from '../models/createCandidateApiV1RecruitingCandidatesPostBody';

import type { CreateDepartmentApiV1RecruitingDepartmentsPostBody } from '../models/createDepartmentApiV1RecruitingDepartmentsPostBody';

import type { CreateOfferRequest } from '../models/createOfferRequest';

import type { CreatePipelineApiV1RecruitingPipelinesPostBody } from '../models/createPipelineApiV1RecruitingPipelinesPostBody';

import type { CreateSchedulingLinkRequest } from '../models/createSchedulingLinkRequest';

import type { CreateScorecardTemplateApiV1RecruitingScorecardTemplatesPostBody } from '../models/createScorecardTemplateApiV1RecruitingScorecardTemplatesPostBody';

import type { DuplicateJobApiV1RecruitingJobsJobIdDuplicatePostBody } from '../models/duplicateJobApiV1RecruitingJobsJobIdDuplicatePostBody';

import type { EditJobContentRequest } from '../models/editJobContentRequest';

import type { ExportJobApiV1RecruitingJobsJobIdExportGetParams } from '../models/exportJobApiV1RecruitingJobsJobIdExportGetParams';

import type { ExtractFromLinkedInRequest } from '../models/extractFromLinkedInRequest';

import type { ExtractFromResumeRequest } from '../models/extractFromResumeRequest';

import type { GenerateJobContentRequest } from '../models/generateJobContentRequest';

import type { GenerateQuestionsRequest } from '../models/generateQuestionsRequest';

import type { GetCandidateApiV1RecruitingCandidatesCandidateIdGetParams } from '../models/getCandidateApiV1RecruitingCandidatesCandidateIdGetParams';

import type { GetCandidateFilterFacetsApiV1RecruitingCandidatesFilterFacetsGetParams } from '../models/getCandidateFilterFacetsApiV1RecruitingCandidatesFilterFacetsGetParams';

import type { GetDashboardStatsApiV1RecruitingReportsDashboardGetParams } from '../models/getDashboardStatsApiV1RecruitingReportsDashboardGetParams';

import type { GetInterviewsCalendarApiV1RecruitingInterviewsCalendarGetParams } from '../models/getInterviewsCalendarApiV1RecruitingInterviewsCalendarGetParams';

import type { GetJobAccessApiV1RecruitingJobsJobIdAccessGetParams } from '../models/getJobAccessApiV1RecruitingJobsJobIdAccessGetParams';

import type { GetJobApiV1RecruitingJobsJobIdGetParams } from '../models/getJobApiV1RecruitingJobsJobIdGetParams';

import type { GetPipelineFunnelApiV1RecruitingReportsPipelineFunnelGetParams } from '../models/getPipelineFunnelApiV1RecruitingReportsPipelineFunnelGetParams';

import type { GetSourceEffectivenessApiV1RecruitingReportsSourceEffectivenessGetParams } from '../models/getSourceEffectivenessApiV1RecruitingReportsSourceEffectivenessGetParams';

import type { GetTimeToHireApiV1RecruitingReportsTimeToHireGetParams } from '../models/getTimeToHireApiV1RecruitingReportsTimeToHireGetParams';

import type { GrantJobAccessApiV1RecruitingJobsJobIdAccessPostBody } from '../models/grantJobAccessApiV1RecruitingJobsJobIdAccessPostBody';

import type { HTTPValidationError } from '../models/hTTPValidationError';

import type { HireApplicationApiV1RecruitingApplicationsApplicationIdHirePostBody } from '../models/hireApplicationApiV1RecruitingApplicationsApplicationIdHirePostBody';

import type { InterviewCalendarResponse } from '../models/interviewCalendarResponse';

import type { InterviewCreateRequest } from '../models/interviewCreateRequest';

import type { InterviewUpdateRequest } from '../models/interviewUpdateRequest';

import type { ListAgentsApiV1RecruitingAgentsGetParams } from '../models/listAgentsApiV1RecruitingAgentsGetParams';

import type { ListAllInterviewsApiV1RecruitingInterviewsGetParams } from '../models/listAllInterviewsApiV1RecruitingInterviewsGetParams';

import type { ListApplicationsApiV1RecruitingApplicationsGetParams } from '../models/listApplicationsApiV1RecruitingApplicationsGetParams';

import type { ListApplicationsByCandidateApiV1RecruitingCandidatesCandidateIdApplicationsGetParams } from '../models/listApplicationsByCandidateApiV1RecruitingCandidatesCandidateIdApplicationsGetParams';

import type { ListApplicationsByJobApiV1RecruitingJobsJobIdApplicationsGetParams } from '../models/listApplicationsByJobApiV1RecruitingJobsJobIdApplicationsGetParams';

import type { ListCandidatesApiV1RecruitingCandidatesGetParams } from '../models/listCandidatesApiV1RecruitingCandidatesGetParams';

import type { ListJobsApiV1RecruitingJobsGetParams } from '../models/listJobsApiV1RecruitingJobsGetParams';

import type { ListOffersApiV1RecruitingOffersGetParams } from '../models/listOffersApiV1RecruitingOffersGetParams';

import type { ListUpcomingInterviewsApiV1RecruitingInterviewsUpcomingGetParams } from '../models/listUpcomingInterviewsApiV1RecruitingInterviewsUpcomingGetParams';

import type { MoveApplicationApiV1RecruitingApplicationsApplicationIdMovePostBody } from '../models/moveApplicationApiV1RecruitingApplicationsApplicationIdMovePostBody';

import type { RecruitingCandidateApplicationsResponse } from '../models/recruitingCandidateApplicationsResponse';

import type { RecruitingDashboard } from '../models/recruitingDashboard';

import type { RecruitingJobAgencyCompanyLinkCreate } from '../models/recruitingJobAgencyCompanyLinkCreate';

import type { RecruitingJobAgencyCompanyLinksResponse } from '../models/recruitingJobAgencyCompanyLinksResponse';

import type { RecruitingJobInterviewerStageLinkCreate } from '../models/recruitingJobInterviewerStageLinkCreate';

import type { RecruitingJobInterviewerStageLinksResponse } from '../models/recruitingJobInterviewerStageLinksResponse';

import type { RecruitingJobPostingCreate } from '../models/recruitingJobPostingCreate';

import type { RefineQuestionsRequest } from '../models/refineQuestionsRequest';

import type { RejectApplicationApiV1RecruitingApplicationsApplicationIdRejectPostBody } from '../models/rejectApplicationApiV1RecruitingApplicationsApplicationIdRejectPostBody';

import type { RespondToOfferApiV1RecruitingOffersOfferIdRespondPostParams } from '../models/respondToOfferApiV1RecruitingOffersOfferIdRespondPostParams';

import type { RevokeJobAccessApiV1RecruitingJobsJobIdAccessUserIdDeleteParams } from '../models/revokeJobAccessApiV1RecruitingJobsJobIdAccessUserIdDeleteParams';

import type { SelectSlotRequest } from '../models/selectSlotRequest';

import type { StageCreateRequest } from '../models/stageCreateRequest';

import type { StageUpdateRequest } from '../models/stageUpdateRequest';

import type { SubmitInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackPostBody } from '../models/submitInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackPostBody';

import type { UpdateCandidateApiV1RecruitingCandidatesCandidateIdPutBody } from '../models/updateCandidateApiV1RecruitingCandidatesCandidateIdPutBody';

import type { UpdateJobApiV1RecruitingJobsJobIdPutBody } from '../models/updateJobApiV1RecruitingJobsJobIdPutBody';

import type { UpdateJobStageQuestionsRequest } from '../models/updateJobStageQuestionsRequest';

import type { UpdateOfferRequest } from '../models/updateOfferRequest';

import type { UpdatePipelineApiV1RecruitingPipelinesPipelineIdPutBody } from '../models/updatePipelineApiV1RecruitingPipelinesPipelineIdPutBody';

import type { UpdateScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdPutBody } from '../models/updateScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdPutBody';

import { customInstance } from '../../../shared/api/axiosInstance';

/**
 * Generate job description, requirements, and benefits using AI.

Takes the job title and optional details to generate compelling job posting content.
Uses tenant context files and description for company-specific tailoring.
 * @summary Generate Job Content
 */
export const generateJobContentApiV1RecruitingJobsAiGenerateContentPost = (
  generateJobContentRequest: GenerateJobContentRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/jobs/ai/generate-content`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: generateJobContentRequest,
    signal
  });
};

export const getGenerateJobContentApiV1RecruitingJobsAiGenerateContentPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof generateJobContentApiV1RecruitingJobsAiGenerateContentPost
        >
      >,
      TError,
      { data: GenerateJobContentRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof generateJobContentApiV1RecruitingJobsAiGenerateContentPost
      >
    >,
    TError,
    { data: GenerateJobContentRequest },
    TContext
  > => {
    const mutationKey = [
      'generateJobContentApiV1RecruitingJobsAiGenerateContentPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof generateJobContentApiV1RecruitingJobsAiGenerateContentPost
        >
      >,
      { data: GenerateJobContentRequest }
    > = (props) => {
      const { data } = props ?? {};

      return generateJobContentApiV1RecruitingJobsAiGenerateContentPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type GenerateJobContentApiV1RecruitingJobsAiGenerateContentPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof generateJobContentApiV1RecruitingJobsAiGenerateContentPost
      >
    >
  >;
export type GenerateJobContentApiV1RecruitingJobsAiGenerateContentPostMutationBody =
  GenerateJobContentRequest;
export type GenerateJobContentApiV1RecruitingJobsAiGenerateContentPostMutationError =
  HTTPValidationError;

/**
 * @summary Generate Job Content
 */
export const useGenerateJobContentApiV1RecruitingJobsAiGenerateContentPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof generateJobContentApiV1RecruitingJobsAiGenerateContentPost
        >
      >,
      TError,
      { data: GenerateJobContentRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof generateJobContentApiV1RecruitingJobsAiGenerateContentPost
    >
  >,
  TError,
  { data: GenerateJobContentRequest },
  TContext
> => {
  const mutationOptions =
    getGenerateJobContentApiV1RecruitingJobsAiGenerateContentPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Stream-generate job content using SSE.
 * @summary Generate Job Content Stream
 */
export const generateJobContentStreamApiV1RecruitingJobsAiGenerateContentStreamPost =
  (
    generateJobContentRequest: GenerateJobContentRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/recruiting/jobs/ai/generate-content-stream`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: generateJobContentRequest,
      signal
    });
  };

export const getGenerateJobContentStreamApiV1RecruitingJobsAiGenerateContentStreamPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof generateJobContentStreamApiV1RecruitingJobsAiGenerateContentStreamPost
        >
      >,
      TError,
      { data: GenerateJobContentRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof generateJobContentStreamApiV1RecruitingJobsAiGenerateContentStreamPost
      >
    >,
    TError,
    { data: GenerateJobContentRequest },
    TContext
  > => {
    const mutationKey = [
      'generateJobContentStreamApiV1RecruitingJobsAiGenerateContentStreamPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof generateJobContentStreamApiV1RecruitingJobsAiGenerateContentStreamPost
        >
      >,
      { data: GenerateJobContentRequest }
    > = (props) => {
      const { data } = props ?? {};

      return generateJobContentStreamApiV1RecruitingJobsAiGenerateContentStreamPost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type GenerateJobContentStreamApiV1RecruitingJobsAiGenerateContentStreamPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof generateJobContentStreamApiV1RecruitingJobsAiGenerateContentStreamPost
      >
    >
  >;
export type GenerateJobContentStreamApiV1RecruitingJobsAiGenerateContentStreamPostMutationBody =
  GenerateJobContentRequest;
export type GenerateJobContentStreamApiV1RecruitingJobsAiGenerateContentStreamPostMutationError =
  HTTPValidationError;

/**
 * @summary Generate Job Content Stream
 */
export const useGenerateJobContentStreamApiV1RecruitingJobsAiGenerateContentStreamPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof generateJobContentStreamApiV1RecruitingJobsAiGenerateContentStreamPost
          >
        >,
        TError,
        { data: GenerateJobContentRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof generateJobContentStreamApiV1RecruitingJobsAiGenerateContentStreamPost
      >
    >,
    TError,
    { data: GenerateJobContentRequest },
    TContext
  > => {
    const mutationOptions =
      getGenerateJobContentStreamApiV1RecruitingJobsAiGenerateContentStreamPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Edit existing job content using AI.
 * @summary Edit Job Content
 */
export const editJobContentApiV1RecruitingJobsAiEditContentPost = (
  editJobContentRequest: EditJobContentRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/jobs/ai/edit-content`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: editJobContentRequest,
    signal
  });
};

export const getEditJobContentApiV1RecruitingJobsAiEditContentPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof editJobContentApiV1RecruitingJobsAiEditContentPost>
      >,
      TError,
      { data: EditJobContentRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof editJobContentApiV1RecruitingJobsAiEditContentPost>
    >,
    TError,
    { data: EditJobContentRequest },
    TContext
  > => {
    const mutationKey = ['editJobContentApiV1RecruitingJobsAiEditContentPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof editJobContentApiV1RecruitingJobsAiEditContentPost>
      >,
      { data: EditJobContentRequest }
    > = (props) => {
      const { data } = props ?? {};

      return editJobContentApiV1RecruitingJobsAiEditContentPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type EditJobContentApiV1RecruitingJobsAiEditContentPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof editJobContentApiV1RecruitingJobsAiEditContentPost>
    >
  >;
export type EditJobContentApiV1RecruitingJobsAiEditContentPostMutationBody =
  EditJobContentRequest;
export type EditJobContentApiV1RecruitingJobsAiEditContentPostMutationError =
  HTTPValidationError;

/**
 * @summary Edit Job Content
 */
export const useEditJobContentApiV1RecruitingJobsAiEditContentPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof editJobContentApiV1RecruitingJobsAiEditContentPost>
      >,
      TError,
      { data: EditJobContentRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof editJobContentApiV1RecruitingJobsAiEditContentPost>
  >,
  TError,
  { data: EditJobContentRequest },
  TContext
> => {
  const mutationOptions =
    getEditJobContentApiV1RecruitingJobsAiEditContentPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Stream AI editing of job content using SSE.
 * @summary Edit Job Content Stream
 */
export const editJobContentStreamApiV1RecruitingJobsAiEditContentStreamPost = (
  editJobContentRequest: EditJobContentRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/jobs/ai/edit-content-stream`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: editJobContentRequest,
    signal
  });
};

export const getEditJobContentStreamApiV1RecruitingJobsAiEditContentStreamPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof editJobContentStreamApiV1RecruitingJobsAiEditContentStreamPost
        >
      >,
      TError,
      { data: EditJobContentRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof editJobContentStreamApiV1RecruitingJobsAiEditContentStreamPost
      >
    >,
    TError,
    { data: EditJobContentRequest },
    TContext
  > => {
    const mutationKey = [
      'editJobContentStreamApiV1RecruitingJobsAiEditContentStreamPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof editJobContentStreamApiV1RecruitingJobsAiEditContentStreamPost
        >
      >,
      { data: EditJobContentRequest }
    > = (props) => {
      const { data } = props ?? {};

      return editJobContentStreamApiV1RecruitingJobsAiEditContentStreamPost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type EditJobContentStreamApiV1RecruitingJobsAiEditContentStreamPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof editJobContentStreamApiV1RecruitingJobsAiEditContentStreamPost
      >
    >
  >;
export type EditJobContentStreamApiV1RecruitingJobsAiEditContentStreamPostMutationBody =
  EditJobContentRequest;
export type EditJobContentStreamApiV1RecruitingJobsAiEditContentStreamPostMutationError =
  HTTPValidationError;

/**
 * @summary Edit Job Content Stream
 */
export const useEditJobContentStreamApiV1RecruitingJobsAiEditContentStreamPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof editJobContentStreamApiV1RecruitingJobsAiEditContentStreamPost
          >
        >,
        TError,
        { data: EditJobContentRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof editJobContentStreamApiV1RecruitingJobsAiEditContentStreamPost
      >
    >,
    TError,
    { data: EditJobContentRequest },
    TContext
  > => {
    const mutationOptions =
      getEditJobContentStreamApiV1RecruitingJobsAiEditContentStreamPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Extract candidate information from an uploaded resume file.

Takes a file_id of an already-uploaded resume and uses AI to extract
candidate fields (name, email, phone, experience, etc.).
 * @summary Extract Candidate From Resume
 */
export const extractCandidateFromResumeApiV1RecruitingCandidatesAiExtractFromResumePost =
  (
    extractFromResumeRequest: ExtractFromResumeRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/recruiting/candidates/ai/extract-from-resume`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: extractFromResumeRequest,
      signal
    });
  };

export const getExtractCandidateFromResumeApiV1RecruitingCandidatesAiExtractFromResumePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof extractCandidateFromResumeApiV1RecruitingCandidatesAiExtractFromResumePost
        >
      >,
      TError,
      { data: ExtractFromResumeRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof extractCandidateFromResumeApiV1RecruitingCandidatesAiExtractFromResumePost
      >
    >,
    TError,
    { data: ExtractFromResumeRequest },
    TContext
  > => {
    const mutationKey = [
      'extractCandidateFromResumeApiV1RecruitingCandidatesAiExtractFromResumePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof extractCandidateFromResumeApiV1RecruitingCandidatesAiExtractFromResumePost
        >
      >,
      { data: ExtractFromResumeRequest }
    > = (props) => {
      const { data } = props ?? {};

      return extractCandidateFromResumeApiV1RecruitingCandidatesAiExtractFromResumePost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ExtractCandidateFromResumeApiV1RecruitingCandidatesAiExtractFromResumePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof extractCandidateFromResumeApiV1RecruitingCandidatesAiExtractFromResumePost
      >
    >
  >;
export type ExtractCandidateFromResumeApiV1RecruitingCandidatesAiExtractFromResumePostMutationBody =
  ExtractFromResumeRequest;
export type ExtractCandidateFromResumeApiV1RecruitingCandidatesAiExtractFromResumePostMutationError =
  HTTPValidationError;

/**
 * @summary Extract Candidate From Resume
 */
export const useExtractCandidateFromResumeApiV1RecruitingCandidatesAiExtractFromResumePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof extractCandidateFromResumeApiV1RecruitingCandidatesAiExtractFromResumePost
          >
        >,
        TError,
        { data: ExtractFromResumeRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof extractCandidateFromResumeApiV1RecruitingCandidatesAiExtractFromResumePost
      >
    >,
    TError,
    { data: ExtractFromResumeRequest },
    TContext
  > => {
    const mutationOptions =
      getExtractCandidateFromResumeApiV1RecruitingCandidatesAiExtractFromResumePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Extract candidate information from a LinkedIn profile URL.

Reads the profile through the structured provider seam when one is configured
and falls back to Google search-result snippets + AI extraction when it is
not, then extracts candidate fields (name, title, company, location, etc.).

The in-flight cap bounds PARALLEL fan-out: every tier of this endpoint makes
outbound calls and holds a request-pool connection for their duration, so one
tenant firing many at once is the 2026-06-20 pool-exhaustion shape. It does
NOT bound sequential looping, and the paid tier's cash cost is bounded
separately — `modules/recruiting/services/profile_lookup_metering` says which
control answers which abuse.
 * @summary Extract Candidate From Linkedin
 */
export const extractCandidateFromLinkedinApiV1RecruitingCandidatesAiExtractFromLinkedinPost =
  (
    extractFromLinkedInRequest: ExtractFromLinkedInRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/recruiting/candidates/ai/extract-from-linkedin`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: extractFromLinkedInRequest,
      signal
    });
  };

export const getExtractCandidateFromLinkedinApiV1RecruitingCandidatesAiExtractFromLinkedinPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof extractCandidateFromLinkedinApiV1RecruitingCandidatesAiExtractFromLinkedinPost
        >
      >,
      TError,
      { data: ExtractFromLinkedInRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof extractCandidateFromLinkedinApiV1RecruitingCandidatesAiExtractFromLinkedinPost
      >
    >,
    TError,
    { data: ExtractFromLinkedInRequest },
    TContext
  > => {
    const mutationKey = [
      'extractCandidateFromLinkedinApiV1RecruitingCandidatesAiExtractFromLinkedinPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof extractCandidateFromLinkedinApiV1RecruitingCandidatesAiExtractFromLinkedinPost
        >
      >,
      { data: ExtractFromLinkedInRequest }
    > = (props) => {
      const { data } = props ?? {};

      return extractCandidateFromLinkedinApiV1RecruitingCandidatesAiExtractFromLinkedinPost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ExtractCandidateFromLinkedinApiV1RecruitingCandidatesAiExtractFromLinkedinPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof extractCandidateFromLinkedinApiV1RecruitingCandidatesAiExtractFromLinkedinPost
      >
    >
  >;
export type ExtractCandidateFromLinkedinApiV1RecruitingCandidatesAiExtractFromLinkedinPostMutationBody =
  ExtractFromLinkedInRequest;
export type ExtractCandidateFromLinkedinApiV1RecruitingCandidatesAiExtractFromLinkedinPostMutationError =
  HTTPValidationError;

/**
 * @summary Extract Candidate From Linkedin
 */
export const useExtractCandidateFromLinkedinApiV1RecruitingCandidatesAiExtractFromLinkedinPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof extractCandidateFromLinkedinApiV1RecruitingCandidatesAiExtractFromLinkedinPost
          >
        >,
        TError,
        { data: ExtractFromLinkedInRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof extractCandidateFromLinkedinApiV1RecruitingCandidatesAiExtractFromLinkedinPost
      >
    >,
    TError,
    { data: ExtractFromLinkedInRequest },
    TContext
  > => {
    const mutationOptions =
      getExtractCandidateFromLinkedinApiV1RecruitingCandidatesAiExtractFromLinkedinPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List all hiring pipelines.
 * @summary List Pipelines
 */
export const listPipelinesApiV1RecruitingPipelinesGet = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/pipelines`,
    method: 'GET',
    signal
  });
};

export const getListPipelinesApiV1RecruitingPipelinesGetQueryKey = () => {
  return [`/api/v1/recruiting/pipelines`] as const;
};

export const getListPipelinesApiV1RecruitingPipelinesGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listPipelinesApiV1RecruitingPipelinesGet>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listPipelinesApiV1RecruitingPipelinesGet>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListPipelinesApiV1RecruitingPipelinesGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPipelinesApiV1RecruitingPipelinesGet>>
  > = ({ signal }) => listPipelinesApiV1RecruitingPipelinesGet(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPipelinesApiV1RecruitingPipelinesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListPipelinesApiV1RecruitingPipelinesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPipelinesApiV1RecruitingPipelinesGet>>
>;
export type ListPipelinesApiV1RecruitingPipelinesGetQueryError = unknown;

export function useListPipelinesApiV1RecruitingPipelinesGet<
  TData = Awaited<ReturnType<typeof listPipelinesApiV1RecruitingPipelinesGet>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listPipelinesApiV1RecruitingPipelinesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPipelinesApiV1RecruitingPipelinesGet>>,
          TError,
          Awaited<ReturnType<typeof listPipelinesApiV1RecruitingPipelinesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListPipelinesApiV1RecruitingPipelinesGet<
  TData = Awaited<ReturnType<typeof listPipelinesApiV1RecruitingPipelinesGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listPipelinesApiV1RecruitingPipelinesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPipelinesApiV1RecruitingPipelinesGet>>,
          TError,
          Awaited<ReturnType<typeof listPipelinesApiV1RecruitingPipelinesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListPipelinesApiV1RecruitingPipelinesGet<
  TData = Awaited<ReturnType<typeof listPipelinesApiV1RecruitingPipelinesGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listPipelinesApiV1RecruitingPipelinesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Pipelines
 */

export function useListPipelinesApiV1RecruitingPipelinesGet<
  TData = Awaited<ReturnType<typeof listPipelinesApiV1RecruitingPipelinesGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listPipelinesApiV1RecruitingPipelinesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListPipelinesApiV1RecruitingPipelinesGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new hiring pipeline.
 * @summary Create Pipeline
 */
export const createPipelineApiV1RecruitingPipelinesPost = (
  createPipelineApiV1RecruitingPipelinesPostBody: CreatePipelineApiV1RecruitingPipelinesPostBody,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/pipelines`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createPipelineApiV1RecruitingPipelinesPostBody,
    signal
  });
};

export const getCreatePipelineApiV1RecruitingPipelinesPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPipelineApiV1RecruitingPipelinesPost>>,
    TError,
    { data: CreatePipelineApiV1RecruitingPipelinesPostBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPipelineApiV1RecruitingPipelinesPost>>,
  TError,
  { data: CreatePipelineApiV1RecruitingPipelinesPostBody },
  TContext
> => {
  const mutationKey = ['createPipelineApiV1RecruitingPipelinesPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPipelineApiV1RecruitingPipelinesPost>>,
    { data: CreatePipelineApiV1RecruitingPipelinesPostBody }
  > = (props) => {
    const { data } = props ?? {};

    return createPipelineApiV1RecruitingPipelinesPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePipelineApiV1RecruitingPipelinesPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createPipelineApiV1RecruitingPipelinesPost>>
  >;
export type CreatePipelineApiV1RecruitingPipelinesPostMutationBody =
  CreatePipelineApiV1RecruitingPipelinesPostBody;
export type CreatePipelineApiV1RecruitingPipelinesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Pipeline
 */
export const useCreatePipelineApiV1RecruitingPipelinesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createPipelineApiV1RecruitingPipelinesPost>>,
      TError,
      { data: CreatePipelineApiV1RecruitingPipelinesPostBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createPipelineApiV1RecruitingPipelinesPost>>,
  TError,
  { data: CreatePipelineApiV1RecruitingPipelinesPostBody },
  TContext
> => {
  const mutationOptions =
    getCreatePipelineApiV1RecruitingPipelinesPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get a pipeline by ID.
 * @summary Get Pipeline
 */
export const getPipelineApiV1RecruitingPipelinesPipelineIdGet = (
  pipelineId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/pipelines/${pipelineId}`,
    method: 'GET',
    signal
  });
};

export const getGetPipelineApiV1RecruitingPipelinesPipelineIdGetQueryKey = (
  pipelineId?: string
) => {
  return [`/api/v1/recruiting/pipelines/${pipelineId}`] as const;
};

export const getGetPipelineApiV1RecruitingPipelinesPipelineIdGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getPipelineApiV1RecruitingPipelinesPipelineIdGet>
  >,
  TError = HTTPValidationError
>(
  pipelineId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getPipelineApiV1RecruitingPipelinesPipelineIdGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetPipelineApiV1RecruitingPipelinesPipelineIdGetQueryKey(pipelineId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPipelineApiV1RecruitingPipelinesPipelineIdGet>>
  > = ({ signal }) =>
    getPipelineApiV1RecruitingPipelinesPipelineIdGet(pipelineId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!pipelineId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<
      ReturnType<typeof getPipelineApiV1RecruitingPipelinesPipelineIdGet>
    >,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetPipelineApiV1RecruitingPipelinesPipelineIdGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getPipelineApiV1RecruitingPipelinesPipelineIdGet>>
  >;
export type GetPipelineApiV1RecruitingPipelinesPipelineIdGetQueryError =
  HTTPValidationError;

export function useGetPipelineApiV1RecruitingPipelinesPipelineIdGet<
  TData = Awaited<
    ReturnType<typeof getPipelineApiV1RecruitingPipelinesPipelineIdGet>
  >,
  TError = HTTPValidationError
>(
  pipelineId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getPipelineApiV1RecruitingPipelinesPipelineIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getPipelineApiV1RecruitingPipelinesPipelineIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getPipelineApiV1RecruitingPipelinesPipelineIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetPipelineApiV1RecruitingPipelinesPipelineIdGet<
  TData = Awaited<
    ReturnType<typeof getPipelineApiV1RecruitingPipelinesPipelineIdGet>
  >,
  TError = HTTPValidationError
>(
  pipelineId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getPipelineApiV1RecruitingPipelinesPipelineIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getPipelineApiV1RecruitingPipelinesPipelineIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getPipelineApiV1RecruitingPipelinesPipelineIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetPipelineApiV1RecruitingPipelinesPipelineIdGet<
  TData = Awaited<
    ReturnType<typeof getPipelineApiV1RecruitingPipelinesPipelineIdGet>
  >,
  TError = HTTPValidationError
>(
  pipelineId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getPipelineApiV1RecruitingPipelinesPipelineIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Pipeline
 */

export function useGetPipelineApiV1RecruitingPipelinesPipelineIdGet<
  TData = Awaited<
    ReturnType<typeof getPipelineApiV1RecruitingPipelinesPipelineIdGet>
  >,
  TError = HTTPValidationError
>(
  pipelineId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getPipelineApiV1RecruitingPipelinesPipelineIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetPipelineApiV1RecruitingPipelinesPipelineIdGetQueryOptions(
      pipelineId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a pipeline.
 * @summary Update Pipeline
 */
export const updatePipelineApiV1RecruitingPipelinesPipelineIdPut = (
  pipelineId: string,
  updatePipelineApiV1RecruitingPipelinesPipelineIdPutBody: UpdatePipelineApiV1RecruitingPipelinesPipelineIdPutBody
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/pipelines/${pipelineId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updatePipelineApiV1RecruitingPipelinesPipelineIdPutBody
  });
};

export const getUpdatePipelineApiV1RecruitingPipelinesPipelineIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updatePipelineApiV1RecruitingPipelinesPipelineIdPut>
      >,
      TError,
      {
        pipelineId: string;
        data: UpdatePipelineApiV1RecruitingPipelinesPipelineIdPutBody;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updatePipelineApiV1RecruitingPipelinesPipelineIdPut>
    >,
    TError,
    {
      pipelineId: string;
      data: UpdatePipelineApiV1RecruitingPipelinesPipelineIdPutBody;
    },
    TContext
  > => {
    const mutationKey = ['updatePipelineApiV1RecruitingPipelinesPipelineIdPut'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updatePipelineApiV1RecruitingPipelinesPipelineIdPut>
      >,
      {
        pipelineId: string;
        data: UpdatePipelineApiV1RecruitingPipelinesPipelineIdPutBody;
      }
    > = (props) => {
      const { pipelineId, data } = props ?? {};

      return updatePipelineApiV1RecruitingPipelinesPipelineIdPut(
        pipelineId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdatePipelineApiV1RecruitingPipelinesPipelineIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updatePipelineApiV1RecruitingPipelinesPipelineIdPut>
    >
  >;
export type UpdatePipelineApiV1RecruitingPipelinesPipelineIdPutMutationBody =
  UpdatePipelineApiV1RecruitingPipelinesPipelineIdPutBody;
export type UpdatePipelineApiV1RecruitingPipelinesPipelineIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Pipeline
 */
export const useUpdatePipelineApiV1RecruitingPipelinesPipelineIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updatePipelineApiV1RecruitingPipelinesPipelineIdPut>
      >,
      TError,
      {
        pipelineId: string;
        data: UpdatePipelineApiV1RecruitingPipelinesPipelineIdPutBody;
      },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updatePipelineApiV1RecruitingPipelinesPipelineIdPut>
  >,
  TError,
  {
    pipelineId: string;
    data: UpdatePipelineApiV1RecruitingPipelinesPipelineIdPutBody;
  },
  TContext
> => {
  const mutationOptions =
    getUpdatePipelineApiV1RecruitingPipelinesPipelineIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a pipeline.
 * @summary Delete Pipeline
 */
export const deletePipelineApiV1RecruitingPipelinesPipelineIdDelete = (
  pipelineId: string
) => {
  return customInstance<void>({
    url: `/api/v1/recruiting/pipelines/${pipelineId}`,
    method: 'DELETE'
  });
};

export const getDeletePipelineApiV1RecruitingPipelinesPipelineIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deletePipelineApiV1RecruitingPipelinesPipelineIdDelete
        >
      >,
      TError,
      { pipelineId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof deletePipelineApiV1RecruitingPipelinesPipelineIdDelete>
    >,
    TError,
    { pipelineId: string },
    TContext
  > => {
    const mutationKey = [
      'deletePipelineApiV1RecruitingPipelinesPipelineIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deletePipelineApiV1RecruitingPipelinesPipelineIdDelete
        >
      >,
      { pipelineId: string }
    > = (props) => {
      const { pipelineId } = props ?? {};

      return deletePipelineApiV1RecruitingPipelinesPipelineIdDelete(pipelineId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeletePipelineApiV1RecruitingPipelinesPipelineIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof deletePipelineApiV1RecruitingPipelinesPipelineIdDelete>
    >
  >;

export type DeletePipelineApiV1RecruitingPipelinesPipelineIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Pipeline
 */
export const useDeletePipelineApiV1RecruitingPipelinesPipelineIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deletePipelineApiV1RecruitingPipelinesPipelineIdDelete
        >
      >,
      TError,
      { pipelineId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof deletePipelineApiV1RecruitingPipelinesPipelineIdDelete>
  >,
  TError,
  { pipelineId: string },
  TContext
> => {
  const mutationOptions =
    getDeletePipelineApiV1RecruitingPipelinesPipelineIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Create a default hiring pipeline with standard stages.
 * @summary Create Default Pipeline
 */
export const createDefaultPipelineApiV1RecruitingPipelinesDefaultPost = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/pipelines/default`,
    method: 'POST',
    signal
  });
};

export const getCreateDefaultPipelineApiV1RecruitingPipelinesDefaultPostMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createDefaultPipelineApiV1RecruitingPipelinesDefaultPost
        >
      >,
      TError,
      void,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createDefaultPipelineApiV1RecruitingPipelinesDefaultPost
      >
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = [
      'createDefaultPipelineApiV1RecruitingPipelinesDefaultPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createDefaultPipelineApiV1RecruitingPipelinesDefaultPost
        >
      >,
      void
    > = () => {
      return createDefaultPipelineApiV1RecruitingPipelinesDefaultPost();
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateDefaultPipelineApiV1RecruitingPipelinesDefaultPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createDefaultPipelineApiV1RecruitingPipelinesDefaultPost
      >
    >
  >;

export type CreateDefaultPipelineApiV1RecruitingPipelinesDefaultPostMutationError =
  unknown;

/**
 * @summary Create Default Pipeline
 */
export const useCreateDefaultPipelineApiV1RecruitingPipelinesDefaultPost = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createDefaultPipelineApiV1RecruitingPipelinesDefaultPost
        >
      >,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof createDefaultPipelineApiV1RecruitingPipelinesDefaultPost>
  >,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getCreateDefaultPipelineApiV1RecruitingPipelinesDefaultPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * List stages for a pipeline.
 * @summary List Stages
 */
export const listStagesApiV1RecruitingPipelinesPipelineIdStagesGet = (
  pipelineId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/pipelines/${pipelineId}/stages`,
    method: 'GET',
    signal
  });
};

export const getListStagesApiV1RecruitingPipelinesPipelineIdStagesGetQueryKey =
  (pipelineId?: string) => {
    return [`/api/v1/recruiting/pipelines/${pipelineId}/stages`] as const;
  };

export const getListStagesApiV1RecruitingPipelinesPipelineIdStagesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listStagesApiV1RecruitingPipelinesPipelineIdStagesGet>
    >,
    TError = HTTPValidationError
  >(
    pipelineId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listStagesApiV1RecruitingPipelinesPipelineIdStagesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListStagesApiV1RecruitingPipelinesPipelineIdStagesGetQueryKey(
        pipelineId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listStagesApiV1RecruitingPipelinesPipelineIdStagesGet>
      >
    > = ({ signal }) =>
      listStagesApiV1RecruitingPipelinesPipelineIdStagesGet(pipelineId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!pipelineId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listStagesApiV1RecruitingPipelinesPipelineIdStagesGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListStagesApiV1RecruitingPipelinesPipelineIdStagesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listStagesApiV1RecruitingPipelinesPipelineIdStagesGet>
    >
  >;
export type ListStagesApiV1RecruitingPipelinesPipelineIdStagesGetQueryError =
  HTTPValidationError;

export function useListStagesApiV1RecruitingPipelinesPipelineIdStagesGet<
  TData = Awaited<
    ReturnType<typeof listStagesApiV1RecruitingPipelinesPipelineIdStagesGet>
  >,
  TError = HTTPValidationError
>(
  pipelineId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listStagesApiV1RecruitingPipelinesPipelineIdStagesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listStagesApiV1RecruitingPipelinesPipelineIdStagesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listStagesApiV1RecruitingPipelinesPipelineIdStagesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListStagesApiV1RecruitingPipelinesPipelineIdStagesGet<
  TData = Awaited<
    ReturnType<typeof listStagesApiV1RecruitingPipelinesPipelineIdStagesGet>
  >,
  TError = HTTPValidationError
>(
  pipelineId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listStagesApiV1RecruitingPipelinesPipelineIdStagesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listStagesApiV1RecruitingPipelinesPipelineIdStagesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listStagesApiV1RecruitingPipelinesPipelineIdStagesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListStagesApiV1RecruitingPipelinesPipelineIdStagesGet<
  TData = Awaited<
    ReturnType<typeof listStagesApiV1RecruitingPipelinesPipelineIdStagesGet>
  >,
  TError = HTTPValidationError
>(
  pipelineId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listStagesApiV1RecruitingPipelinesPipelineIdStagesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Stages
 */

export function useListStagesApiV1RecruitingPipelinesPipelineIdStagesGet<
  TData = Awaited<
    ReturnType<typeof listStagesApiV1RecruitingPipelinesPipelineIdStagesGet>
  >,
  TError = HTTPValidationError
>(
  pipelineId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listStagesApiV1RecruitingPipelinesPipelineIdStagesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListStagesApiV1RecruitingPipelinesPipelineIdStagesGetQueryOptions(
      pipelineId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new stage in a pipeline.
 * @summary Create Stage
 */
export const createStageApiV1RecruitingPipelinesPipelineIdStagesPost = (
  pipelineId: string,
  stageCreateRequest: StageCreateRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/pipelines/${pipelineId}/stages`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: stageCreateRequest,
    signal
  });
};

export const getCreateStageApiV1RecruitingPipelinesPipelineIdStagesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createStageApiV1RecruitingPipelinesPipelineIdStagesPost
        >
      >,
      TError,
      { pipelineId: string; data: StageCreateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createStageApiV1RecruitingPipelinesPipelineIdStagesPost>
    >,
    TError,
    { pipelineId: string; data: StageCreateRequest },
    TContext
  > => {
    const mutationKey = [
      'createStageApiV1RecruitingPipelinesPipelineIdStagesPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createStageApiV1RecruitingPipelinesPipelineIdStagesPost
        >
      >,
      { pipelineId: string; data: StageCreateRequest }
    > = (props) => {
      const { pipelineId, data } = props ?? {};

      return createStageApiV1RecruitingPipelinesPipelineIdStagesPost(
        pipelineId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateStageApiV1RecruitingPipelinesPipelineIdStagesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof createStageApiV1RecruitingPipelinesPipelineIdStagesPost>
    >
  >;
export type CreateStageApiV1RecruitingPipelinesPipelineIdStagesPostMutationBody =
  StageCreateRequest;
export type CreateStageApiV1RecruitingPipelinesPipelineIdStagesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Stage
 */
export const useCreateStageApiV1RecruitingPipelinesPipelineIdStagesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createStageApiV1RecruitingPipelinesPipelineIdStagesPost
        >
      >,
      TError,
      { pipelineId: string; data: StageCreateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof createStageApiV1RecruitingPipelinesPipelineIdStagesPost>
  >,
  TError,
  { pipelineId: string; data: StageCreateRequest },
  TContext
> => {
  const mutationOptions =
    getCreateStageApiV1RecruitingPipelinesPipelineIdStagesPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Update a stage.
 * @summary Update Stage
 */
export const updateStageApiV1RecruitingStagesStageIdPut = (
  stageId: string,
  stageUpdateRequest: StageUpdateRequest
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/stages/${stageId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: stageUpdateRequest
  });
};

export const getUpdateStageApiV1RecruitingStagesStageIdPutMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStageApiV1RecruitingStagesStageIdPut>>,
    TError,
    { stageId: string; data: StageUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateStageApiV1RecruitingStagesStageIdPut>>,
  TError,
  { stageId: string; data: StageUpdateRequest },
  TContext
> => {
  const mutationKey = ['updateStageApiV1RecruitingStagesStageIdPut'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateStageApiV1RecruitingStagesStageIdPut>>,
    { stageId: string; data: StageUpdateRequest }
  > = (props) => {
    const { stageId, data } = props ?? {};

    return updateStageApiV1RecruitingStagesStageIdPut(stageId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateStageApiV1RecruitingStagesStageIdPutMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateStageApiV1RecruitingStagesStageIdPut>>
  >;
export type UpdateStageApiV1RecruitingStagesStageIdPutMutationBody =
  StageUpdateRequest;
export type UpdateStageApiV1RecruitingStagesStageIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Stage
 */
export const useUpdateStageApiV1RecruitingStagesStageIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateStageApiV1RecruitingStagesStageIdPut>>,
      TError,
      { stageId: string; data: StageUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateStageApiV1RecruitingStagesStageIdPut>>,
  TError,
  { stageId: string; data: StageUpdateRequest },
  TContext
> => {
  const mutationOptions =
    getUpdateStageApiV1RecruitingStagesStageIdPutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a stage.
 * @summary Delete Stage
 */
export const deleteStageApiV1RecruitingStagesStageIdDelete = (
  stageId: string
) => {
  return customInstance<void>({
    url: `/api/v1/recruiting/stages/${stageId}`,
    method: 'DELETE'
  });
};

export const getDeleteStageApiV1RecruitingStagesStageIdDeleteMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteStageApiV1RecruitingStagesStageIdDelete>>,
    TError,
    { stageId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteStageApiV1RecruitingStagesStageIdDelete>>,
  TError,
  { stageId: string },
  TContext
> => {
  const mutationKey = ['deleteStageApiV1RecruitingStagesStageIdDelete'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteStageApiV1RecruitingStagesStageIdDelete>>,
    { stageId: string }
  > = (props) => {
    const { stageId } = props ?? {};

    return deleteStageApiV1RecruitingStagesStageIdDelete(stageId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteStageApiV1RecruitingStagesStageIdDeleteMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof deleteStageApiV1RecruitingStagesStageIdDelete>>
  >;

export type DeleteStageApiV1RecruitingStagesStageIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Stage
 */
export const useDeleteStageApiV1RecruitingStagesStageIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteStageApiV1RecruitingStagesStageIdDelete>>,
      TError,
      { stageId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteStageApiV1RecruitingStagesStageIdDelete>>,
  TError,
  { stageId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteStageApiV1RecruitingStagesStageIdDeleteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * List all departments.
 * @summary List Departments
 */
export const listDepartmentsApiV1RecruitingDepartmentsGet = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/departments`,
    method: 'GET',
    signal
  });
};

export const getListDepartmentsApiV1RecruitingDepartmentsGetQueryKey = () => {
  return [`/api/v1/recruiting/departments`] as const;
};

export const getListDepartmentsApiV1RecruitingDepartmentsGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listDepartmentsApiV1RecruitingDepartmentsGet>
  >,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listDepartmentsApiV1RecruitingDepartmentsGet>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListDepartmentsApiV1RecruitingDepartmentsGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listDepartmentsApiV1RecruitingDepartmentsGet>>
  > = ({ signal }) => listDepartmentsApiV1RecruitingDepartmentsGet(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listDepartmentsApiV1RecruitingDepartmentsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListDepartmentsApiV1RecruitingDepartmentsGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listDepartmentsApiV1RecruitingDepartmentsGet>>
  >;
export type ListDepartmentsApiV1RecruitingDepartmentsGetQueryError = unknown;

export function useListDepartmentsApiV1RecruitingDepartmentsGet<
  TData = Awaited<
    ReturnType<typeof listDepartmentsApiV1RecruitingDepartmentsGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listDepartmentsApiV1RecruitingDepartmentsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listDepartmentsApiV1RecruitingDepartmentsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listDepartmentsApiV1RecruitingDepartmentsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListDepartmentsApiV1RecruitingDepartmentsGet<
  TData = Awaited<
    ReturnType<typeof listDepartmentsApiV1RecruitingDepartmentsGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listDepartmentsApiV1RecruitingDepartmentsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listDepartmentsApiV1RecruitingDepartmentsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listDepartmentsApiV1RecruitingDepartmentsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListDepartmentsApiV1RecruitingDepartmentsGet<
  TData = Awaited<
    ReturnType<typeof listDepartmentsApiV1RecruitingDepartmentsGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listDepartmentsApiV1RecruitingDepartmentsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Departments
 */

export function useListDepartmentsApiV1RecruitingDepartmentsGet<
  TData = Awaited<
    ReturnType<typeof listDepartmentsApiV1RecruitingDepartmentsGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listDepartmentsApiV1RecruitingDepartmentsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListDepartmentsApiV1RecruitingDepartmentsGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new department.
 * @summary Create Department
 */
export const createDepartmentApiV1RecruitingDepartmentsPost = (
  createDepartmentApiV1RecruitingDepartmentsPostBody: CreateDepartmentApiV1RecruitingDepartmentsPostBody,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/departments`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createDepartmentApiV1RecruitingDepartmentsPostBody,
    signal
  });
};

export const getCreateDepartmentApiV1RecruitingDepartmentsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createDepartmentApiV1RecruitingDepartmentsPost>
      >,
      TError,
      { data: CreateDepartmentApiV1RecruitingDepartmentsPostBody },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof createDepartmentApiV1RecruitingDepartmentsPost>>,
    TError,
    { data: CreateDepartmentApiV1RecruitingDepartmentsPostBody },
    TContext
  > => {
    const mutationKey = ['createDepartmentApiV1RecruitingDepartmentsPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createDepartmentApiV1RecruitingDepartmentsPost>
      >,
      { data: CreateDepartmentApiV1RecruitingDepartmentsPostBody }
    > = (props) => {
      const { data } = props ?? {};

      return createDepartmentApiV1RecruitingDepartmentsPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateDepartmentApiV1RecruitingDepartmentsPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createDepartmentApiV1RecruitingDepartmentsPost>>
  >;
export type CreateDepartmentApiV1RecruitingDepartmentsPostMutationBody =
  CreateDepartmentApiV1RecruitingDepartmentsPostBody;
export type CreateDepartmentApiV1RecruitingDepartmentsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Department
 */
export const useCreateDepartmentApiV1RecruitingDepartmentsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createDepartmentApiV1RecruitingDepartmentsPost>
      >,
      TError,
      { data: CreateDepartmentApiV1RecruitingDepartmentsPostBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createDepartmentApiV1RecruitingDepartmentsPost>>,
  TError,
  { data: CreateDepartmentApiV1RecruitingDepartmentsPostBody },
  TContext
> => {
  const mutationOptions =
    getCreateDepartmentApiV1RecruitingDepartmentsPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * List job postings with optional filtering.

Private jobs are only visible to users with access.

Jobs accumulate (Shape A), so the page window AND the sort resolve here; the
caller only ever holds one page.
 * @summary List Jobs
 */
export const listJobsApiV1RecruitingJobsGet = (
  params?: ListJobsApiV1RecruitingJobsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/jobs`,
    method: 'GET',
    params,
    signal
  });
};

export const getListJobsApiV1RecruitingJobsGetQueryKey = (
  params?: ListJobsApiV1RecruitingJobsGetParams
) => {
  return [`/api/v1/recruiting/jobs`, ...(params ? [params] : [])] as const;
};

export const getListJobsApiV1RecruitingJobsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listJobsApiV1RecruitingJobsGet>>,
  TError = HTTPValidationError
>(
  params?: ListJobsApiV1RecruitingJobsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listJobsApiV1RecruitingJobsGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListJobsApiV1RecruitingJobsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listJobsApiV1RecruitingJobsGet>>
  > = ({ signal }) => listJobsApiV1RecruitingJobsGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listJobsApiV1RecruitingJobsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListJobsApiV1RecruitingJobsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listJobsApiV1RecruitingJobsGet>>
>;
export type ListJobsApiV1RecruitingJobsGetQueryError = HTTPValidationError;

export function useListJobsApiV1RecruitingJobsGet<
  TData = Awaited<ReturnType<typeof listJobsApiV1RecruitingJobsGet>>,
  TError = HTTPValidationError
>(
  params: undefined | ListJobsApiV1RecruitingJobsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listJobsApiV1RecruitingJobsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listJobsApiV1RecruitingJobsGet>>,
          TError,
          Awaited<ReturnType<typeof listJobsApiV1RecruitingJobsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListJobsApiV1RecruitingJobsGet<
  TData = Awaited<ReturnType<typeof listJobsApiV1RecruitingJobsGet>>,
  TError = HTTPValidationError
>(
  params?: ListJobsApiV1RecruitingJobsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listJobsApiV1RecruitingJobsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listJobsApiV1RecruitingJobsGet>>,
          TError,
          Awaited<ReturnType<typeof listJobsApiV1RecruitingJobsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListJobsApiV1RecruitingJobsGet<
  TData = Awaited<ReturnType<typeof listJobsApiV1RecruitingJobsGet>>,
  TError = HTTPValidationError
>(
  params?: ListJobsApiV1RecruitingJobsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listJobsApiV1RecruitingJobsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Jobs
 */

export function useListJobsApiV1RecruitingJobsGet<
  TData = Awaited<ReturnType<typeof listJobsApiV1RecruitingJobsGet>>,
  TError = HTTPValidationError
>(
  params?: ListJobsApiV1RecruitingJobsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listJobsApiV1RecruitingJobsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListJobsApiV1RecruitingJobsGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new job posting.

Audience levels (the `JobAudience` enum; stored in the `visibility` column):
- 'public': Visible on public career page
- 'employees': Visible to all authenticated employees (default)
- 'private': Only visible to hiring team and users in job_access_user_ids

Access lists:
- job_access_user_ids: Who can see private jobs (in addition to hiring team)
- candidate_access_user_ids: Who can see candidates/interviews (in addition to hiring team)
 * @summary Create Job
 */
export const createJobApiV1RecruitingJobsPost = (
  recruitingJobPostingCreate: RecruitingJobPostingCreate,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/jobs`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: recruitingJobPostingCreate,
    signal
  });
};

export const getCreateJobApiV1RecruitingJobsPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createJobApiV1RecruitingJobsPost>>,
    TError,
    { data: RecruitingJobPostingCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createJobApiV1RecruitingJobsPost>>,
  TError,
  { data: RecruitingJobPostingCreate },
  TContext
> => {
  const mutationKey = ['createJobApiV1RecruitingJobsPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createJobApiV1RecruitingJobsPost>>,
    { data: RecruitingJobPostingCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createJobApiV1RecruitingJobsPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateJobApiV1RecruitingJobsPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createJobApiV1RecruitingJobsPost>>
>;
export type CreateJobApiV1RecruitingJobsPostMutationBody =
  RecruitingJobPostingCreate;
export type CreateJobApiV1RecruitingJobsPostMutationError = HTTPValidationError;

/**
 * @summary Create Job
 */
export const useCreateJobApiV1RecruitingJobsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createJobApiV1RecruitingJobsPost>>,
      TError,
      { data: RecruitingJobPostingCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createJobApiV1RecruitingJobsPost>>,
  TError,
  { data: RecruitingJobPostingCreate },
  TContext
> => {
  const mutationOptions =
    getCreateJobApiV1RecruitingJobsPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get a job posting by ID.

Returns 404 if the job doesn't exist or user doesn't have access to a private job.
 * @summary Get Job
 */
export const getJobApiV1RecruitingJobsJobIdGet = (
  jobId: string,
  params?: GetJobApiV1RecruitingJobsJobIdGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/jobs/${jobId}`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetJobApiV1RecruitingJobsJobIdGetQueryKey = (
  jobId?: string,
  params?: GetJobApiV1RecruitingJobsJobIdGetParams
) => {
  return [
    `/api/v1/recruiting/jobs/${jobId}`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetJobApiV1RecruitingJobsJobIdGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobApiV1RecruitingJobsJobIdGet>>,
  TError = HTTPValidationError
>(
  jobId: string,
  params?: GetJobApiV1RecruitingJobsJobIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getJobApiV1RecruitingJobsJobIdGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetJobApiV1RecruitingJobsJobIdGetQueryKey(jobId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getJobApiV1RecruitingJobsJobIdGet>>
  > = ({ signal }) => getJobApiV1RecruitingJobsJobIdGet(jobId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!jobId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobApiV1RecruitingJobsJobIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetJobApiV1RecruitingJobsJobIdGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getJobApiV1RecruitingJobsJobIdGet>>
>;
export type GetJobApiV1RecruitingJobsJobIdGetQueryError = HTTPValidationError;

export function useGetJobApiV1RecruitingJobsJobIdGet<
  TData = Awaited<ReturnType<typeof getJobApiV1RecruitingJobsJobIdGet>>,
  TError = HTTPValidationError
>(
  jobId: string,
  params: undefined | GetJobApiV1RecruitingJobsJobIdGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getJobApiV1RecruitingJobsJobIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobApiV1RecruitingJobsJobIdGet>>,
          TError,
          Awaited<ReturnType<typeof getJobApiV1RecruitingJobsJobIdGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetJobApiV1RecruitingJobsJobIdGet<
  TData = Awaited<ReturnType<typeof getJobApiV1RecruitingJobsJobIdGet>>,
  TError = HTTPValidationError
>(
  jobId: string,
  params?: GetJobApiV1RecruitingJobsJobIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getJobApiV1RecruitingJobsJobIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobApiV1RecruitingJobsJobIdGet>>,
          TError,
          Awaited<ReturnType<typeof getJobApiV1RecruitingJobsJobIdGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetJobApiV1RecruitingJobsJobIdGet<
  TData = Awaited<ReturnType<typeof getJobApiV1RecruitingJobsJobIdGet>>,
  TError = HTTPValidationError
>(
  jobId: string,
  params?: GetJobApiV1RecruitingJobsJobIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getJobApiV1RecruitingJobsJobIdGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Job
 */

export function useGetJobApiV1RecruitingJobsJobIdGet<
  TData = Awaited<ReturnType<typeof getJobApiV1RecruitingJobsJobIdGet>>,
  TError = HTTPValidationError
>(
  jobId: string,
  params?: GetJobApiV1RecruitingJobsJobIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getJobApiV1RecruitingJobsJobIdGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetJobApiV1RecruitingJobsJobIdGetQueryOptions(
    jobId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a job posting.

Can update visibility and access lists to control who sees the job and candidates.
 * @summary Update Job
 */
export const updateJobApiV1RecruitingJobsJobIdPut = (
  jobId: string,
  updateJobApiV1RecruitingJobsJobIdPutBody: UpdateJobApiV1RecruitingJobsJobIdPutBody
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/jobs/${jobId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateJobApiV1RecruitingJobsJobIdPutBody
  });
};

export const getUpdateJobApiV1RecruitingJobsJobIdPutMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateJobApiV1RecruitingJobsJobIdPut>>,
    TError,
    { jobId: string; data: UpdateJobApiV1RecruitingJobsJobIdPutBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateJobApiV1RecruitingJobsJobIdPut>>,
  TError,
  { jobId: string; data: UpdateJobApiV1RecruitingJobsJobIdPutBody },
  TContext
> => {
  const mutationKey = ['updateJobApiV1RecruitingJobsJobIdPut'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateJobApiV1RecruitingJobsJobIdPut>>,
    { jobId: string; data: UpdateJobApiV1RecruitingJobsJobIdPutBody }
  > = (props) => {
    const { jobId, data } = props ?? {};

    return updateJobApiV1RecruitingJobsJobIdPut(jobId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateJobApiV1RecruitingJobsJobIdPutMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateJobApiV1RecruitingJobsJobIdPut>>
>;
export type UpdateJobApiV1RecruitingJobsJobIdPutMutationBody =
  UpdateJobApiV1RecruitingJobsJobIdPutBody;
export type UpdateJobApiV1RecruitingJobsJobIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Job
 */
export const useUpdateJobApiV1RecruitingJobsJobIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateJobApiV1RecruitingJobsJobIdPut>>,
      TError,
      { jobId: string; data: UpdateJobApiV1RecruitingJobsJobIdPutBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateJobApiV1RecruitingJobsJobIdPut>>,
  TError,
  { jobId: string; data: UpdateJobApiV1RecruitingJobsJobIdPutBody },
  TContext
> => {
  const mutationOptions =
    getUpdateJobApiV1RecruitingJobsJobIdPutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a job posting.
 * @summary Delete Job
 */
export const deleteJobApiV1RecruitingJobsJobIdDelete = (jobId: string) => {
  return customInstance<void>({
    url: `/api/v1/recruiting/jobs/${jobId}`,
    method: 'DELETE'
  });
};

export const getDeleteJobApiV1RecruitingJobsJobIdDeleteMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteJobApiV1RecruitingJobsJobIdDelete>>,
    TError,
    { jobId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteJobApiV1RecruitingJobsJobIdDelete>>,
  TError,
  { jobId: string },
  TContext
> => {
  const mutationKey = ['deleteJobApiV1RecruitingJobsJobIdDelete'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteJobApiV1RecruitingJobsJobIdDelete>>,
    { jobId: string }
  > = (props) => {
    const { jobId } = props ?? {};

    return deleteJobApiV1RecruitingJobsJobIdDelete(jobId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteJobApiV1RecruitingJobsJobIdDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteJobApiV1RecruitingJobsJobIdDelete>>
>;

export type DeleteJobApiV1RecruitingJobsJobIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Job
 */
export const useDeleteJobApiV1RecruitingJobsJobIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteJobApiV1RecruitingJobsJobIdDelete>>,
      TError,
      { jobId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteJobApiV1RecruitingJobsJobIdDelete>>,
  TError,
  { jobId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteJobApiV1RecruitingJobsJobIdDeleteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Publish a job posting.
 * @summary Publish Job
 */
export const publishJobApiV1RecruitingJobsJobIdPublishPost = (
  jobId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/jobs/${jobId}/publish`,
    method: 'POST',
    signal
  });
};

export const getPublishJobApiV1RecruitingJobsJobIdPublishPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof publishJobApiV1RecruitingJobsJobIdPublishPost>>,
    TError,
    { jobId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof publishJobApiV1RecruitingJobsJobIdPublishPost>>,
  TError,
  { jobId: string },
  TContext
> => {
  const mutationKey = ['publishJobApiV1RecruitingJobsJobIdPublishPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof publishJobApiV1RecruitingJobsJobIdPublishPost>>,
    { jobId: string }
  > = (props) => {
    const { jobId } = props ?? {};

    return publishJobApiV1RecruitingJobsJobIdPublishPost(jobId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PublishJobApiV1RecruitingJobsJobIdPublishPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof publishJobApiV1RecruitingJobsJobIdPublishPost>>
  >;

export type PublishJobApiV1RecruitingJobsJobIdPublishPostMutationError =
  HTTPValidationError;

/**
 * @summary Publish Job
 */
export const usePublishJobApiV1RecruitingJobsJobIdPublishPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof publishJobApiV1RecruitingJobsJobIdPublishPost>>,
      TError,
      { jobId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof publishJobApiV1RecruitingJobsJobIdPublishPost>>,
  TError,
  { jobId: string },
  TContext
> => {
  const mutationOptions =
    getPublishJobApiV1RecruitingJobsJobIdPublishPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Close a job posting.
 * @summary Close Job
 */
export const closeJobApiV1RecruitingJobsJobIdClosePost = (
  jobId: string,
  closeJobApiV1RecruitingJobsJobIdClosePostBody: CloseJobApiV1RecruitingJobsJobIdClosePostBody,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/jobs/${jobId}/close`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: closeJobApiV1RecruitingJobsJobIdClosePostBody,
    signal
  });
};

export const getCloseJobApiV1RecruitingJobsJobIdClosePostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof closeJobApiV1RecruitingJobsJobIdClosePost>>,
    TError,
    { jobId: string; data: CloseJobApiV1RecruitingJobsJobIdClosePostBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof closeJobApiV1RecruitingJobsJobIdClosePost>>,
  TError,
  { jobId: string; data: CloseJobApiV1RecruitingJobsJobIdClosePostBody },
  TContext
> => {
  const mutationKey = ['closeJobApiV1RecruitingJobsJobIdClosePost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof closeJobApiV1RecruitingJobsJobIdClosePost>>,
    { jobId: string; data: CloseJobApiV1RecruitingJobsJobIdClosePostBody }
  > = (props) => {
    const { jobId, data } = props ?? {};

    return closeJobApiV1RecruitingJobsJobIdClosePost(jobId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CloseJobApiV1RecruitingJobsJobIdClosePostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof closeJobApiV1RecruitingJobsJobIdClosePost>>
  >;
export type CloseJobApiV1RecruitingJobsJobIdClosePostMutationBody =
  CloseJobApiV1RecruitingJobsJobIdClosePostBody;
export type CloseJobApiV1RecruitingJobsJobIdClosePostMutationError =
  HTTPValidationError;

/**
 * @summary Close Job
 */
export const useCloseJobApiV1RecruitingJobsJobIdClosePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof closeJobApiV1RecruitingJobsJobIdClosePost>>,
      TError,
      { jobId: string; data: CloseJobApiV1RecruitingJobsJobIdClosePostBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof closeJobApiV1RecruitingJobsJobIdClosePost>>,
  TError,
  { jobId: string; data: CloseJobApiV1RecruitingJobsJobIdClosePostBody },
  TContext
> => {
  const mutationOptions =
    getCloseJobApiV1RecruitingJobsJobIdClosePostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Reopen a closed or filled job posting.
 * @summary Reopen Job
 */
export const reopenJobApiV1RecruitingJobsJobIdReopenPost = (
  jobId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/jobs/${jobId}/reopen`,
    method: 'POST',
    signal
  });
};

export const getReopenJobApiV1RecruitingJobsJobIdReopenPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reopenJobApiV1RecruitingJobsJobIdReopenPost>>,
    TError,
    { jobId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reopenJobApiV1RecruitingJobsJobIdReopenPost>>,
  TError,
  { jobId: string },
  TContext
> => {
  const mutationKey = ['reopenJobApiV1RecruitingJobsJobIdReopenPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reopenJobApiV1RecruitingJobsJobIdReopenPost>>,
    { jobId: string }
  > = (props) => {
    const { jobId } = props ?? {};

    return reopenJobApiV1RecruitingJobsJobIdReopenPost(jobId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReopenJobApiV1RecruitingJobsJobIdReopenPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof reopenJobApiV1RecruitingJobsJobIdReopenPost>>
  >;

export type ReopenJobApiV1RecruitingJobsJobIdReopenPostMutationError =
  HTTPValidationError;

/**
 * @summary Reopen Job
 */
export const useReopenJobApiV1RecruitingJobsJobIdReopenPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof reopenJobApiV1RecruitingJobsJobIdReopenPost>>,
      TError,
      { jobId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof reopenJobApiV1RecruitingJobsJobIdReopenPost>>,
  TError,
  { jobId: string },
  TContext
> => {
  const mutationOptions =
    getReopenJobApiV1RecruitingJobsJobIdReopenPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Duplicate a job posting as a fresh draft.

Requires read access on the source job — creating a job is otherwise
unrestricted, so a caller who can see a job may copy it.

Copies the job's fields, hiring team, application questions, access lists,
stage questions and tags. The copy is always a ``draft``; its slug,
internal code and hiring results are NOT carried over (see
``RecruitingJobRepository.duplicate``). Applications and candidates stay
with the source job.
 * @summary Duplicate Job
 */
export const duplicateJobApiV1RecruitingJobsJobIdDuplicatePost = (
  jobId: string,
  duplicateJobApiV1RecruitingJobsJobIdDuplicatePostBody: DuplicateJobApiV1RecruitingJobsJobIdDuplicatePostBody,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/jobs/${jobId}/duplicate`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: duplicateJobApiV1RecruitingJobsJobIdDuplicatePostBody,
    signal
  });
};

export const getDuplicateJobApiV1RecruitingJobsJobIdDuplicatePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof duplicateJobApiV1RecruitingJobsJobIdDuplicatePost>
      >,
      TError,
      {
        jobId: string;
        data: DuplicateJobApiV1RecruitingJobsJobIdDuplicatePostBody;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof duplicateJobApiV1RecruitingJobsJobIdDuplicatePost>
    >,
    TError,
    {
      jobId: string;
      data: DuplicateJobApiV1RecruitingJobsJobIdDuplicatePostBody;
    },
    TContext
  > => {
    const mutationKey = ['duplicateJobApiV1RecruitingJobsJobIdDuplicatePost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof duplicateJobApiV1RecruitingJobsJobIdDuplicatePost>
      >,
      {
        jobId: string;
        data: DuplicateJobApiV1RecruitingJobsJobIdDuplicatePostBody;
      }
    > = (props) => {
      const { jobId, data } = props ?? {};

      return duplicateJobApiV1RecruitingJobsJobIdDuplicatePost(jobId, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type DuplicateJobApiV1RecruitingJobsJobIdDuplicatePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof duplicateJobApiV1RecruitingJobsJobIdDuplicatePost>
    >
  >;
export type DuplicateJobApiV1RecruitingJobsJobIdDuplicatePostMutationBody =
  DuplicateJobApiV1RecruitingJobsJobIdDuplicatePostBody;
export type DuplicateJobApiV1RecruitingJobsJobIdDuplicatePostMutationError =
  HTTPValidationError;

/**
 * @summary Duplicate Job
 */
export const useDuplicateJobApiV1RecruitingJobsJobIdDuplicatePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof duplicateJobApiV1RecruitingJobsJobIdDuplicatePost>
      >,
      TError,
      {
        jobId: string;
        data: DuplicateJobApiV1RecruitingJobsJobIdDuplicatePostBody;
      },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof duplicateJobApiV1RecruitingJobsJobIdDuplicatePost>>,
  TError,
  {
    jobId: string;
    data: DuplicateJobApiV1RecruitingJobsJobIdDuplicatePostBody;
  },
  TContext
> => {
  const mutationOptions =
    getDuplicateJobApiV1RecruitingJobsJobIdDuplicatePostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Export a job posting as PDF or DOCX.
 * @summary Export Job
 */
export const exportJobApiV1RecruitingJobsJobIdExportGet = (
  jobId: string,
  params?: ExportJobApiV1RecruitingJobsJobIdExportGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/jobs/${jobId}/export`,
    method: 'GET',
    params,
    signal
  });
};

export const getExportJobApiV1RecruitingJobsJobIdExportGetQueryKey = (
  jobId?: string,
  params?: ExportJobApiV1RecruitingJobsJobIdExportGetParams
) => {
  return [
    `/api/v1/recruiting/jobs/${jobId}/export`,
    ...(params ? [params] : [])
  ] as const;
};

export const getExportJobApiV1RecruitingJobsJobIdExportGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof exportJobApiV1RecruitingJobsJobIdExportGet>
  >,
  TError = HTTPValidationError
>(
  jobId: string,
  params?: ExportJobApiV1RecruitingJobsJobIdExportGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportJobApiV1RecruitingJobsJobIdExportGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExportJobApiV1RecruitingJobsJobIdExportGetQueryKey(jobId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof exportJobApiV1RecruitingJobsJobIdExportGet>>
  > = ({ signal }) =>
    exportJobApiV1RecruitingJobsJobIdExportGet(jobId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!jobId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof exportJobApiV1RecruitingJobsJobIdExportGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ExportJobApiV1RecruitingJobsJobIdExportGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportJobApiV1RecruitingJobsJobIdExportGet>>
>;
export type ExportJobApiV1RecruitingJobsJobIdExportGetQueryError =
  HTTPValidationError;

export function useExportJobApiV1RecruitingJobsJobIdExportGet<
  TData = Awaited<
    ReturnType<typeof exportJobApiV1RecruitingJobsJobIdExportGet>
  >,
  TError = HTTPValidationError
>(
  jobId: string,
  params: undefined | ExportJobApiV1RecruitingJobsJobIdExportGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportJobApiV1RecruitingJobsJobIdExportGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof exportJobApiV1RecruitingJobsJobIdExportGet>
          >,
          TError,
          Awaited<ReturnType<typeof exportJobApiV1RecruitingJobsJobIdExportGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useExportJobApiV1RecruitingJobsJobIdExportGet<
  TData = Awaited<
    ReturnType<typeof exportJobApiV1RecruitingJobsJobIdExportGet>
  >,
  TError = HTTPValidationError
>(
  jobId: string,
  params?: ExportJobApiV1RecruitingJobsJobIdExportGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportJobApiV1RecruitingJobsJobIdExportGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof exportJobApiV1RecruitingJobsJobIdExportGet>
          >,
          TError,
          Awaited<ReturnType<typeof exportJobApiV1RecruitingJobsJobIdExportGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useExportJobApiV1RecruitingJobsJobIdExportGet<
  TData = Awaited<
    ReturnType<typeof exportJobApiV1RecruitingJobsJobIdExportGet>
  >,
  TError = HTTPValidationError
>(
  jobId: string,
  params?: ExportJobApiV1RecruitingJobsJobIdExportGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportJobApiV1RecruitingJobsJobIdExportGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Export Job
 */

export function useExportJobApiV1RecruitingJobsJobIdExportGet<
  TData = Awaited<
    ReturnType<typeof exportJobApiV1RecruitingJobsJobIdExportGet>
  >,
  TError = HTTPValidationError
>(
  jobId: string,
  params?: ExportJobApiV1RecruitingJobsJobIdExportGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportJobApiV1RecruitingJobsJobIdExportGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getExportJobApiV1RecruitingJobsJobIdExportGetQueryOptions(
      jobId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get the access list for a job.

Args:
    access_type: Filter by 'job' (private job visibility) or 'candidates' (candidate access).
                 If not provided, returns all access entries.
 * @summary Get Job Access
 */
export const getJobAccessApiV1RecruitingJobsJobIdAccessGet = (
  jobId: string,
  params?: GetJobAccessApiV1RecruitingJobsJobIdAccessGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/jobs/${jobId}/access`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetJobAccessApiV1RecruitingJobsJobIdAccessGetQueryKey = (
  jobId?: string,
  params?: GetJobAccessApiV1RecruitingJobsJobIdAccessGetParams
) => {
  return [
    `/api/v1/recruiting/jobs/${jobId}/access`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetJobAccessApiV1RecruitingJobsJobIdAccessGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getJobAccessApiV1RecruitingJobsJobIdAccessGet>
  >,
  TError = HTTPValidationError
>(
  jobId: string,
  params?: GetJobAccessApiV1RecruitingJobsJobIdAccessGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getJobAccessApiV1RecruitingJobsJobIdAccessGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetJobAccessApiV1RecruitingJobsJobIdAccessGetQueryKey(jobId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getJobAccessApiV1RecruitingJobsJobIdAccessGet>>
  > = ({ signal }) =>
    getJobAccessApiV1RecruitingJobsJobIdAccessGet(jobId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!jobId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobAccessApiV1RecruitingJobsJobIdAccessGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetJobAccessApiV1RecruitingJobsJobIdAccessGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getJobAccessApiV1RecruitingJobsJobIdAccessGet>>
  >;
export type GetJobAccessApiV1RecruitingJobsJobIdAccessGetQueryError =
  HTTPValidationError;

export function useGetJobAccessApiV1RecruitingJobsJobIdAccessGet<
  TData = Awaited<
    ReturnType<typeof getJobAccessApiV1RecruitingJobsJobIdAccessGet>
  >,
  TError = HTTPValidationError
>(
  jobId: string,
  params: undefined | GetJobAccessApiV1RecruitingJobsJobIdAccessGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getJobAccessApiV1RecruitingJobsJobIdAccessGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getJobAccessApiV1RecruitingJobsJobIdAccessGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getJobAccessApiV1RecruitingJobsJobIdAccessGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetJobAccessApiV1RecruitingJobsJobIdAccessGet<
  TData = Awaited<
    ReturnType<typeof getJobAccessApiV1RecruitingJobsJobIdAccessGet>
  >,
  TError = HTTPValidationError
>(
  jobId: string,
  params?: GetJobAccessApiV1RecruitingJobsJobIdAccessGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getJobAccessApiV1RecruitingJobsJobIdAccessGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getJobAccessApiV1RecruitingJobsJobIdAccessGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getJobAccessApiV1RecruitingJobsJobIdAccessGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetJobAccessApiV1RecruitingJobsJobIdAccessGet<
  TData = Awaited<
    ReturnType<typeof getJobAccessApiV1RecruitingJobsJobIdAccessGet>
  >,
  TError = HTTPValidationError
>(
  jobId: string,
  params?: GetJobAccessApiV1RecruitingJobsJobIdAccessGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getJobAccessApiV1RecruitingJobsJobIdAccessGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Job Access
 */

export function useGetJobAccessApiV1RecruitingJobsJobIdAccessGet<
  TData = Awaited<
    ReturnType<typeof getJobAccessApiV1RecruitingJobsJobIdAccessGet>
  >,
  TError = HTTPValidationError
>(
  jobId: string,
  params?: GetJobAccessApiV1RecruitingJobsJobIdAccessGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getJobAccessApiV1RecruitingJobsJobIdAccessGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetJobAccessApiV1RecruitingJobsJobIdAccessGetQueryOptions(
      jobId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Grant a user access to a job.

Args:
    user_id: The user to grant access to
    access_type: 'job' for private job visibility, 'candidates' for candidate access (default: 'job')
 * @summary Grant Job Access
 */
export const grantJobAccessApiV1RecruitingJobsJobIdAccessPost = (
  jobId: string,
  grantJobAccessApiV1RecruitingJobsJobIdAccessPostBody: GrantJobAccessApiV1RecruitingJobsJobIdAccessPostBody,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/jobs/${jobId}/access`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: grantJobAccessApiV1RecruitingJobsJobIdAccessPostBody,
    signal
  });
};

export const getGrantJobAccessApiV1RecruitingJobsJobIdAccessPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof grantJobAccessApiV1RecruitingJobsJobIdAccessPost>
      >,
      TError,
      {
        jobId: string;
        data: GrantJobAccessApiV1RecruitingJobsJobIdAccessPostBody;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof grantJobAccessApiV1RecruitingJobsJobIdAccessPost>
    >,
    TError,
    {
      jobId: string;
      data: GrantJobAccessApiV1RecruitingJobsJobIdAccessPostBody;
    },
    TContext
  > => {
    const mutationKey = ['grantJobAccessApiV1RecruitingJobsJobIdAccessPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof grantJobAccessApiV1RecruitingJobsJobIdAccessPost>
      >,
      {
        jobId: string;
        data: GrantJobAccessApiV1RecruitingJobsJobIdAccessPostBody;
      }
    > = (props) => {
      const { jobId, data } = props ?? {};

      return grantJobAccessApiV1RecruitingJobsJobIdAccessPost(jobId, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type GrantJobAccessApiV1RecruitingJobsJobIdAccessPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof grantJobAccessApiV1RecruitingJobsJobIdAccessPost>>
  >;
export type GrantJobAccessApiV1RecruitingJobsJobIdAccessPostMutationBody =
  GrantJobAccessApiV1RecruitingJobsJobIdAccessPostBody;
export type GrantJobAccessApiV1RecruitingJobsJobIdAccessPostMutationError =
  HTTPValidationError;

/**
 * @summary Grant Job Access
 */
export const useGrantJobAccessApiV1RecruitingJobsJobIdAccessPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof grantJobAccessApiV1RecruitingJobsJobIdAccessPost>
      >,
      TError,
      {
        jobId: string;
        data: GrantJobAccessApiV1RecruitingJobsJobIdAccessPostBody;
      },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof grantJobAccessApiV1RecruitingJobsJobIdAccessPost>>,
  TError,
  { jobId: string; data: GrantJobAccessApiV1RecruitingJobsJobIdAccessPostBody },
  TContext
> => {
  const mutationOptions =
    getGrantJobAccessApiV1RecruitingJobsJobIdAccessPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Revoke a user's access.

Args:
    access_type: 'job' for private job visibility, 'candidates' for candidate access
 * @summary Revoke Job Access
 */
export const revokeJobAccessApiV1RecruitingJobsJobIdAccessUserIdDelete = (
  jobId: string,
  userId: string,
  params?: RevokeJobAccessApiV1RecruitingJobsJobIdAccessUserIdDeleteParams
) => {
  return customInstance<void>({
    url: `/api/v1/recruiting/jobs/${jobId}/access/${userId}`,
    method: 'DELETE',
    params
  });
};

export const getRevokeJobAccessApiV1RecruitingJobsJobIdAccessUserIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof revokeJobAccessApiV1RecruitingJobsJobIdAccessUserIdDelete
        >
      >,
      TError,
      {
        jobId: string;
        userId: string;
        params?: RevokeJobAccessApiV1RecruitingJobsJobIdAccessUserIdDeleteParams;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof revokeJobAccessApiV1RecruitingJobsJobIdAccessUserIdDelete
      >
    >,
    TError,
    {
      jobId: string;
      userId: string;
      params?: RevokeJobAccessApiV1RecruitingJobsJobIdAccessUserIdDeleteParams;
    },
    TContext
  > => {
    const mutationKey = [
      'revokeJobAccessApiV1RecruitingJobsJobIdAccessUserIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof revokeJobAccessApiV1RecruitingJobsJobIdAccessUserIdDelete
        >
      >,
      {
        jobId: string;
        userId: string;
        params?: RevokeJobAccessApiV1RecruitingJobsJobIdAccessUserIdDeleteParams;
      }
    > = (props) => {
      const { jobId, userId, params } = props ?? {};

      return revokeJobAccessApiV1RecruitingJobsJobIdAccessUserIdDelete(
        jobId,
        userId,
        params
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RevokeJobAccessApiV1RecruitingJobsJobIdAccessUserIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof revokeJobAccessApiV1RecruitingJobsJobIdAccessUserIdDelete
      >
    >
  >;

export type RevokeJobAccessApiV1RecruitingJobsJobIdAccessUserIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Revoke Job Access
 */
export const useRevokeJobAccessApiV1RecruitingJobsJobIdAccessUserIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof revokeJobAccessApiV1RecruitingJobsJobIdAccessUserIdDelete
        >
      >,
      TError,
      {
        jobId: string;
        userId: string;
        params?: RevokeJobAccessApiV1RecruitingJobsJobIdAccessUserIdDeleteParams;
      },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof revokeJobAccessApiV1RecruitingJobsJobIdAccessUserIdDelete>
  >,
  TError,
  {
    jobId: string;
    userId: string;
    params?: RevokeJobAccessApiV1RecruitingJobsJobIdAccessUserIdDeleteParams;
  },
  TContext
> => {
  const mutationOptions =
    getRevokeJobAccessApiV1RecruitingJobsJobIdAccessUserIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * List all interviewers assigned to a job.
 * @summary List Job Interviewers
 */
export const listJobInterviewersApiV1RecruitingJobsJobIdInterviewersGet = (
  jobId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/jobs/${jobId}/interviewers`,
    method: 'GET',
    signal
  });
};

export const getListJobInterviewersApiV1RecruitingJobsJobIdInterviewersGetQueryKey =
  (jobId?: string) => {
    return [`/api/v1/recruiting/jobs/${jobId}/interviewers`] as const;
  };

export const getListJobInterviewersApiV1RecruitingJobsJobIdInterviewersGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listJobInterviewersApiV1RecruitingJobsJobIdInterviewersGet
      >
    >,
    TError = HTTPValidationError
  >(
    jobId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listJobInterviewersApiV1RecruitingJobsJobIdInterviewersGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListJobInterviewersApiV1RecruitingJobsJobIdInterviewersGetQueryKey(
        jobId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listJobInterviewersApiV1RecruitingJobsJobIdInterviewersGet
        >
      >
    > = ({ signal }) =>
      listJobInterviewersApiV1RecruitingJobsJobIdInterviewersGet(jobId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!jobId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listJobInterviewersApiV1RecruitingJobsJobIdInterviewersGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListJobInterviewersApiV1RecruitingJobsJobIdInterviewersGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listJobInterviewersApiV1RecruitingJobsJobIdInterviewersGet
      >
    >
  >;
export type ListJobInterviewersApiV1RecruitingJobsJobIdInterviewersGetQueryError =
  HTTPValidationError;

export function useListJobInterviewersApiV1RecruitingJobsJobIdInterviewersGet<
  TData = Awaited<
    ReturnType<
      typeof listJobInterviewersApiV1RecruitingJobsJobIdInterviewersGet
    >
  >,
  TError = HTTPValidationError
>(
  jobId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listJobInterviewersApiV1RecruitingJobsJobIdInterviewersGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listJobInterviewersApiV1RecruitingJobsJobIdInterviewersGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listJobInterviewersApiV1RecruitingJobsJobIdInterviewersGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListJobInterviewersApiV1RecruitingJobsJobIdInterviewersGet<
  TData = Awaited<
    ReturnType<
      typeof listJobInterviewersApiV1RecruitingJobsJobIdInterviewersGet
    >
  >,
  TError = HTTPValidationError
>(
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listJobInterviewersApiV1RecruitingJobsJobIdInterviewersGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listJobInterviewersApiV1RecruitingJobsJobIdInterviewersGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listJobInterviewersApiV1RecruitingJobsJobIdInterviewersGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListJobInterviewersApiV1RecruitingJobsJobIdInterviewersGet<
  TData = Awaited<
    ReturnType<
      typeof listJobInterviewersApiV1RecruitingJobsJobIdInterviewersGet
    >
  >,
  TError = HTTPValidationError
>(
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listJobInterviewersApiV1RecruitingJobsJobIdInterviewersGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Job Interviewers
 */

export function useListJobInterviewersApiV1RecruitingJobsJobIdInterviewersGet<
  TData = Awaited<
    ReturnType<
      typeof listJobInterviewersApiV1RecruitingJobsJobIdInterviewersGet
    >
  >,
  TError = HTTPValidationError
>(
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listJobInterviewersApiV1RecruitingJobsJobIdInterviewersGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListJobInterviewersApiV1RecruitingJobsJobIdInterviewersGetQueryOptions(
      jobId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add an interviewer to a job with optional stage assignments.
 * @summary Add Job Interviewer
 */
export const addJobInterviewerApiV1RecruitingJobsJobIdInterviewersPost = (
  jobId: string,
  addJobInterviewerApiV1RecruitingJobsJobIdInterviewersPostBody: AddJobInterviewerApiV1RecruitingJobsJobIdInterviewersPostBody,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/jobs/${jobId}/interviewers`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: addJobInterviewerApiV1RecruitingJobsJobIdInterviewersPostBody,
    signal
  });
};

export const getAddJobInterviewerApiV1RecruitingJobsJobIdInterviewersPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof addJobInterviewerApiV1RecruitingJobsJobIdInterviewersPost
        >
      >,
      TError,
      {
        jobId: string;
        data: AddJobInterviewerApiV1RecruitingJobsJobIdInterviewersPostBody;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof addJobInterviewerApiV1RecruitingJobsJobIdInterviewersPost
      >
    >,
    TError,
    {
      jobId: string;
      data: AddJobInterviewerApiV1RecruitingJobsJobIdInterviewersPostBody;
    },
    TContext
  > => {
    const mutationKey = [
      'addJobInterviewerApiV1RecruitingJobsJobIdInterviewersPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof addJobInterviewerApiV1RecruitingJobsJobIdInterviewersPost
        >
      >,
      {
        jobId: string;
        data: AddJobInterviewerApiV1RecruitingJobsJobIdInterviewersPostBody;
      }
    > = (props) => {
      const { jobId, data } = props ?? {};

      return addJobInterviewerApiV1RecruitingJobsJobIdInterviewersPost(
        jobId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AddJobInterviewerApiV1RecruitingJobsJobIdInterviewersPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof addJobInterviewerApiV1RecruitingJobsJobIdInterviewersPost
      >
    >
  >;
export type AddJobInterviewerApiV1RecruitingJobsJobIdInterviewersPostMutationBody =
  AddJobInterviewerApiV1RecruitingJobsJobIdInterviewersPostBody;
export type AddJobInterviewerApiV1RecruitingJobsJobIdInterviewersPostMutationError =
  HTTPValidationError;

/**
 * @summary Add Job Interviewer
 */
export const useAddJobInterviewerApiV1RecruitingJobsJobIdInterviewersPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof addJobInterviewerApiV1RecruitingJobsJobIdInterviewersPost
        >
      >,
      TError,
      {
        jobId: string;
        data: AddJobInterviewerApiV1RecruitingJobsJobIdInterviewersPostBody;
      },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof addJobInterviewerApiV1RecruitingJobsJobIdInterviewersPost>
  >,
  TError,
  {
    jobId: string;
    data: AddJobInterviewerApiV1RecruitingJobsJobIdInterviewersPostBody;
  },
  TContext
> => {
  const mutationOptions =
    getAddJobInterviewerApiV1RecruitingJobsJobIdInterviewersPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Link stages to an interviewer, naming ONLY the stages being added.

Re-linking a stage the interviewer already covers is a no-op rather than an
error, so a double-click or a retried request is idempotent.
 * @summary Add Job Interviewer Stages
 */
export const addJobInterviewerStagesApiV1RecruitingJobsJobIdInterviewersUserIdStagesPost =
  (
    jobId: string,
    userId: string,
    recruitingJobInterviewerStageLinkCreate: RecruitingJobInterviewerStageLinkCreate,
    signal?: AbortSignal
  ) => {
    return customInstance<RecruitingJobInterviewerStageLinksResponse>({
      url: `/api/v1/recruiting/jobs/${jobId}/interviewers/${userId}/stages`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: recruitingJobInterviewerStageLinkCreate,
      signal
    });
  };

export const getAddJobInterviewerStagesApiV1RecruitingJobsJobIdInterviewersUserIdStagesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof addJobInterviewerStagesApiV1RecruitingJobsJobIdInterviewersUserIdStagesPost
        >
      >,
      TError,
      {
        jobId: string;
        userId: string;
        data: RecruitingJobInterviewerStageLinkCreate;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof addJobInterviewerStagesApiV1RecruitingJobsJobIdInterviewersUserIdStagesPost
      >
    >,
    TError,
    {
      jobId: string;
      userId: string;
      data: RecruitingJobInterviewerStageLinkCreate;
    },
    TContext
  > => {
    const mutationKey = [
      'addJobInterviewerStagesApiV1RecruitingJobsJobIdInterviewersUserIdStagesPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof addJobInterviewerStagesApiV1RecruitingJobsJobIdInterviewersUserIdStagesPost
        >
      >,
      {
        jobId: string;
        userId: string;
        data: RecruitingJobInterviewerStageLinkCreate;
      }
    > = (props) => {
      const { jobId, userId, data } = props ?? {};

      return addJobInterviewerStagesApiV1RecruitingJobsJobIdInterviewersUserIdStagesPost(
        jobId,
        userId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AddJobInterviewerStagesApiV1RecruitingJobsJobIdInterviewersUserIdStagesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof addJobInterviewerStagesApiV1RecruitingJobsJobIdInterviewersUserIdStagesPost
      >
    >
  >;
export type AddJobInterviewerStagesApiV1RecruitingJobsJobIdInterviewersUserIdStagesPostMutationBody =
  RecruitingJobInterviewerStageLinkCreate;
export type AddJobInterviewerStagesApiV1RecruitingJobsJobIdInterviewersUserIdStagesPostMutationError =
  HTTPValidationError;

/**
 * @summary Add Job Interviewer Stages
 */
export const useAddJobInterviewerStagesApiV1RecruitingJobsJobIdInterviewersUserIdStagesPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof addJobInterviewerStagesApiV1RecruitingJobsJobIdInterviewersUserIdStagesPost
          >
        >,
        TError,
        {
          jobId: string;
          userId: string;
          data: RecruitingJobInterviewerStageLinkCreate;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof addJobInterviewerStagesApiV1RecruitingJobsJobIdInterviewersUserIdStagesPost
      >
    >,
    TError,
    {
      jobId: string;
      userId: string;
      data: RecruitingJobInterviewerStageLinkCreate;
    },
    TContext
  > => {
    const mutationOptions =
      getAddJobInterviewerStagesApiV1RecruitingJobsJobIdInterviewersUserIdStagesPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Unlink ONE stage from an interviewer.

When that was the interviewer's last stage, their hiring-team row goes too —
the behaviour the stage picker has always had, moved server-side so it is
decided inside this request's transaction. Deciding "that was their last one"
in the browser is the same stale read the whole-list PUT was: a stage another
recruiter added a moment ago would be destroyed by a client that still
believed one link remained.
 * @summary Remove Job Interviewer Stage
 */
export const removeJobInterviewerStageApiV1RecruitingJobsJobIdInterviewersUserIdStagesStageIdDelete =
  (jobId: string, userId: string, stageId: string) => {
    return customInstance<RecruitingJobInterviewerStageLinksResponse>({
      url: `/api/v1/recruiting/jobs/${jobId}/interviewers/${userId}/stages/${stageId}`,
      method: 'DELETE'
    });
  };

export const getRemoveJobInterviewerStageApiV1RecruitingJobsJobIdInterviewersUserIdStagesStageIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof removeJobInterviewerStageApiV1RecruitingJobsJobIdInterviewersUserIdStagesStageIdDelete
        >
      >,
      TError,
      { jobId: string; userId: string; stageId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof removeJobInterviewerStageApiV1RecruitingJobsJobIdInterviewersUserIdStagesStageIdDelete
      >
    >,
    TError,
    { jobId: string; userId: string; stageId: string },
    TContext
  > => {
    const mutationKey = [
      'removeJobInterviewerStageApiV1RecruitingJobsJobIdInterviewersUserIdStagesStageIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof removeJobInterviewerStageApiV1RecruitingJobsJobIdInterviewersUserIdStagesStageIdDelete
        >
      >,
      { jobId: string; userId: string; stageId: string }
    > = (props) => {
      const { jobId, userId, stageId } = props ?? {};

      return removeJobInterviewerStageApiV1RecruitingJobsJobIdInterviewersUserIdStagesStageIdDelete(
        jobId,
        userId,
        stageId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RemoveJobInterviewerStageApiV1RecruitingJobsJobIdInterviewersUserIdStagesStageIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof removeJobInterviewerStageApiV1RecruitingJobsJobIdInterviewersUserIdStagesStageIdDelete
      >
    >
  >;

export type RemoveJobInterviewerStageApiV1RecruitingJobsJobIdInterviewersUserIdStagesStageIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Remove Job Interviewer Stage
 */
export const useRemoveJobInterviewerStageApiV1RecruitingJobsJobIdInterviewersUserIdStagesStageIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof removeJobInterviewerStageApiV1RecruitingJobsJobIdInterviewersUserIdStagesStageIdDelete
          >
        >,
        TError,
        { jobId: string; userId: string; stageId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof removeJobInterviewerStageApiV1RecruitingJobsJobIdInterviewersUserIdStagesStageIdDelete
      >
    >,
    TError,
    { jobId: string; userId: string; stageId: string },
    TContext
  > => {
    const mutationOptions =
      getRemoveJobInterviewerStageApiV1RecruitingJobsJobIdInterviewersUserIdStagesStageIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Remove an interviewer from a job.
 * @summary Remove Job Interviewer
 */
export const removeJobInterviewerApiV1RecruitingJobsJobIdInterviewersUserIdDelete =
  (jobId: string, userId: string) => {
    return customInstance<void>({
      url: `/api/v1/recruiting/jobs/${jobId}/interviewers/${userId}`,
      method: 'DELETE'
    });
  };

export const getRemoveJobInterviewerApiV1RecruitingJobsJobIdInterviewersUserIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof removeJobInterviewerApiV1RecruitingJobsJobIdInterviewersUserIdDelete
        >
      >,
      TError,
      { jobId: string; userId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof removeJobInterviewerApiV1RecruitingJobsJobIdInterviewersUserIdDelete
      >
    >,
    TError,
    { jobId: string; userId: string },
    TContext
  > => {
    const mutationKey = [
      'removeJobInterviewerApiV1RecruitingJobsJobIdInterviewersUserIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof removeJobInterviewerApiV1RecruitingJobsJobIdInterviewersUserIdDelete
        >
      >,
      { jobId: string; userId: string }
    > = (props) => {
      const { jobId, userId } = props ?? {};

      return removeJobInterviewerApiV1RecruitingJobsJobIdInterviewersUserIdDelete(
        jobId,
        userId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RemoveJobInterviewerApiV1RecruitingJobsJobIdInterviewersUserIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof removeJobInterviewerApiV1RecruitingJobsJobIdInterviewersUserIdDelete
      >
    >
  >;

export type RemoveJobInterviewerApiV1RecruitingJobsJobIdInterviewersUserIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Remove Job Interviewer
 */
export const useRemoveJobInterviewerApiV1RecruitingJobsJobIdInterviewersUserIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof removeJobInterviewerApiV1RecruitingJobsJobIdInterviewersUserIdDelete
          >
        >,
        TError,
        { jobId: string; userId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof removeJobInterviewerApiV1RecruitingJobsJobIdInterviewersUserIdDelete
      >
    >,
    TError,
    { jobId: string; userId: string },
    TContext
  > => {
    const mutationOptions =
      getRemoveJobInterviewerApiV1RecruitingJobsJobIdInterviewersUserIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Get the task board for a job (if it exists).

Returns the board ID and workspace ID if a task board has been created for this job.
Returns null values if no board exists yet.
 * @summary Get Job Board
 */
export const getJobBoardApiV1RecruitingJobsJobIdBoardGet = (
  jobId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/jobs/${jobId}/board`,
    method: 'GET',
    signal
  });
};

export const getGetJobBoardApiV1RecruitingJobsJobIdBoardGetQueryKey = (
  jobId?: string
) => {
  return [`/api/v1/recruiting/jobs/${jobId}/board`] as const;
};

export const getGetJobBoardApiV1RecruitingJobsJobIdBoardGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getJobBoardApiV1RecruitingJobsJobIdBoardGet>
  >,
  TError = HTTPValidationError
>(
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getJobBoardApiV1RecruitingJobsJobIdBoardGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetJobBoardApiV1RecruitingJobsJobIdBoardGetQueryKey(jobId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getJobBoardApiV1RecruitingJobsJobIdBoardGet>>
  > = ({ signal }) =>
    getJobBoardApiV1RecruitingJobsJobIdBoardGet(jobId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!jobId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobBoardApiV1RecruitingJobsJobIdBoardGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetJobBoardApiV1RecruitingJobsJobIdBoardGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getJobBoardApiV1RecruitingJobsJobIdBoardGet>>
  >;
export type GetJobBoardApiV1RecruitingJobsJobIdBoardGetQueryError =
  HTTPValidationError;

export function useGetJobBoardApiV1RecruitingJobsJobIdBoardGet<
  TData = Awaited<
    ReturnType<typeof getJobBoardApiV1RecruitingJobsJobIdBoardGet>
  >,
  TError = HTTPValidationError
>(
  jobId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getJobBoardApiV1RecruitingJobsJobIdBoardGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getJobBoardApiV1RecruitingJobsJobIdBoardGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getJobBoardApiV1RecruitingJobsJobIdBoardGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetJobBoardApiV1RecruitingJobsJobIdBoardGet<
  TData = Awaited<
    ReturnType<typeof getJobBoardApiV1RecruitingJobsJobIdBoardGet>
  >,
  TError = HTTPValidationError
>(
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getJobBoardApiV1RecruitingJobsJobIdBoardGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getJobBoardApiV1RecruitingJobsJobIdBoardGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getJobBoardApiV1RecruitingJobsJobIdBoardGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetJobBoardApiV1RecruitingJobsJobIdBoardGet<
  TData = Awaited<
    ReturnType<typeof getJobBoardApiV1RecruitingJobsJobIdBoardGet>
  >,
  TError = HTTPValidationError
>(
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getJobBoardApiV1RecruitingJobsJobIdBoardGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Job Board
 */

export function useGetJobBoardApiV1RecruitingJobsJobIdBoardGet<
  TData = Awaited<
    ReturnType<typeof getJobBoardApiV1RecruitingJobsJobIdBoardGet>
  >,
  TError = HTTPValidationError
>(
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getJobBoardApiV1RecruitingJobsJobIdBoardGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetJobBoardApiV1RecruitingJobsJobIdBoardGetQueryOptions(jobId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create or get the task board for a job.

Creates a new task board linked to the job if one doesn't exist.
The board is placed in the tenant's "Recruiting" workspace (created if needed).
Returns the board ID and whether it was newly created.
 * @summary Create Job Board
 */
export const createJobBoardApiV1RecruitingJobsJobIdBoardPost = (
  jobId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/jobs/${jobId}/board`,
    method: 'POST',
    signal
  });
};

export const getCreateJobBoardApiV1RecruitingJobsJobIdBoardPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createJobBoardApiV1RecruitingJobsJobIdBoardPost>
      >,
      TError,
      { jobId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof createJobBoardApiV1RecruitingJobsJobIdBoardPost>>,
    TError,
    { jobId: string },
    TContext
  > => {
    const mutationKey = ['createJobBoardApiV1RecruitingJobsJobIdBoardPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createJobBoardApiV1RecruitingJobsJobIdBoardPost>
      >,
      { jobId: string }
    > = (props) => {
      const { jobId } = props ?? {};

      return createJobBoardApiV1RecruitingJobsJobIdBoardPost(jobId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateJobBoardApiV1RecruitingJobsJobIdBoardPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createJobBoardApiV1RecruitingJobsJobIdBoardPost>>
  >;

export type CreateJobBoardApiV1RecruitingJobsJobIdBoardPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Job Board
 */
export const useCreateJobBoardApiV1RecruitingJobsJobIdBoardPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createJobBoardApiV1RecruitingJobsJobIdBoardPost>
      >,
      TError,
      { jobId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createJobBoardApiV1RecruitingJobsJobIdBoardPost>>,
  TError,
  { jobId: string },
  TContext
> => {
  const mutationOptions =
    getCreateJobBoardApiV1RecruitingJobsJobIdBoardPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Return linked-record candidates from the broad accessible candidate scope.
 * @summary Get Candidate Filter Facets
 */
export const getCandidateFilterFacetsApiV1RecruitingCandidatesFilterFacetsGet =
  (
    params?: GetCandidateFilterFacetsApiV1RecruitingCandidatesFilterFacetsGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<CandidateFilterFacets>({
      url: `/api/v1/recruiting/candidates/filter-facets`,
      method: 'GET',
      params,
      signal
    });
  };

export const getGetCandidateFilterFacetsApiV1RecruitingCandidatesFilterFacetsGetQueryKey =
  (
    params?: GetCandidateFilterFacetsApiV1RecruitingCandidatesFilterFacetsGetParams
  ) => {
    return [
      `/api/v1/recruiting/candidates/filter-facets`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetCandidateFilterFacetsApiV1RecruitingCandidatesFilterFacetsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getCandidateFilterFacetsApiV1RecruitingCandidatesFilterFacetsGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: GetCandidateFilterFacetsApiV1RecruitingCandidatesFilterFacetsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getCandidateFilterFacetsApiV1RecruitingCandidatesFilterFacetsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetCandidateFilterFacetsApiV1RecruitingCandidatesFilterFacetsGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getCandidateFilterFacetsApiV1RecruitingCandidatesFilterFacetsGet
        >
      >
    > = ({ signal }) =>
      getCandidateFilterFacetsApiV1RecruitingCandidatesFilterFacetsGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getCandidateFilterFacetsApiV1RecruitingCandidatesFilterFacetsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetCandidateFilterFacetsApiV1RecruitingCandidatesFilterFacetsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getCandidateFilterFacetsApiV1RecruitingCandidatesFilterFacetsGet
      >
    >
  >;
export type GetCandidateFilterFacetsApiV1RecruitingCandidatesFilterFacetsGetQueryError =
  HTTPValidationError;

export function useGetCandidateFilterFacetsApiV1RecruitingCandidatesFilterFacetsGet<
  TData = Awaited<
    ReturnType<
      typeof getCandidateFilterFacetsApiV1RecruitingCandidatesFilterFacetsGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | GetCandidateFilterFacetsApiV1RecruitingCandidatesFilterFacetsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCandidateFilterFacetsApiV1RecruitingCandidatesFilterFacetsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getCandidateFilterFacetsApiV1RecruitingCandidatesFilterFacetsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getCandidateFilterFacetsApiV1RecruitingCandidatesFilterFacetsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCandidateFilterFacetsApiV1RecruitingCandidatesFilterFacetsGet<
  TData = Awaited<
    ReturnType<
      typeof getCandidateFilterFacetsApiV1RecruitingCandidatesFilterFacetsGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: GetCandidateFilterFacetsApiV1RecruitingCandidatesFilterFacetsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCandidateFilterFacetsApiV1RecruitingCandidatesFilterFacetsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getCandidateFilterFacetsApiV1RecruitingCandidatesFilterFacetsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getCandidateFilterFacetsApiV1RecruitingCandidatesFilterFacetsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCandidateFilterFacetsApiV1RecruitingCandidatesFilterFacetsGet<
  TData = Awaited<
    ReturnType<
      typeof getCandidateFilterFacetsApiV1RecruitingCandidatesFilterFacetsGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: GetCandidateFilterFacetsApiV1RecruitingCandidatesFilterFacetsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCandidateFilterFacetsApiV1RecruitingCandidatesFilterFacetsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Candidate Filter Facets
 */

export function useGetCandidateFilterFacetsApiV1RecruitingCandidatesFilterFacetsGet<
  TData = Awaited<
    ReturnType<
      typeof getCandidateFilterFacetsApiV1RecruitingCandidatesFilterFacetsGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: GetCandidateFilterFacetsApiV1RecruitingCandidatesFilterFacetsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getCandidateFilterFacetsApiV1RecruitingCandidatesFilterFacetsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetCandidateFilterFacetsApiV1RecruitingCandidatesFilterFacetsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List candidates with optional filtering.

Candidates accumulate (Shape A), so the page window AND the sort resolve
here; the caller only ever holds one page.
 * @summary List Candidates
 */
export const listCandidatesApiV1RecruitingCandidatesGet = (
  params?: ListCandidatesApiV1RecruitingCandidatesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<CandidateListResponse>({
    url: `/api/v1/recruiting/candidates`,
    method: 'GET',
    params,
    signal
  });
};

export const getListCandidatesApiV1RecruitingCandidatesGetQueryKey = (
  params?: ListCandidatesApiV1RecruitingCandidatesGetParams
) => {
  return [
    `/api/v1/recruiting/candidates`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListCandidatesApiV1RecruitingCandidatesGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listCandidatesApiV1RecruitingCandidatesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListCandidatesApiV1RecruitingCandidatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCandidatesApiV1RecruitingCandidatesGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListCandidatesApiV1RecruitingCandidatesGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCandidatesApiV1RecruitingCandidatesGet>>
  > = ({ signal }) =>
    listCandidatesApiV1RecruitingCandidatesGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCandidatesApiV1RecruitingCandidatesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListCandidatesApiV1RecruitingCandidatesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCandidatesApiV1RecruitingCandidatesGet>>
>;
export type ListCandidatesApiV1RecruitingCandidatesGetQueryError =
  HTTPValidationError;

export function useListCandidatesApiV1RecruitingCandidatesGet<
  TData = Awaited<
    ReturnType<typeof listCandidatesApiV1RecruitingCandidatesGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListCandidatesApiV1RecruitingCandidatesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCandidatesApiV1RecruitingCandidatesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listCandidatesApiV1RecruitingCandidatesGet>
          >,
          TError,
          Awaited<ReturnType<typeof listCandidatesApiV1RecruitingCandidatesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListCandidatesApiV1RecruitingCandidatesGet<
  TData = Awaited<
    ReturnType<typeof listCandidatesApiV1RecruitingCandidatesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListCandidatesApiV1RecruitingCandidatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCandidatesApiV1RecruitingCandidatesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listCandidatesApiV1RecruitingCandidatesGet>
          >,
          TError,
          Awaited<ReturnType<typeof listCandidatesApiV1RecruitingCandidatesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListCandidatesApiV1RecruitingCandidatesGet<
  TData = Awaited<
    ReturnType<typeof listCandidatesApiV1RecruitingCandidatesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListCandidatesApiV1RecruitingCandidatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCandidatesApiV1RecruitingCandidatesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Candidates
 */

export function useListCandidatesApiV1RecruitingCandidatesGet<
  TData = Awaited<
    ReturnType<typeof listCandidatesApiV1RecruitingCandidatesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListCandidatesApiV1RecruitingCandidatesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCandidatesApiV1RecruitingCandidatesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListCandidatesApiV1RecruitingCandidatesGetQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new candidate.
 * @summary Create Candidate
 */
export const createCandidateApiV1RecruitingCandidatesPost = (
  createCandidateApiV1RecruitingCandidatesPostBody: CreateCandidateApiV1RecruitingCandidatesPostBody,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/candidates`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createCandidateApiV1RecruitingCandidatesPostBody,
    signal
  });
};

export const getCreateCandidateApiV1RecruitingCandidatesPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCandidateApiV1RecruitingCandidatesPost>>,
    TError,
    { data: CreateCandidateApiV1RecruitingCandidatesPostBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCandidateApiV1RecruitingCandidatesPost>>,
  TError,
  { data: CreateCandidateApiV1RecruitingCandidatesPostBody },
  TContext
> => {
  const mutationKey = ['createCandidateApiV1RecruitingCandidatesPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCandidateApiV1RecruitingCandidatesPost>>,
    { data: CreateCandidateApiV1RecruitingCandidatesPostBody }
  > = (props) => {
    const { data } = props ?? {};

    return createCandidateApiV1RecruitingCandidatesPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCandidateApiV1RecruitingCandidatesPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createCandidateApiV1RecruitingCandidatesPost>>
  >;
export type CreateCandidateApiV1RecruitingCandidatesPostMutationBody =
  CreateCandidateApiV1RecruitingCandidatesPostBody;
export type CreateCandidateApiV1RecruitingCandidatesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Candidate
 */
export const useCreateCandidateApiV1RecruitingCandidatesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createCandidateApiV1RecruitingCandidatesPost>>,
      TError,
      { data: CreateCandidateApiV1RecruitingCandidatesPostBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createCandidateApiV1RecruitingCandidatesPost>>,
  TError,
  { data: CreateCandidateApiV1RecruitingCandidatesPostBody },
  TContext
> => {
  const mutationOptions =
    getCreateCandidateApiV1RecruitingCandidatesPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get a candidate by ID.
 * @summary Get Candidate
 */
export const getCandidateApiV1RecruitingCandidatesCandidateIdGet = (
  candidateId: string,
  params?: GetCandidateApiV1RecruitingCandidatesCandidateIdGetParams,
  signal?: AbortSignal
) => {
  return customInstance<CandidateResponse>({
    url: `/api/v1/recruiting/candidates/${candidateId}`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetCandidateApiV1RecruitingCandidatesCandidateIdGetQueryKey = (
  candidateId?: string,
  params?: GetCandidateApiV1RecruitingCandidatesCandidateIdGetParams
) => {
  return [
    `/api/v1/recruiting/candidates/${candidateId}`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetCandidateApiV1RecruitingCandidatesCandidateIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getCandidateApiV1RecruitingCandidatesCandidateIdGet>
    >,
    TError = HTTPValidationError
  >(
    candidateId: string,
    params?: GetCandidateApiV1RecruitingCandidatesCandidateIdGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getCandidateApiV1RecruitingCandidatesCandidateIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetCandidateApiV1RecruitingCandidatesCandidateIdGetQueryKey(
        candidateId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getCandidateApiV1RecruitingCandidatesCandidateIdGet>
      >
    > = ({ signal }) =>
      getCandidateApiV1RecruitingCandidatesCandidateIdGet(
        candidateId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!candidateId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getCandidateApiV1RecruitingCandidatesCandidateIdGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetCandidateApiV1RecruitingCandidatesCandidateIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getCandidateApiV1RecruitingCandidatesCandidateIdGet>
    >
  >;
export type GetCandidateApiV1RecruitingCandidatesCandidateIdGetQueryError =
  HTTPValidationError;

export function useGetCandidateApiV1RecruitingCandidatesCandidateIdGet<
  TData = Awaited<
    ReturnType<typeof getCandidateApiV1RecruitingCandidatesCandidateIdGet>
  >,
  TError = HTTPValidationError
>(
  candidateId: string,
  params: undefined | GetCandidateApiV1RecruitingCandidatesCandidateIdGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getCandidateApiV1RecruitingCandidatesCandidateIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getCandidateApiV1RecruitingCandidatesCandidateIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getCandidateApiV1RecruitingCandidatesCandidateIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCandidateApiV1RecruitingCandidatesCandidateIdGet<
  TData = Awaited<
    ReturnType<typeof getCandidateApiV1RecruitingCandidatesCandidateIdGet>
  >,
  TError = HTTPValidationError
>(
  candidateId: string,
  params?: GetCandidateApiV1RecruitingCandidatesCandidateIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getCandidateApiV1RecruitingCandidatesCandidateIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getCandidateApiV1RecruitingCandidatesCandidateIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getCandidateApiV1RecruitingCandidatesCandidateIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCandidateApiV1RecruitingCandidatesCandidateIdGet<
  TData = Awaited<
    ReturnType<typeof getCandidateApiV1RecruitingCandidatesCandidateIdGet>
  >,
  TError = HTTPValidationError
>(
  candidateId: string,
  params?: GetCandidateApiV1RecruitingCandidatesCandidateIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getCandidateApiV1RecruitingCandidatesCandidateIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Candidate
 */

export function useGetCandidateApiV1RecruitingCandidatesCandidateIdGet<
  TData = Awaited<
    ReturnType<typeof getCandidateApiV1RecruitingCandidatesCandidateIdGet>
  >,
  TError = HTTPValidationError
>(
  candidateId: string,
  params?: GetCandidateApiV1RecruitingCandidatesCandidateIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getCandidateApiV1RecruitingCandidatesCandidateIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetCandidateApiV1RecruitingCandidatesCandidateIdGetQueryOptions(
      candidateId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a candidate.
 * @summary Update Candidate
 */
export const updateCandidateApiV1RecruitingCandidatesCandidateIdPut = (
  candidateId: string,
  updateCandidateApiV1RecruitingCandidatesCandidateIdPutBody: UpdateCandidateApiV1RecruitingCandidatesCandidateIdPutBody
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/candidates/${candidateId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateCandidateApiV1RecruitingCandidatesCandidateIdPutBody
  });
};

export const getUpdateCandidateApiV1RecruitingCandidatesCandidateIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateCandidateApiV1RecruitingCandidatesCandidateIdPut
        >
      >,
      TError,
      {
        candidateId: string;
        data: UpdateCandidateApiV1RecruitingCandidatesCandidateIdPutBody;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateCandidateApiV1RecruitingCandidatesCandidateIdPut>
    >,
    TError,
    {
      candidateId: string;
      data: UpdateCandidateApiV1RecruitingCandidatesCandidateIdPutBody;
    },
    TContext
  > => {
    const mutationKey = [
      'updateCandidateApiV1RecruitingCandidatesCandidateIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateCandidateApiV1RecruitingCandidatesCandidateIdPut
        >
      >,
      {
        candidateId: string;
        data: UpdateCandidateApiV1RecruitingCandidatesCandidateIdPutBody;
      }
    > = (props) => {
      const { candidateId, data } = props ?? {};

      return updateCandidateApiV1RecruitingCandidatesCandidateIdPut(
        candidateId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateCandidateApiV1RecruitingCandidatesCandidateIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateCandidateApiV1RecruitingCandidatesCandidateIdPut>
    >
  >;
export type UpdateCandidateApiV1RecruitingCandidatesCandidateIdPutMutationBody =
  UpdateCandidateApiV1RecruitingCandidatesCandidateIdPutBody;
export type UpdateCandidateApiV1RecruitingCandidatesCandidateIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Candidate
 */
export const useUpdateCandidateApiV1RecruitingCandidatesCandidateIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateCandidateApiV1RecruitingCandidatesCandidateIdPut
        >
      >,
      TError,
      {
        candidateId: string;
        data: UpdateCandidateApiV1RecruitingCandidatesCandidateIdPutBody;
      },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateCandidateApiV1RecruitingCandidatesCandidateIdPut>
  >,
  TError,
  {
    candidateId: string;
    data: UpdateCandidateApiV1RecruitingCandidatesCandidateIdPutBody;
  },
  TContext
> => {
  const mutationOptions =
    getUpdateCandidateApiV1RecruitingCandidatesCandidateIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a candidate.
 * @summary Delete Candidate
 */
export const deleteCandidateApiV1RecruitingCandidatesCandidateIdDelete = (
  candidateId: string
) => {
  return customInstance<void>({
    url: `/api/v1/recruiting/candidates/${candidateId}`,
    method: 'DELETE'
  });
};

export const getDeleteCandidateApiV1RecruitingCandidatesCandidateIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteCandidateApiV1RecruitingCandidatesCandidateIdDelete
        >
      >,
      TError,
      { candidateId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteCandidateApiV1RecruitingCandidatesCandidateIdDelete
      >
    >,
    TError,
    { candidateId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteCandidateApiV1RecruitingCandidatesCandidateIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteCandidateApiV1RecruitingCandidatesCandidateIdDelete
        >
      >,
      { candidateId: string }
    > = (props) => {
      const { candidateId } = props ?? {};

      return deleteCandidateApiV1RecruitingCandidatesCandidateIdDelete(
        candidateId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteCandidateApiV1RecruitingCandidatesCandidateIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteCandidateApiV1RecruitingCandidatesCandidateIdDelete
      >
    >
  >;

export type DeleteCandidateApiV1RecruitingCandidatesCandidateIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Candidate
 */
export const useDeleteCandidateApiV1RecruitingCandidatesCandidateIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteCandidateApiV1RecruitingCandidatesCandidateIdDelete
        >
      >,
      TError,
      { candidateId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof deleteCandidateApiV1RecruitingCandidatesCandidateIdDelete>
  >,
  TError,
  { candidateId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteCandidateApiV1RecruitingCandidatesCandidateIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * List all applications with optional filters.
 * @summary List Applications
 */
export const listApplicationsApiV1RecruitingApplicationsGet = (
  params?: ListApplicationsApiV1RecruitingApplicationsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/applications`,
    method: 'GET',
    params,
    signal
  });
};

export const getListApplicationsApiV1RecruitingApplicationsGetQueryKey = (
  params?: ListApplicationsApiV1RecruitingApplicationsGetParams
) => {
  return [
    `/api/v1/recruiting/applications`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListApplicationsApiV1RecruitingApplicationsGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listApplicationsApiV1RecruitingApplicationsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListApplicationsApiV1RecruitingApplicationsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listApplicationsApiV1RecruitingApplicationsGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListApplicationsApiV1RecruitingApplicationsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listApplicationsApiV1RecruitingApplicationsGet>>
  > = ({ signal }) =>
    listApplicationsApiV1RecruitingApplicationsGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listApplicationsApiV1RecruitingApplicationsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListApplicationsApiV1RecruitingApplicationsGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listApplicationsApiV1RecruitingApplicationsGet>>
  >;
export type ListApplicationsApiV1RecruitingApplicationsGetQueryError =
  HTTPValidationError;

export function useListApplicationsApiV1RecruitingApplicationsGet<
  TData = Awaited<
    ReturnType<typeof listApplicationsApiV1RecruitingApplicationsGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListApplicationsApiV1RecruitingApplicationsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listApplicationsApiV1RecruitingApplicationsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listApplicationsApiV1RecruitingApplicationsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listApplicationsApiV1RecruitingApplicationsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListApplicationsApiV1RecruitingApplicationsGet<
  TData = Awaited<
    ReturnType<typeof listApplicationsApiV1RecruitingApplicationsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListApplicationsApiV1RecruitingApplicationsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listApplicationsApiV1RecruitingApplicationsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listApplicationsApiV1RecruitingApplicationsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listApplicationsApiV1RecruitingApplicationsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListApplicationsApiV1RecruitingApplicationsGet<
  TData = Awaited<
    ReturnType<typeof listApplicationsApiV1RecruitingApplicationsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListApplicationsApiV1RecruitingApplicationsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listApplicationsApiV1RecruitingApplicationsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Applications
 */

export function useListApplicationsApiV1RecruitingApplicationsGet<
  TData = Awaited<
    ReturnType<typeof listApplicationsApiV1RecruitingApplicationsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListApplicationsApiV1RecruitingApplicationsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listApplicationsApiV1RecruitingApplicationsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListApplicationsApiV1RecruitingApplicationsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new application.
 * @summary Create Application
 */
export const createApplicationApiV1RecruitingApplicationsPost = (
  createApplicationApiV1RecruitingApplicationsPostBody: CreateApplicationApiV1RecruitingApplicationsPostBody,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/applications`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createApplicationApiV1RecruitingApplicationsPostBody,
    signal
  });
};

export const getCreateApplicationApiV1RecruitingApplicationsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createApplicationApiV1RecruitingApplicationsPost>
      >,
      TError,
      { data: CreateApplicationApiV1RecruitingApplicationsPostBody },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createApplicationApiV1RecruitingApplicationsPost>
    >,
    TError,
    { data: CreateApplicationApiV1RecruitingApplicationsPostBody },
    TContext
  > => {
    const mutationKey = ['createApplicationApiV1RecruitingApplicationsPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createApplicationApiV1RecruitingApplicationsPost>
      >,
      { data: CreateApplicationApiV1RecruitingApplicationsPostBody }
    > = (props) => {
      const { data } = props ?? {};

      return createApplicationApiV1RecruitingApplicationsPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateApplicationApiV1RecruitingApplicationsPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createApplicationApiV1RecruitingApplicationsPost>>
  >;
export type CreateApplicationApiV1RecruitingApplicationsPostMutationBody =
  CreateApplicationApiV1RecruitingApplicationsPostBody;
export type CreateApplicationApiV1RecruitingApplicationsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Application
 */
export const useCreateApplicationApiV1RecruitingApplicationsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createApplicationApiV1RecruitingApplicationsPost>
      >,
      TError,
      { data: CreateApplicationApiV1RecruitingApplicationsPostBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createApplicationApiV1RecruitingApplicationsPost>>,
  TError,
  { data: CreateApplicationApiV1RecruitingApplicationsPostBody },
  TContext
> => {
  const mutationOptions =
    getCreateApplicationApiV1RecruitingApplicationsPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * List applications for a job posting.
 * @summary List Applications By Job
 */
export const listApplicationsByJobApiV1RecruitingJobsJobIdApplicationsGet = (
  jobId: string,
  params?: ListApplicationsByJobApiV1RecruitingJobsJobIdApplicationsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/jobs/${jobId}/applications`,
    method: 'GET',
    params,
    signal
  });
};

export const getListApplicationsByJobApiV1RecruitingJobsJobIdApplicationsGetQueryKey =
  (
    jobId?: string,
    params?: ListApplicationsByJobApiV1RecruitingJobsJobIdApplicationsGetParams
  ) => {
    return [
      `/api/v1/recruiting/jobs/${jobId}/applications`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListApplicationsByJobApiV1RecruitingJobsJobIdApplicationsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listApplicationsByJobApiV1RecruitingJobsJobIdApplicationsGet
      >
    >,
    TError = HTTPValidationError
  >(
    jobId: string,
    params?: ListApplicationsByJobApiV1RecruitingJobsJobIdApplicationsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listApplicationsByJobApiV1RecruitingJobsJobIdApplicationsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListApplicationsByJobApiV1RecruitingJobsJobIdApplicationsGetQueryKey(
        jobId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listApplicationsByJobApiV1RecruitingJobsJobIdApplicationsGet
        >
      >
    > = ({ signal }) =>
      listApplicationsByJobApiV1RecruitingJobsJobIdApplicationsGet(
        jobId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!jobId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listApplicationsByJobApiV1RecruitingJobsJobIdApplicationsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListApplicationsByJobApiV1RecruitingJobsJobIdApplicationsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listApplicationsByJobApiV1RecruitingJobsJobIdApplicationsGet
      >
    >
  >;
export type ListApplicationsByJobApiV1RecruitingJobsJobIdApplicationsGetQueryError =
  HTTPValidationError;

export function useListApplicationsByJobApiV1RecruitingJobsJobIdApplicationsGet<
  TData = Awaited<
    ReturnType<
      typeof listApplicationsByJobApiV1RecruitingJobsJobIdApplicationsGet
    >
  >,
  TError = HTTPValidationError
>(
  jobId: string,
  params:
    | undefined
    | ListApplicationsByJobApiV1RecruitingJobsJobIdApplicationsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listApplicationsByJobApiV1RecruitingJobsJobIdApplicationsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listApplicationsByJobApiV1RecruitingJobsJobIdApplicationsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listApplicationsByJobApiV1RecruitingJobsJobIdApplicationsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListApplicationsByJobApiV1RecruitingJobsJobIdApplicationsGet<
  TData = Awaited<
    ReturnType<
      typeof listApplicationsByJobApiV1RecruitingJobsJobIdApplicationsGet
    >
  >,
  TError = HTTPValidationError
>(
  jobId: string,
  params?: ListApplicationsByJobApiV1RecruitingJobsJobIdApplicationsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listApplicationsByJobApiV1RecruitingJobsJobIdApplicationsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listApplicationsByJobApiV1RecruitingJobsJobIdApplicationsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listApplicationsByJobApiV1RecruitingJobsJobIdApplicationsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListApplicationsByJobApiV1RecruitingJobsJobIdApplicationsGet<
  TData = Awaited<
    ReturnType<
      typeof listApplicationsByJobApiV1RecruitingJobsJobIdApplicationsGet
    >
  >,
  TError = HTTPValidationError
>(
  jobId: string,
  params?: ListApplicationsByJobApiV1RecruitingJobsJobIdApplicationsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listApplicationsByJobApiV1RecruitingJobsJobIdApplicationsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Applications By Job
 */

export function useListApplicationsByJobApiV1RecruitingJobsJobIdApplicationsGet<
  TData = Awaited<
    ReturnType<
      typeof listApplicationsByJobApiV1RecruitingJobsJobIdApplicationsGet
    >
  >,
  TError = HTTPValidationError
>(
  jobId: string,
  params?: ListApplicationsByJobApiV1RecruitingJobsJobIdApplicationsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listApplicationsByJobApiV1RecruitingJobsJobIdApplicationsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListApplicationsByJobApiV1RecruitingJobsJobIdApplicationsGetQueryOptions(
      jobId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List a candidate's applications to jobs THIS caller may see.

The candidate gate below is the NEAR side and is structurally vacuous on its own —
the caller opened the candidate by construction. The far side is each row's job,
bounded in the query by ``accessible_job_ids_set`` exactly like the sibling
``/applications`` list, so the ``total`` beside the rows counts the same set.
 * @summary List Applications By Candidate
 */
export const listApplicationsByCandidateApiV1RecruitingCandidatesCandidateIdApplicationsGet =
  (
    candidateId: string,
    params?: ListApplicationsByCandidateApiV1RecruitingCandidatesCandidateIdApplicationsGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<RecruitingCandidateApplicationsResponse>({
      url: `/api/v1/recruiting/candidates/${candidateId}/applications`,
      method: 'GET',
      params,
      signal
    });
  };

export const getListApplicationsByCandidateApiV1RecruitingCandidatesCandidateIdApplicationsGetQueryKey =
  (
    candidateId?: string,
    params?: ListApplicationsByCandidateApiV1RecruitingCandidatesCandidateIdApplicationsGetParams
  ) => {
    return [
      `/api/v1/recruiting/candidates/${candidateId}/applications`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListApplicationsByCandidateApiV1RecruitingCandidatesCandidateIdApplicationsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listApplicationsByCandidateApiV1RecruitingCandidatesCandidateIdApplicationsGet
      >
    >,
    TError = HTTPValidationError
  >(
    candidateId: string,
    params?: ListApplicationsByCandidateApiV1RecruitingCandidatesCandidateIdApplicationsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listApplicationsByCandidateApiV1RecruitingCandidatesCandidateIdApplicationsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListApplicationsByCandidateApiV1RecruitingCandidatesCandidateIdApplicationsGetQueryKey(
        candidateId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listApplicationsByCandidateApiV1RecruitingCandidatesCandidateIdApplicationsGet
        >
      >
    > = ({ signal }) =>
      listApplicationsByCandidateApiV1RecruitingCandidatesCandidateIdApplicationsGet(
        candidateId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!candidateId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listApplicationsByCandidateApiV1RecruitingCandidatesCandidateIdApplicationsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListApplicationsByCandidateApiV1RecruitingCandidatesCandidateIdApplicationsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listApplicationsByCandidateApiV1RecruitingCandidatesCandidateIdApplicationsGet
      >
    >
  >;
export type ListApplicationsByCandidateApiV1RecruitingCandidatesCandidateIdApplicationsGetQueryError =
  HTTPValidationError;

export function useListApplicationsByCandidateApiV1RecruitingCandidatesCandidateIdApplicationsGet<
  TData = Awaited<
    ReturnType<
      typeof listApplicationsByCandidateApiV1RecruitingCandidatesCandidateIdApplicationsGet
    >
  >,
  TError = HTTPValidationError
>(
  candidateId: string,
  params:
    | undefined
    | ListApplicationsByCandidateApiV1RecruitingCandidatesCandidateIdApplicationsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listApplicationsByCandidateApiV1RecruitingCandidatesCandidateIdApplicationsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listApplicationsByCandidateApiV1RecruitingCandidatesCandidateIdApplicationsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listApplicationsByCandidateApiV1RecruitingCandidatesCandidateIdApplicationsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListApplicationsByCandidateApiV1RecruitingCandidatesCandidateIdApplicationsGet<
  TData = Awaited<
    ReturnType<
      typeof listApplicationsByCandidateApiV1RecruitingCandidatesCandidateIdApplicationsGet
    >
  >,
  TError = HTTPValidationError
>(
  candidateId: string,
  params?: ListApplicationsByCandidateApiV1RecruitingCandidatesCandidateIdApplicationsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listApplicationsByCandidateApiV1RecruitingCandidatesCandidateIdApplicationsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listApplicationsByCandidateApiV1RecruitingCandidatesCandidateIdApplicationsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listApplicationsByCandidateApiV1RecruitingCandidatesCandidateIdApplicationsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListApplicationsByCandidateApiV1RecruitingCandidatesCandidateIdApplicationsGet<
  TData = Awaited<
    ReturnType<
      typeof listApplicationsByCandidateApiV1RecruitingCandidatesCandidateIdApplicationsGet
    >
  >,
  TError = HTTPValidationError
>(
  candidateId: string,
  params?: ListApplicationsByCandidateApiV1RecruitingCandidatesCandidateIdApplicationsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listApplicationsByCandidateApiV1RecruitingCandidatesCandidateIdApplicationsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Applications By Candidate
 */

export function useListApplicationsByCandidateApiV1RecruitingCandidatesCandidateIdApplicationsGet<
  TData = Awaited<
    ReturnType<
      typeof listApplicationsByCandidateApiV1RecruitingCandidatesCandidateIdApplicationsGet
    >
  >,
  TError = HTTPValidationError
>(
  candidateId: string,
  params?: ListApplicationsByCandidateApiV1RecruitingCandidatesCandidateIdApplicationsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listApplicationsByCandidateApiV1RecruitingCandidatesCandidateIdApplicationsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListApplicationsByCandidateApiV1RecruitingCandidatesCandidateIdApplicationsGetQueryOptions(
      candidateId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get an application by ID.
 * @summary Get Application
 */
export const getApplicationApiV1RecruitingApplicationsApplicationIdGet = (
  applicationId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/applications/${applicationId}`,
    method: 'GET',
    signal
  });
};

export const getGetApplicationApiV1RecruitingApplicationsApplicationIdGetQueryKey =
  (applicationId?: string) => {
    return [`/api/v1/recruiting/applications/${applicationId}`] as const;
  };

export const getGetApplicationApiV1RecruitingApplicationsApplicationIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getApplicationApiV1RecruitingApplicationsApplicationIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    applicationId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getApplicationApiV1RecruitingApplicationsApplicationIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetApplicationApiV1RecruitingApplicationsApplicationIdGetQueryKey(
        applicationId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getApplicationApiV1RecruitingApplicationsApplicationIdGet
        >
      >
    > = ({ signal }) =>
      getApplicationApiV1RecruitingApplicationsApplicationIdGet(
        applicationId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!applicationId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getApplicationApiV1RecruitingApplicationsApplicationIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetApplicationApiV1RecruitingApplicationsApplicationIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getApplicationApiV1RecruitingApplicationsApplicationIdGet
      >
    >
  >;
export type GetApplicationApiV1RecruitingApplicationsApplicationIdGetQueryError =
  HTTPValidationError;

export function useGetApplicationApiV1RecruitingApplicationsApplicationIdGet<
  TData = Awaited<
    ReturnType<typeof getApplicationApiV1RecruitingApplicationsApplicationIdGet>
  >,
  TError = HTTPValidationError
>(
  applicationId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApplicationApiV1RecruitingApplicationsApplicationIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getApplicationApiV1RecruitingApplicationsApplicationIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getApplicationApiV1RecruitingApplicationsApplicationIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetApplicationApiV1RecruitingApplicationsApplicationIdGet<
  TData = Awaited<
    ReturnType<typeof getApplicationApiV1RecruitingApplicationsApplicationIdGet>
  >,
  TError = HTTPValidationError
>(
  applicationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApplicationApiV1RecruitingApplicationsApplicationIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getApplicationApiV1RecruitingApplicationsApplicationIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getApplicationApiV1RecruitingApplicationsApplicationIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApplicationApiV1RecruitingApplicationsApplicationIdGet<
  TData = Awaited<
    ReturnType<typeof getApplicationApiV1RecruitingApplicationsApplicationIdGet>
  >,
  TError = HTTPValidationError
>(
  applicationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApplicationApiV1RecruitingApplicationsApplicationIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Application
 */

export function useGetApplicationApiV1RecruitingApplicationsApplicationIdGet<
  TData = Awaited<
    ReturnType<typeof getApplicationApiV1RecruitingApplicationsApplicationIdGet>
  >,
  TError = HTTPValidationError
>(
  applicationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApplicationApiV1RecruitingApplicationsApplicationIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetApplicationApiV1RecruitingApplicationsApplicationIdGetQueryOptions(
      applicationId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Move multiple applications to a stage.
 * @summary Bulk Move Applications
 */
export const bulkMoveApplicationsApiV1RecruitingApplicationsBulkMovePost = (
  bulkMoveRequest: BulkMoveRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/applications/bulk/move`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: bulkMoveRequest,
    signal
  });
};

export const getBulkMoveApplicationsApiV1RecruitingApplicationsBulkMovePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof bulkMoveApplicationsApiV1RecruitingApplicationsBulkMovePost
        >
      >,
      TError,
      { data: BulkMoveRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof bulkMoveApplicationsApiV1RecruitingApplicationsBulkMovePost
      >
    >,
    TError,
    { data: BulkMoveRequest },
    TContext
  > => {
    const mutationKey = [
      'bulkMoveApplicationsApiV1RecruitingApplicationsBulkMovePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof bulkMoveApplicationsApiV1RecruitingApplicationsBulkMovePost
        >
      >,
      { data: BulkMoveRequest }
    > = (props) => {
      const { data } = props ?? {};

      return bulkMoveApplicationsApiV1RecruitingApplicationsBulkMovePost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type BulkMoveApplicationsApiV1RecruitingApplicationsBulkMovePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof bulkMoveApplicationsApiV1RecruitingApplicationsBulkMovePost
      >
    >
  >;
export type BulkMoveApplicationsApiV1RecruitingApplicationsBulkMovePostMutationBody =
  BulkMoveRequest;
export type BulkMoveApplicationsApiV1RecruitingApplicationsBulkMovePostMutationError =
  HTTPValidationError;

/**
 * @summary Bulk Move Applications
 */
export const useBulkMoveApplicationsApiV1RecruitingApplicationsBulkMovePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof bulkMoveApplicationsApiV1RecruitingApplicationsBulkMovePost
        >
      >,
      TError,
      { data: BulkMoveRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof bulkMoveApplicationsApiV1RecruitingApplicationsBulkMovePost
    >
  >,
  TError,
  { data: BulkMoveRequest },
  TContext
> => {
  const mutationOptions =
    getBulkMoveApplicationsApiV1RecruitingApplicationsBulkMovePostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Reject multiple applications.
 * @summary Bulk Reject Applications
 */
export const bulkRejectApplicationsApiV1RecruitingApplicationsBulkRejectPost = (
  bulkRejectRequest: BulkRejectRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/applications/bulk/reject`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: bulkRejectRequest,
    signal
  });
};

export const getBulkRejectApplicationsApiV1RecruitingApplicationsBulkRejectPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof bulkRejectApplicationsApiV1RecruitingApplicationsBulkRejectPost
        >
      >,
      TError,
      { data: BulkRejectRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof bulkRejectApplicationsApiV1RecruitingApplicationsBulkRejectPost
      >
    >,
    TError,
    { data: BulkRejectRequest },
    TContext
  > => {
    const mutationKey = [
      'bulkRejectApplicationsApiV1RecruitingApplicationsBulkRejectPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof bulkRejectApplicationsApiV1RecruitingApplicationsBulkRejectPost
        >
      >,
      { data: BulkRejectRequest }
    > = (props) => {
      const { data } = props ?? {};

      return bulkRejectApplicationsApiV1RecruitingApplicationsBulkRejectPost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type BulkRejectApplicationsApiV1RecruitingApplicationsBulkRejectPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof bulkRejectApplicationsApiV1RecruitingApplicationsBulkRejectPost
      >
    >
  >;
export type BulkRejectApplicationsApiV1RecruitingApplicationsBulkRejectPostMutationBody =
  BulkRejectRequest;
export type BulkRejectApplicationsApiV1RecruitingApplicationsBulkRejectPostMutationError =
  HTTPValidationError;

/**
 * @summary Bulk Reject Applications
 */
export const useBulkRejectApplicationsApiV1RecruitingApplicationsBulkRejectPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof bulkRejectApplicationsApiV1RecruitingApplicationsBulkRejectPost
          >
        >,
        TError,
        { data: BulkRejectRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof bulkRejectApplicationsApiV1RecruitingApplicationsBulkRejectPost
      >
    >,
    TError,
    { data: BulkRejectRequest },
    TContext
  > => {
    const mutationOptions =
      getBulkRejectApplicationsApiV1RecruitingApplicationsBulkRejectPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Move an application to a new stage.
 * @summary Move Application
 */
export const moveApplicationApiV1RecruitingApplicationsApplicationIdMovePost = (
  applicationId: string,
  moveApplicationApiV1RecruitingApplicationsApplicationIdMovePostBody: MoveApplicationApiV1RecruitingApplicationsApplicationIdMovePostBody,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/applications/${applicationId}/move`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: moveApplicationApiV1RecruitingApplicationsApplicationIdMovePostBody,
    signal
  });
};

export const getMoveApplicationApiV1RecruitingApplicationsApplicationIdMovePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof moveApplicationApiV1RecruitingApplicationsApplicationIdMovePost
        >
      >,
      TError,
      {
        applicationId: string;
        data: MoveApplicationApiV1RecruitingApplicationsApplicationIdMovePostBody;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof moveApplicationApiV1RecruitingApplicationsApplicationIdMovePost
      >
    >,
    TError,
    {
      applicationId: string;
      data: MoveApplicationApiV1RecruitingApplicationsApplicationIdMovePostBody;
    },
    TContext
  > => {
    const mutationKey = [
      'moveApplicationApiV1RecruitingApplicationsApplicationIdMovePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof moveApplicationApiV1RecruitingApplicationsApplicationIdMovePost
        >
      >,
      {
        applicationId: string;
        data: MoveApplicationApiV1RecruitingApplicationsApplicationIdMovePostBody;
      }
    > = (props) => {
      const { applicationId, data } = props ?? {};

      return moveApplicationApiV1RecruitingApplicationsApplicationIdMovePost(
        applicationId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type MoveApplicationApiV1RecruitingApplicationsApplicationIdMovePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof moveApplicationApiV1RecruitingApplicationsApplicationIdMovePost
      >
    >
  >;
export type MoveApplicationApiV1RecruitingApplicationsApplicationIdMovePostMutationBody =
  MoveApplicationApiV1RecruitingApplicationsApplicationIdMovePostBody;
export type MoveApplicationApiV1RecruitingApplicationsApplicationIdMovePostMutationError =
  HTTPValidationError;

/**
 * @summary Move Application
 */
export const useMoveApplicationApiV1RecruitingApplicationsApplicationIdMovePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof moveApplicationApiV1RecruitingApplicationsApplicationIdMovePost
          >
        >,
        TError,
        {
          applicationId: string;
          data: MoveApplicationApiV1RecruitingApplicationsApplicationIdMovePostBody;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof moveApplicationApiV1RecruitingApplicationsApplicationIdMovePost
      >
    >,
    TError,
    {
      applicationId: string;
      data: MoveApplicationApiV1RecruitingApplicationsApplicationIdMovePostBody;
    },
    TContext
  > => {
    const mutationOptions =
      getMoveApplicationApiV1RecruitingApplicationsApplicationIdMovePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Reject an application.
 * @summary Reject Application
 */
export const rejectApplicationApiV1RecruitingApplicationsApplicationIdRejectPost =
  (
    applicationId: string,
    rejectApplicationApiV1RecruitingApplicationsApplicationIdRejectPostBody: RejectApplicationApiV1RecruitingApplicationsApplicationIdRejectPostBody,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/recruiting/applications/${applicationId}/reject`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: rejectApplicationApiV1RecruitingApplicationsApplicationIdRejectPostBody,
      signal
    });
  };

export const getRejectApplicationApiV1RecruitingApplicationsApplicationIdRejectPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof rejectApplicationApiV1RecruitingApplicationsApplicationIdRejectPost
        >
      >,
      TError,
      {
        applicationId: string;
        data: RejectApplicationApiV1RecruitingApplicationsApplicationIdRejectPostBody;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof rejectApplicationApiV1RecruitingApplicationsApplicationIdRejectPost
      >
    >,
    TError,
    {
      applicationId: string;
      data: RejectApplicationApiV1RecruitingApplicationsApplicationIdRejectPostBody;
    },
    TContext
  > => {
    const mutationKey = [
      'rejectApplicationApiV1RecruitingApplicationsApplicationIdRejectPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof rejectApplicationApiV1RecruitingApplicationsApplicationIdRejectPost
        >
      >,
      {
        applicationId: string;
        data: RejectApplicationApiV1RecruitingApplicationsApplicationIdRejectPostBody;
      }
    > = (props) => {
      const { applicationId, data } = props ?? {};

      return rejectApplicationApiV1RecruitingApplicationsApplicationIdRejectPost(
        applicationId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RejectApplicationApiV1RecruitingApplicationsApplicationIdRejectPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof rejectApplicationApiV1RecruitingApplicationsApplicationIdRejectPost
      >
    >
  >;
export type RejectApplicationApiV1RecruitingApplicationsApplicationIdRejectPostMutationBody =
  RejectApplicationApiV1RecruitingApplicationsApplicationIdRejectPostBody;
export type RejectApplicationApiV1RecruitingApplicationsApplicationIdRejectPostMutationError =
  HTTPValidationError;

/**
 * @summary Reject Application
 */
export const useRejectApplicationApiV1RecruitingApplicationsApplicationIdRejectPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof rejectApplicationApiV1RecruitingApplicationsApplicationIdRejectPost
          >
        >,
        TError,
        {
          applicationId: string;
          data: RejectApplicationApiV1RecruitingApplicationsApplicationIdRejectPostBody;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof rejectApplicationApiV1RecruitingApplicationsApplicationIdRejectPost
      >
    >,
    TError,
    {
      applicationId: string;
      data: RejectApplicationApiV1RecruitingApplicationsApplicationIdRejectPostBody;
    },
    TContext
  > => {
    const mutationOptions =
      getRejectApplicationApiV1RecruitingApplicationsApplicationIdRejectPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Mark an application as hired.
 * @summary Hire Application
 */
export const hireApplicationApiV1RecruitingApplicationsApplicationIdHirePost = (
  applicationId: string,
  hireApplicationApiV1RecruitingApplicationsApplicationIdHirePostBody: HireApplicationApiV1RecruitingApplicationsApplicationIdHirePostBody,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/applications/${applicationId}/hire`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: hireApplicationApiV1RecruitingApplicationsApplicationIdHirePostBody,
    signal
  });
};

export const getHireApplicationApiV1RecruitingApplicationsApplicationIdHirePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof hireApplicationApiV1RecruitingApplicationsApplicationIdHirePost
        >
      >,
      TError,
      {
        applicationId: string;
        data: HireApplicationApiV1RecruitingApplicationsApplicationIdHirePostBody;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof hireApplicationApiV1RecruitingApplicationsApplicationIdHirePost
      >
    >,
    TError,
    {
      applicationId: string;
      data: HireApplicationApiV1RecruitingApplicationsApplicationIdHirePostBody;
    },
    TContext
  > => {
    const mutationKey = [
      'hireApplicationApiV1RecruitingApplicationsApplicationIdHirePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof hireApplicationApiV1RecruitingApplicationsApplicationIdHirePost
        >
      >,
      {
        applicationId: string;
        data: HireApplicationApiV1RecruitingApplicationsApplicationIdHirePostBody;
      }
    > = (props) => {
      const { applicationId, data } = props ?? {};

      return hireApplicationApiV1RecruitingApplicationsApplicationIdHirePost(
        applicationId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type HireApplicationApiV1RecruitingApplicationsApplicationIdHirePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof hireApplicationApiV1RecruitingApplicationsApplicationIdHirePost
      >
    >
  >;
export type HireApplicationApiV1RecruitingApplicationsApplicationIdHirePostMutationBody =
  HireApplicationApiV1RecruitingApplicationsApplicationIdHirePostBody;
export type HireApplicationApiV1RecruitingApplicationsApplicationIdHirePostMutationError =
  HTTPValidationError;

/**
 * @summary Hire Application
 */
export const useHireApplicationApiV1RecruitingApplicationsApplicationIdHirePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof hireApplicationApiV1RecruitingApplicationsApplicationIdHirePost
          >
        >,
        TError,
        {
          applicationId: string;
          data: HireApplicationApiV1RecruitingApplicationsApplicationIdHirePostBody;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof hireApplicationApiV1RecruitingApplicationsApplicationIdHirePost
      >
    >,
    TError,
    {
      applicationId: string;
      data: HireApplicationApiV1RecruitingApplicationsApplicationIdHirePostBody;
    },
    TContext
  > => {
    const mutationOptions =
      getHireApplicationApiV1RecruitingApplicationsApplicationIdHirePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Withdraw an application.
 * @summary Withdraw Application
 */
export const withdrawApplicationApiV1RecruitingApplicationsApplicationIdWithdrawPost =
  (applicationId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/recruiting/applications/${applicationId}/withdraw`,
      method: 'POST',
      signal
    });
  };

export const getWithdrawApplicationApiV1RecruitingApplicationsApplicationIdWithdrawPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof withdrawApplicationApiV1RecruitingApplicationsApplicationIdWithdrawPost
        >
      >,
      TError,
      { applicationId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof withdrawApplicationApiV1RecruitingApplicationsApplicationIdWithdrawPost
      >
    >,
    TError,
    { applicationId: string },
    TContext
  > => {
    const mutationKey = [
      'withdrawApplicationApiV1RecruitingApplicationsApplicationIdWithdrawPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof withdrawApplicationApiV1RecruitingApplicationsApplicationIdWithdrawPost
        >
      >,
      { applicationId: string }
    > = (props) => {
      const { applicationId } = props ?? {};

      return withdrawApplicationApiV1RecruitingApplicationsApplicationIdWithdrawPost(
        applicationId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type WithdrawApplicationApiV1RecruitingApplicationsApplicationIdWithdrawPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof withdrawApplicationApiV1RecruitingApplicationsApplicationIdWithdrawPost
      >
    >
  >;

export type WithdrawApplicationApiV1RecruitingApplicationsApplicationIdWithdrawPostMutationError =
  HTTPValidationError;

/**
 * @summary Withdraw Application
 */
export const useWithdrawApplicationApiV1RecruitingApplicationsApplicationIdWithdrawPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof withdrawApplicationApiV1RecruitingApplicationsApplicationIdWithdrawPost
          >
        >,
        TError,
        { applicationId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof withdrawApplicationApiV1RecruitingApplicationsApplicationIdWithdrawPost
      >
    >,
    TError,
    { applicationId: string },
    TContext
  > => {
    const mutationOptions =
      getWithdrawApplicationApiV1RecruitingApplicationsApplicationIdWithdrawPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Get activity timeline for an application.
 * @summary Get Application Timeline
 */
export const getApplicationTimelineApiV1RecruitingApplicationsApplicationIdTimelineGet =
  (applicationId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/recruiting/applications/${applicationId}/timeline`,
      method: 'GET',
      signal
    });
  };

export const getGetApplicationTimelineApiV1RecruitingApplicationsApplicationIdTimelineGetQueryKey =
  (applicationId?: string) => {
    return [
      `/api/v1/recruiting/applications/${applicationId}/timeline`
    ] as const;
  };

export const getGetApplicationTimelineApiV1RecruitingApplicationsApplicationIdTimelineGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getApplicationTimelineApiV1RecruitingApplicationsApplicationIdTimelineGet
      >
    >,
    TError = HTTPValidationError
  >(
    applicationId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getApplicationTimelineApiV1RecruitingApplicationsApplicationIdTimelineGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetApplicationTimelineApiV1RecruitingApplicationsApplicationIdTimelineGetQueryKey(
        applicationId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getApplicationTimelineApiV1RecruitingApplicationsApplicationIdTimelineGet
        >
      >
    > = ({ signal }) =>
      getApplicationTimelineApiV1RecruitingApplicationsApplicationIdTimelineGet(
        applicationId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!applicationId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getApplicationTimelineApiV1RecruitingApplicationsApplicationIdTimelineGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetApplicationTimelineApiV1RecruitingApplicationsApplicationIdTimelineGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getApplicationTimelineApiV1RecruitingApplicationsApplicationIdTimelineGet
      >
    >
  >;
export type GetApplicationTimelineApiV1RecruitingApplicationsApplicationIdTimelineGetQueryError =
  HTTPValidationError;

export function useGetApplicationTimelineApiV1RecruitingApplicationsApplicationIdTimelineGet<
  TData = Awaited<
    ReturnType<
      typeof getApplicationTimelineApiV1RecruitingApplicationsApplicationIdTimelineGet
    >
  >,
  TError = HTTPValidationError
>(
  applicationId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApplicationTimelineApiV1RecruitingApplicationsApplicationIdTimelineGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getApplicationTimelineApiV1RecruitingApplicationsApplicationIdTimelineGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getApplicationTimelineApiV1RecruitingApplicationsApplicationIdTimelineGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetApplicationTimelineApiV1RecruitingApplicationsApplicationIdTimelineGet<
  TData = Awaited<
    ReturnType<
      typeof getApplicationTimelineApiV1RecruitingApplicationsApplicationIdTimelineGet
    >
  >,
  TError = HTTPValidationError
>(
  applicationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApplicationTimelineApiV1RecruitingApplicationsApplicationIdTimelineGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getApplicationTimelineApiV1RecruitingApplicationsApplicationIdTimelineGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getApplicationTimelineApiV1RecruitingApplicationsApplicationIdTimelineGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetApplicationTimelineApiV1RecruitingApplicationsApplicationIdTimelineGet<
  TData = Awaited<
    ReturnType<
      typeof getApplicationTimelineApiV1RecruitingApplicationsApplicationIdTimelineGet
    >
  >,
  TError = HTTPValidationError
>(
  applicationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApplicationTimelineApiV1RecruitingApplicationsApplicationIdTimelineGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Application Timeline
 */

export function useGetApplicationTimelineApiV1RecruitingApplicationsApplicationIdTimelineGet<
  TData = Awaited<
    ReturnType<
      typeof getApplicationTimelineApiV1RecruitingApplicationsApplicationIdTimelineGet
    >
  >,
  TError = HTTPValidationError
>(
  applicationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApplicationTimelineApiV1RecruitingApplicationsApplicationIdTimelineGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetApplicationTimelineApiV1RecruitingApplicationsApplicationIdTimelineGetQueryOptions(
      applicationId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List active rejection reasons for the tenant.
 * @summary List Rejection Reasons
 */
export const listRejectionReasonsApiV1RecruitingRejectionReasonsGet = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/rejection-reasons`,
    method: 'GET',
    signal
  });
};

export const getListRejectionReasonsApiV1RecruitingRejectionReasonsGetQueryKey =
  () => {
    return [`/api/v1/recruiting/rejection-reasons`] as const;
  };

export const getListRejectionReasonsApiV1RecruitingRejectionReasonsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listRejectionReasonsApiV1RecruitingRejectionReasonsGet>
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listRejectionReasonsApiV1RecruitingRejectionReasonsGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListRejectionReasonsApiV1RecruitingRejectionReasonsGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listRejectionReasonsApiV1RecruitingRejectionReasonsGet
        >
      >
    > = ({ signal }) =>
      listRejectionReasonsApiV1RecruitingRejectionReasonsGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listRejectionReasonsApiV1RecruitingRejectionReasonsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListRejectionReasonsApiV1RecruitingRejectionReasonsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listRejectionReasonsApiV1RecruitingRejectionReasonsGet>
    >
  >;
export type ListRejectionReasonsApiV1RecruitingRejectionReasonsGetQueryError =
  unknown;

export function useListRejectionReasonsApiV1RecruitingRejectionReasonsGet<
  TData = Awaited<
    ReturnType<typeof listRejectionReasonsApiV1RecruitingRejectionReasonsGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listRejectionReasonsApiV1RecruitingRejectionReasonsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listRejectionReasonsApiV1RecruitingRejectionReasonsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listRejectionReasonsApiV1RecruitingRejectionReasonsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListRejectionReasonsApiV1RecruitingRejectionReasonsGet<
  TData = Awaited<
    ReturnType<typeof listRejectionReasonsApiV1RecruitingRejectionReasonsGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listRejectionReasonsApiV1RecruitingRejectionReasonsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listRejectionReasonsApiV1RecruitingRejectionReasonsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listRejectionReasonsApiV1RecruitingRejectionReasonsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListRejectionReasonsApiV1RecruitingRejectionReasonsGet<
  TData = Awaited<
    ReturnType<typeof listRejectionReasonsApiV1RecruitingRejectionReasonsGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listRejectionReasonsApiV1RecruitingRejectionReasonsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Rejection Reasons
 */

export function useListRejectionReasonsApiV1RecruitingRejectionReasonsGet<
  TData = Awaited<
    ReturnType<typeof listRejectionReasonsApiV1RecruitingRejectionReasonsGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listRejectionReasonsApiV1RecruitingRejectionReasonsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListRejectionReasonsApiV1RecruitingRejectionReasonsGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List activity timeline for a candidate.
 * @summary List Candidate Activities
 */
export const listCandidateActivitiesApiV1RecruitingCandidatesCandidateIdActivitiesGet =
  (candidateId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/recruiting/candidates/${candidateId}/activities`,
      method: 'GET',
      signal
    });
  };

export const getListCandidateActivitiesApiV1RecruitingCandidatesCandidateIdActivitiesGetQueryKey =
  (candidateId?: string) => {
    return [`/api/v1/recruiting/candidates/${candidateId}/activities`] as const;
  };

export const getListCandidateActivitiesApiV1RecruitingCandidatesCandidateIdActivitiesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listCandidateActivitiesApiV1RecruitingCandidatesCandidateIdActivitiesGet
      >
    >,
    TError = HTTPValidationError
  >(
    candidateId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listCandidateActivitiesApiV1RecruitingCandidatesCandidateIdActivitiesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListCandidateActivitiesApiV1RecruitingCandidatesCandidateIdActivitiesGetQueryKey(
        candidateId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listCandidateActivitiesApiV1RecruitingCandidatesCandidateIdActivitiesGet
        >
      >
    > = ({ signal }) =>
      listCandidateActivitiesApiV1RecruitingCandidatesCandidateIdActivitiesGet(
        candidateId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!candidateId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listCandidateActivitiesApiV1RecruitingCandidatesCandidateIdActivitiesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListCandidateActivitiesApiV1RecruitingCandidatesCandidateIdActivitiesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listCandidateActivitiesApiV1RecruitingCandidatesCandidateIdActivitiesGet
      >
    >
  >;
export type ListCandidateActivitiesApiV1RecruitingCandidatesCandidateIdActivitiesGetQueryError =
  HTTPValidationError;

export function useListCandidateActivitiesApiV1RecruitingCandidatesCandidateIdActivitiesGet<
  TData = Awaited<
    ReturnType<
      typeof listCandidateActivitiesApiV1RecruitingCandidatesCandidateIdActivitiesGet
    >
  >,
  TError = HTTPValidationError
>(
  candidateId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCandidateActivitiesApiV1RecruitingCandidatesCandidateIdActivitiesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listCandidateActivitiesApiV1RecruitingCandidatesCandidateIdActivitiesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listCandidateActivitiesApiV1RecruitingCandidatesCandidateIdActivitiesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListCandidateActivitiesApiV1RecruitingCandidatesCandidateIdActivitiesGet<
  TData = Awaited<
    ReturnType<
      typeof listCandidateActivitiesApiV1RecruitingCandidatesCandidateIdActivitiesGet
    >
  >,
  TError = HTTPValidationError
>(
  candidateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCandidateActivitiesApiV1RecruitingCandidatesCandidateIdActivitiesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listCandidateActivitiesApiV1RecruitingCandidatesCandidateIdActivitiesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listCandidateActivitiesApiV1RecruitingCandidatesCandidateIdActivitiesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListCandidateActivitiesApiV1RecruitingCandidatesCandidateIdActivitiesGet<
  TData = Awaited<
    ReturnType<
      typeof listCandidateActivitiesApiV1RecruitingCandidatesCandidateIdActivitiesGet
    >
  >,
  TError = HTTPValidationError
>(
  candidateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCandidateActivitiesApiV1RecruitingCandidatesCandidateIdActivitiesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Candidate Activities
 */

export function useListCandidateActivitiesApiV1RecruitingCandidatesCandidateIdActivitiesGet<
  TData = Awaited<
    ReturnType<
      typeof listCandidateActivitiesApiV1RecruitingCandidatesCandidateIdActivitiesGet
    >
  >,
  TError = HTTPValidationError
>(
  candidateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCandidateActivitiesApiV1RecruitingCandidatesCandidateIdActivitiesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListCandidateActivitiesApiV1RecruitingCandidatesCandidateIdActivitiesGetQueryOptions(
      candidateId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List interviews for an application.
 * @summary List Interviews
 */
export const listInterviewsApiV1RecruitingApplicationsApplicationIdInterviewsGet =
  (applicationId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/recruiting/applications/${applicationId}/interviews`,
      method: 'GET',
      signal
    });
  };

export const getListInterviewsApiV1RecruitingApplicationsApplicationIdInterviewsGetQueryKey =
  (applicationId?: string) => {
    return [
      `/api/v1/recruiting/applications/${applicationId}/interviews`
    ] as const;
  };

export const getListInterviewsApiV1RecruitingApplicationsApplicationIdInterviewsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listInterviewsApiV1RecruitingApplicationsApplicationIdInterviewsGet
      >
    >,
    TError = HTTPValidationError
  >(
    applicationId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listInterviewsApiV1RecruitingApplicationsApplicationIdInterviewsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListInterviewsApiV1RecruitingApplicationsApplicationIdInterviewsGetQueryKey(
        applicationId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listInterviewsApiV1RecruitingApplicationsApplicationIdInterviewsGet
        >
      >
    > = ({ signal }) =>
      listInterviewsApiV1RecruitingApplicationsApplicationIdInterviewsGet(
        applicationId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!applicationId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listInterviewsApiV1RecruitingApplicationsApplicationIdInterviewsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListInterviewsApiV1RecruitingApplicationsApplicationIdInterviewsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listInterviewsApiV1RecruitingApplicationsApplicationIdInterviewsGet
      >
    >
  >;
export type ListInterviewsApiV1RecruitingApplicationsApplicationIdInterviewsGetQueryError =
  HTTPValidationError;

export function useListInterviewsApiV1RecruitingApplicationsApplicationIdInterviewsGet<
  TData = Awaited<
    ReturnType<
      typeof listInterviewsApiV1RecruitingApplicationsApplicationIdInterviewsGet
    >
  >,
  TError = HTTPValidationError
>(
  applicationId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listInterviewsApiV1RecruitingApplicationsApplicationIdInterviewsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listInterviewsApiV1RecruitingApplicationsApplicationIdInterviewsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listInterviewsApiV1RecruitingApplicationsApplicationIdInterviewsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListInterviewsApiV1RecruitingApplicationsApplicationIdInterviewsGet<
  TData = Awaited<
    ReturnType<
      typeof listInterviewsApiV1RecruitingApplicationsApplicationIdInterviewsGet
    >
  >,
  TError = HTTPValidationError
>(
  applicationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listInterviewsApiV1RecruitingApplicationsApplicationIdInterviewsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listInterviewsApiV1RecruitingApplicationsApplicationIdInterviewsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listInterviewsApiV1RecruitingApplicationsApplicationIdInterviewsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListInterviewsApiV1RecruitingApplicationsApplicationIdInterviewsGet<
  TData = Awaited<
    ReturnType<
      typeof listInterviewsApiV1RecruitingApplicationsApplicationIdInterviewsGet
    >
  >,
  TError = HTTPValidationError
>(
  applicationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listInterviewsApiV1RecruitingApplicationsApplicationIdInterviewsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Interviews
 */

export function useListInterviewsApiV1RecruitingApplicationsApplicationIdInterviewsGet<
  TData = Awaited<
    ReturnType<
      typeof listInterviewsApiV1RecruitingApplicationsApplicationIdInterviewsGet
    >
  >,
  TError = HTTPValidationError
>(
  applicationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listInterviewsApiV1RecruitingApplicationsApplicationIdInterviewsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListInterviewsApiV1RecruitingApplicationsApplicationIdInterviewsGetQueryOptions(
      applicationId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Schedule a new interview with optional email invite.
 * @summary Create Interview
 */
export const createInterviewApiV1RecruitingApplicationsApplicationIdInterviewsPost =
  (
    applicationId: string,
    interviewCreateRequest: InterviewCreateRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/recruiting/applications/${applicationId}/interviews`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: interviewCreateRequest,
      signal
    });
  };

export const getCreateInterviewApiV1RecruitingApplicationsApplicationIdInterviewsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createInterviewApiV1RecruitingApplicationsApplicationIdInterviewsPost
        >
      >,
      TError,
      { applicationId: string; data: InterviewCreateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createInterviewApiV1RecruitingApplicationsApplicationIdInterviewsPost
      >
    >,
    TError,
    { applicationId: string; data: InterviewCreateRequest },
    TContext
  > => {
    const mutationKey = [
      'createInterviewApiV1RecruitingApplicationsApplicationIdInterviewsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createInterviewApiV1RecruitingApplicationsApplicationIdInterviewsPost
        >
      >,
      { applicationId: string; data: InterviewCreateRequest }
    > = (props) => {
      const { applicationId, data } = props ?? {};

      return createInterviewApiV1RecruitingApplicationsApplicationIdInterviewsPost(
        applicationId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateInterviewApiV1RecruitingApplicationsApplicationIdInterviewsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createInterviewApiV1RecruitingApplicationsApplicationIdInterviewsPost
      >
    >
  >;
export type CreateInterviewApiV1RecruitingApplicationsApplicationIdInterviewsPostMutationBody =
  InterviewCreateRequest;
export type CreateInterviewApiV1RecruitingApplicationsApplicationIdInterviewsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Interview
 */
export const useCreateInterviewApiV1RecruitingApplicationsApplicationIdInterviewsPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createInterviewApiV1RecruitingApplicationsApplicationIdInterviewsPost
          >
        >,
        TError,
        { applicationId: string; data: InterviewCreateRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createInterviewApiV1RecruitingApplicationsApplicationIdInterviewsPost
      >
    >,
    TError,
    { applicationId: string; data: InterviewCreateRequest },
    TContext
  > => {
    const mutationOptions =
      getCreateInterviewApiV1RecruitingApplicationsApplicationIdInterviewsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List upcoming interviews, optionally filtered by user.
 * @summary List Upcoming Interviews
 */
export const listUpcomingInterviewsApiV1RecruitingInterviewsUpcomingGet = (
  params?: ListUpcomingInterviewsApiV1RecruitingInterviewsUpcomingGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/interviews/upcoming`,
    method: 'GET',
    params,
    signal
  });
};

export const getListUpcomingInterviewsApiV1RecruitingInterviewsUpcomingGetQueryKey =
  (
    params?: ListUpcomingInterviewsApiV1RecruitingInterviewsUpcomingGetParams
  ) => {
    return [
      `/api/v1/recruiting/interviews/upcoming`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListUpcomingInterviewsApiV1RecruitingInterviewsUpcomingGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listUpcomingInterviewsApiV1RecruitingInterviewsUpcomingGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: ListUpcomingInterviewsApiV1RecruitingInterviewsUpcomingGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listUpcomingInterviewsApiV1RecruitingInterviewsUpcomingGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListUpcomingInterviewsApiV1RecruitingInterviewsUpcomingGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listUpcomingInterviewsApiV1RecruitingInterviewsUpcomingGet
        >
      >
    > = ({ signal }) =>
      listUpcomingInterviewsApiV1RecruitingInterviewsUpcomingGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listUpcomingInterviewsApiV1RecruitingInterviewsUpcomingGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListUpcomingInterviewsApiV1RecruitingInterviewsUpcomingGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listUpcomingInterviewsApiV1RecruitingInterviewsUpcomingGet
      >
    >
  >;
export type ListUpcomingInterviewsApiV1RecruitingInterviewsUpcomingGetQueryError =
  HTTPValidationError;

export function useListUpcomingInterviewsApiV1RecruitingInterviewsUpcomingGet<
  TData = Awaited<
    ReturnType<
      typeof listUpcomingInterviewsApiV1RecruitingInterviewsUpcomingGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ListUpcomingInterviewsApiV1RecruitingInterviewsUpcomingGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listUpcomingInterviewsApiV1RecruitingInterviewsUpcomingGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listUpcomingInterviewsApiV1RecruitingInterviewsUpcomingGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listUpcomingInterviewsApiV1RecruitingInterviewsUpcomingGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListUpcomingInterviewsApiV1RecruitingInterviewsUpcomingGet<
  TData = Awaited<
    ReturnType<
      typeof listUpcomingInterviewsApiV1RecruitingInterviewsUpcomingGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListUpcomingInterviewsApiV1RecruitingInterviewsUpcomingGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listUpcomingInterviewsApiV1RecruitingInterviewsUpcomingGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listUpcomingInterviewsApiV1RecruitingInterviewsUpcomingGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listUpcomingInterviewsApiV1RecruitingInterviewsUpcomingGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListUpcomingInterviewsApiV1RecruitingInterviewsUpcomingGet<
  TData = Awaited<
    ReturnType<
      typeof listUpcomingInterviewsApiV1RecruitingInterviewsUpcomingGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListUpcomingInterviewsApiV1RecruitingInterviewsUpcomingGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listUpcomingInterviewsApiV1RecruitingInterviewsUpcomingGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Upcoming Interviews
 */

export function useListUpcomingInterviewsApiV1RecruitingInterviewsUpcomingGet<
  TData = Awaited<
    ReturnType<
      typeof listUpcomingInterviewsApiV1RecruitingInterviewsUpcomingGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListUpcomingInterviewsApiV1RecruitingInterviewsUpcomingGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listUpcomingInterviewsApiV1RecruitingInterviewsUpcomingGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListUpcomingInterviewsApiV1RecruitingInterviewsUpcomingGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List all interviews with candidate, job, and participant info.

Interviews accumulate (Shape A), so the page window AND the sort resolve
here; the caller only ever holds one page.
 * @summary List All Interviews
 */
export const listAllInterviewsApiV1RecruitingInterviewsGet = (
  params?: ListAllInterviewsApiV1RecruitingInterviewsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/interviews`,
    method: 'GET',
    params,
    signal
  });
};

export const getListAllInterviewsApiV1RecruitingInterviewsGetQueryKey = (
  params?: ListAllInterviewsApiV1RecruitingInterviewsGetParams
) => {
  return [
    `/api/v1/recruiting/interviews`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListAllInterviewsApiV1RecruitingInterviewsGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listAllInterviewsApiV1RecruitingInterviewsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListAllInterviewsApiV1RecruitingInterviewsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listAllInterviewsApiV1RecruitingInterviewsGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListAllInterviewsApiV1RecruitingInterviewsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAllInterviewsApiV1RecruitingInterviewsGet>>
  > = ({ signal }) =>
    listAllInterviewsApiV1RecruitingInterviewsGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAllInterviewsApiV1RecruitingInterviewsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListAllInterviewsApiV1RecruitingInterviewsGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listAllInterviewsApiV1RecruitingInterviewsGet>>
  >;
export type ListAllInterviewsApiV1RecruitingInterviewsGetQueryError =
  HTTPValidationError;

export function useListAllInterviewsApiV1RecruitingInterviewsGet<
  TData = Awaited<
    ReturnType<typeof listAllInterviewsApiV1RecruitingInterviewsGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListAllInterviewsApiV1RecruitingInterviewsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listAllInterviewsApiV1RecruitingInterviewsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listAllInterviewsApiV1RecruitingInterviewsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listAllInterviewsApiV1RecruitingInterviewsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListAllInterviewsApiV1RecruitingInterviewsGet<
  TData = Awaited<
    ReturnType<typeof listAllInterviewsApiV1RecruitingInterviewsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListAllInterviewsApiV1RecruitingInterviewsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listAllInterviewsApiV1RecruitingInterviewsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listAllInterviewsApiV1RecruitingInterviewsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listAllInterviewsApiV1RecruitingInterviewsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListAllInterviewsApiV1RecruitingInterviewsGet<
  TData = Awaited<
    ReturnType<typeof listAllInterviewsApiV1RecruitingInterviewsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListAllInterviewsApiV1RecruitingInterviewsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listAllInterviewsApiV1RecruitingInterviewsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List All Interviews
 */

export function useListAllInterviewsApiV1RecruitingInterviewsGet<
  TData = Awaited<
    ReturnType<typeof listAllInterviewsApiV1RecruitingInterviewsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListAllInterviewsApiV1RecruitingInterviewsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listAllInterviewsApiV1RecruitingInterviewsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListAllInterviewsApiV1RecruitingInterviewsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get interviews in a date range for calendar view.

Unpaged by design: the result set is already bounded by the mandatory
`start`/`end` window the calendar grid is rendering, and the grid needs every
interview inside it — a page would silently drop chips off a day.
 * @summary Get Interviews Calendar
 */
export const getInterviewsCalendarApiV1RecruitingInterviewsCalendarGet = (
  params: GetInterviewsCalendarApiV1RecruitingInterviewsCalendarGetParams,
  signal?: AbortSignal
) => {
  return customInstance<InterviewCalendarResponse>({
    url: `/api/v1/recruiting/interviews/calendar`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetInterviewsCalendarApiV1RecruitingInterviewsCalendarGetQueryKey =
  (
    params?: GetInterviewsCalendarApiV1RecruitingInterviewsCalendarGetParams
  ) => {
    return [
      `/api/v1/recruiting/interviews/calendar`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetInterviewsCalendarApiV1RecruitingInterviewsCalendarGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getInterviewsCalendarApiV1RecruitingInterviewsCalendarGet
      >
    >,
    TError = HTTPValidationError
  >(
    params: GetInterviewsCalendarApiV1RecruitingInterviewsCalendarGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getInterviewsCalendarApiV1RecruitingInterviewsCalendarGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetInterviewsCalendarApiV1RecruitingInterviewsCalendarGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getInterviewsCalendarApiV1RecruitingInterviewsCalendarGet
        >
      >
    > = ({ signal }) =>
      getInterviewsCalendarApiV1RecruitingInterviewsCalendarGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getInterviewsCalendarApiV1RecruitingInterviewsCalendarGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetInterviewsCalendarApiV1RecruitingInterviewsCalendarGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getInterviewsCalendarApiV1RecruitingInterviewsCalendarGet
      >
    >
  >;
export type GetInterviewsCalendarApiV1RecruitingInterviewsCalendarGetQueryError =
  HTTPValidationError;

export function useGetInterviewsCalendarApiV1RecruitingInterviewsCalendarGet<
  TData = Awaited<
    ReturnType<typeof getInterviewsCalendarApiV1RecruitingInterviewsCalendarGet>
  >,
  TError = HTTPValidationError
>(
  params: GetInterviewsCalendarApiV1RecruitingInterviewsCalendarGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getInterviewsCalendarApiV1RecruitingInterviewsCalendarGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getInterviewsCalendarApiV1RecruitingInterviewsCalendarGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getInterviewsCalendarApiV1RecruitingInterviewsCalendarGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetInterviewsCalendarApiV1RecruitingInterviewsCalendarGet<
  TData = Awaited<
    ReturnType<typeof getInterviewsCalendarApiV1RecruitingInterviewsCalendarGet>
  >,
  TError = HTTPValidationError
>(
  params: GetInterviewsCalendarApiV1RecruitingInterviewsCalendarGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getInterviewsCalendarApiV1RecruitingInterviewsCalendarGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getInterviewsCalendarApiV1RecruitingInterviewsCalendarGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getInterviewsCalendarApiV1RecruitingInterviewsCalendarGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetInterviewsCalendarApiV1RecruitingInterviewsCalendarGet<
  TData = Awaited<
    ReturnType<typeof getInterviewsCalendarApiV1RecruitingInterviewsCalendarGet>
  >,
  TError = HTTPValidationError
>(
  params: GetInterviewsCalendarApiV1RecruitingInterviewsCalendarGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getInterviewsCalendarApiV1RecruitingInterviewsCalendarGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Interviews Calendar
 */

export function useGetInterviewsCalendarApiV1RecruitingInterviewsCalendarGet<
  TData = Awaited<
    ReturnType<typeof getInterviewsCalendarApiV1RecruitingInterviewsCalendarGet>
  >,
  TError = HTTPValidationError
>(
  params: GetInterviewsCalendarApiV1RecruitingInterviewsCalendarGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getInterviewsCalendarApiV1RecruitingInterviewsCalendarGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetInterviewsCalendarApiV1RecruitingInterviewsCalendarGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get an interview by ID.
 * @summary Get Interview
 */
export const getInterviewApiV1RecruitingInterviewsInterviewIdGet = (
  interviewId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/interviews/${interviewId}`,
    method: 'GET',
    signal
  });
};

export const getGetInterviewApiV1RecruitingInterviewsInterviewIdGetQueryKey = (
  interviewId?: string
) => {
  return [`/api/v1/recruiting/interviews/${interviewId}`] as const;
};

export const getGetInterviewApiV1RecruitingInterviewsInterviewIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getInterviewApiV1RecruitingInterviewsInterviewIdGet>
    >,
    TError = HTTPValidationError
  >(
    interviewId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getInterviewApiV1RecruitingInterviewsInterviewIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetInterviewApiV1RecruitingInterviewsInterviewIdGetQueryKey(
        interviewId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getInterviewApiV1RecruitingInterviewsInterviewIdGet>
      >
    > = ({ signal }) =>
      getInterviewApiV1RecruitingInterviewsInterviewIdGet(interviewId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!interviewId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getInterviewApiV1RecruitingInterviewsInterviewIdGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetInterviewApiV1RecruitingInterviewsInterviewIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getInterviewApiV1RecruitingInterviewsInterviewIdGet>
    >
  >;
export type GetInterviewApiV1RecruitingInterviewsInterviewIdGetQueryError =
  HTTPValidationError;

export function useGetInterviewApiV1RecruitingInterviewsInterviewIdGet<
  TData = Awaited<
    ReturnType<typeof getInterviewApiV1RecruitingInterviewsInterviewIdGet>
  >,
  TError = HTTPValidationError
>(
  interviewId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getInterviewApiV1RecruitingInterviewsInterviewIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getInterviewApiV1RecruitingInterviewsInterviewIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getInterviewApiV1RecruitingInterviewsInterviewIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetInterviewApiV1RecruitingInterviewsInterviewIdGet<
  TData = Awaited<
    ReturnType<typeof getInterviewApiV1RecruitingInterviewsInterviewIdGet>
  >,
  TError = HTTPValidationError
>(
  interviewId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getInterviewApiV1RecruitingInterviewsInterviewIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getInterviewApiV1RecruitingInterviewsInterviewIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getInterviewApiV1RecruitingInterviewsInterviewIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetInterviewApiV1RecruitingInterviewsInterviewIdGet<
  TData = Awaited<
    ReturnType<typeof getInterviewApiV1RecruitingInterviewsInterviewIdGet>
  >,
  TError = HTTPValidationError
>(
  interviewId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getInterviewApiV1RecruitingInterviewsInterviewIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Interview
 */

export function useGetInterviewApiV1RecruitingInterviewsInterviewIdGet<
  TData = Awaited<
    ReturnType<typeof getInterviewApiV1RecruitingInterviewsInterviewIdGet>
  >,
  TError = HTTPValidationError
>(
  interviewId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getInterviewApiV1RecruitingInterviewsInterviewIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetInterviewApiV1RecruitingInterviewsInterviewIdGetQueryOptions(
      interviewId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update an interview with optional candidate notification.
 * @summary Update Interview
 */
export const updateInterviewApiV1RecruitingInterviewsInterviewIdPut = (
  interviewId: string,
  interviewUpdateRequest: InterviewUpdateRequest
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/interviews/${interviewId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: interviewUpdateRequest
  });
};

export const getUpdateInterviewApiV1RecruitingInterviewsInterviewIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateInterviewApiV1RecruitingInterviewsInterviewIdPut
        >
      >,
      TError,
      { interviewId: string; data: InterviewUpdateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateInterviewApiV1RecruitingInterviewsInterviewIdPut>
    >,
    TError,
    { interviewId: string; data: InterviewUpdateRequest },
    TContext
  > => {
    const mutationKey = [
      'updateInterviewApiV1RecruitingInterviewsInterviewIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateInterviewApiV1RecruitingInterviewsInterviewIdPut
        >
      >,
      { interviewId: string; data: InterviewUpdateRequest }
    > = (props) => {
      const { interviewId, data } = props ?? {};

      return updateInterviewApiV1RecruitingInterviewsInterviewIdPut(
        interviewId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateInterviewApiV1RecruitingInterviewsInterviewIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateInterviewApiV1RecruitingInterviewsInterviewIdPut>
    >
  >;
export type UpdateInterviewApiV1RecruitingInterviewsInterviewIdPutMutationBody =
  InterviewUpdateRequest;
export type UpdateInterviewApiV1RecruitingInterviewsInterviewIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Interview
 */
export const useUpdateInterviewApiV1RecruitingInterviewsInterviewIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateInterviewApiV1RecruitingInterviewsInterviewIdPut
        >
      >,
      TError,
      { interviewId: string; data: InterviewUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateInterviewApiV1RecruitingInterviewsInterviewIdPut>
  >,
  TError,
  { interviewId: string; data: InterviewUpdateRequest },
  TContext
> => {
  const mutationOptions =
    getUpdateInterviewApiV1RecruitingInterviewsInterviewIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Schedule an interview directly for a candidate without a specific job application.
 * @summary Create Candidate Interview
 */
export const createCandidateInterviewApiV1RecruitingCandidatesCandidateIdInterviewsPost =
  (
    candidateId: string,
    interviewCreateRequest: InterviewCreateRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/recruiting/candidates/${candidateId}/interviews`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: interviewCreateRequest,
      signal
    });
  };

export const getCreateCandidateInterviewApiV1RecruitingCandidatesCandidateIdInterviewsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createCandidateInterviewApiV1RecruitingCandidatesCandidateIdInterviewsPost
        >
      >,
      TError,
      { candidateId: string; data: InterviewCreateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createCandidateInterviewApiV1RecruitingCandidatesCandidateIdInterviewsPost
      >
    >,
    TError,
    { candidateId: string; data: InterviewCreateRequest },
    TContext
  > => {
    const mutationKey = [
      'createCandidateInterviewApiV1RecruitingCandidatesCandidateIdInterviewsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createCandidateInterviewApiV1RecruitingCandidatesCandidateIdInterviewsPost
        >
      >,
      { candidateId: string; data: InterviewCreateRequest }
    > = (props) => {
      const { candidateId, data } = props ?? {};

      return createCandidateInterviewApiV1RecruitingCandidatesCandidateIdInterviewsPost(
        candidateId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateCandidateInterviewApiV1RecruitingCandidatesCandidateIdInterviewsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createCandidateInterviewApiV1RecruitingCandidatesCandidateIdInterviewsPost
      >
    >
  >;
export type CreateCandidateInterviewApiV1RecruitingCandidatesCandidateIdInterviewsPostMutationBody =
  InterviewCreateRequest;
export type CreateCandidateInterviewApiV1RecruitingCandidatesCandidateIdInterviewsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Candidate Interview
 */
export const useCreateCandidateInterviewApiV1RecruitingCandidatesCandidateIdInterviewsPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createCandidateInterviewApiV1RecruitingCandidatesCandidateIdInterviewsPost
          >
        >,
        TError,
        { candidateId: string; data: InterviewCreateRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createCandidateInterviewApiV1RecruitingCandidatesCandidateIdInterviewsPost
      >
    >,
    TError,
    { candidateId: string; data: InterviewCreateRequest },
    TContext
  > => {
    const mutationOptions =
      getCreateCandidateInterviewApiV1RecruitingCandidatesCandidateIdInterviewsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Add a participant to an interview.
 * @summary Add Interview Participant
 */
export const addInterviewParticipantApiV1RecruitingInterviewsInterviewIdParticipantsPost =
  (
    interviewId: string,
    addParticipantRequest: AddParticipantRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/recruiting/interviews/${interviewId}/participants`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: addParticipantRequest,
      signal
    });
  };

export const getAddInterviewParticipantApiV1RecruitingInterviewsInterviewIdParticipantsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof addInterviewParticipantApiV1RecruitingInterviewsInterviewIdParticipantsPost
        >
      >,
      TError,
      { interviewId: string; data: AddParticipantRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof addInterviewParticipantApiV1RecruitingInterviewsInterviewIdParticipantsPost
      >
    >,
    TError,
    { interviewId: string; data: AddParticipantRequest },
    TContext
  > => {
    const mutationKey = [
      'addInterviewParticipantApiV1RecruitingInterviewsInterviewIdParticipantsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof addInterviewParticipantApiV1RecruitingInterviewsInterviewIdParticipantsPost
        >
      >,
      { interviewId: string; data: AddParticipantRequest }
    > = (props) => {
      const { interviewId, data } = props ?? {};

      return addInterviewParticipantApiV1RecruitingInterviewsInterviewIdParticipantsPost(
        interviewId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AddInterviewParticipantApiV1RecruitingInterviewsInterviewIdParticipantsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof addInterviewParticipantApiV1RecruitingInterviewsInterviewIdParticipantsPost
      >
    >
  >;
export type AddInterviewParticipantApiV1RecruitingInterviewsInterviewIdParticipantsPostMutationBody =
  AddParticipantRequest;
export type AddInterviewParticipantApiV1RecruitingInterviewsInterviewIdParticipantsPostMutationError =
  HTTPValidationError;

/**
 * @summary Add Interview Participant
 */
export const useAddInterviewParticipantApiV1RecruitingInterviewsInterviewIdParticipantsPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof addInterviewParticipantApiV1RecruitingInterviewsInterviewIdParticipantsPost
          >
        >,
        TError,
        { interviewId: string; data: AddParticipantRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof addInterviewParticipantApiV1RecruitingInterviewsInterviewIdParticipantsPost
      >
    >,
    TError,
    { interviewId: string; data: AddParticipantRequest },
    TContext
  > => {
    const mutationOptions =
      getAddInterviewParticipantApiV1RecruitingInterviewsInterviewIdParticipantsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Remove a participant from an interview.
 * @summary Remove Interview Participant
 */
export const removeInterviewParticipantApiV1RecruitingInterviewsInterviewIdParticipantsUserIdDelete =
  (interviewId: string, userId: string) => {
    return customInstance<unknown>({
      url: `/api/v1/recruiting/interviews/${interviewId}/participants/${userId}`,
      method: 'DELETE'
    });
  };

export const getRemoveInterviewParticipantApiV1RecruitingInterviewsInterviewIdParticipantsUserIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof removeInterviewParticipantApiV1RecruitingInterviewsInterviewIdParticipantsUserIdDelete
        >
      >,
      TError,
      { interviewId: string; userId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof removeInterviewParticipantApiV1RecruitingInterviewsInterviewIdParticipantsUserIdDelete
      >
    >,
    TError,
    { interviewId: string; userId: string },
    TContext
  > => {
    const mutationKey = [
      'removeInterviewParticipantApiV1RecruitingInterviewsInterviewIdParticipantsUserIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof removeInterviewParticipantApiV1RecruitingInterviewsInterviewIdParticipantsUserIdDelete
        >
      >,
      { interviewId: string; userId: string }
    > = (props) => {
      const { interviewId, userId } = props ?? {};

      return removeInterviewParticipantApiV1RecruitingInterviewsInterviewIdParticipantsUserIdDelete(
        interviewId,
        userId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RemoveInterviewParticipantApiV1RecruitingInterviewsInterviewIdParticipantsUserIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof removeInterviewParticipantApiV1RecruitingInterviewsInterviewIdParticipantsUserIdDelete
      >
    >
  >;

export type RemoveInterviewParticipantApiV1RecruitingInterviewsInterviewIdParticipantsUserIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Remove Interview Participant
 */
export const useRemoveInterviewParticipantApiV1RecruitingInterviewsInterviewIdParticipantsUserIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof removeInterviewParticipantApiV1RecruitingInterviewsInterviewIdParticipantsUserIdDelete
          >
        >,
        TError,
        { interviewId: string; userId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof removeInterviewParticipantApiV1RecruitingInterviewsInterviewIdParticipantsUserIdDelete
      >
    >,
    TError,
    { interviewId: string; userId: string },
    TContext
  > => {
    const mutationOptions =
      getRemoveInterviewParticipantApiV1RecruitingInterviewsInterviewIdParticipantsUserIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Cancel an interview with optional calendar deletion and candidate notification.
 * @summary Cancel Interview
 */
export const cancelInterviewApiV1RecruitingInterviewsInterviewIdCancelPost = (
  interviewId: string,
  cancelInterviewApiV1RecruitingInterviewsInterviewIdCancelPostBody: CancelInterviewApiV1RecruitingInterviewsInterviewIdCancelPostBody,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/interviews/${interviewId}/cancel`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: cancelInterviewApiV1RecruitingInterviewsInterviewIdCancelPostBody,
    signal
  });
};

export const getCancelInterviewApiV1RecruitingInterviewsInterviewIdCancelPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof cancelInterviewApiV1RecruitingInterviewsInterviewIdCancelPost
        >
      >,
      TError,
      {
        interviewId: string;
        data: CancelInterviewApiV1RecruitingInterviewsInterviewIdCancelPostBody;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof cancelInterviewApiV1RecruitingInterviewsInterviewIdCancelPost
      >
    >,
    TError,
    {
      interviewId: string;
      data: CancelInterviewApiV1RecruitingInterviewsInterviewIdCancelPostBody;
    },
    TContext
  > => {
    const mutationKey = [
      'cancelInterviewApiV1RecruitingInterviewsInterviewIdCancelPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof cancelInterviewApiV1RecruitingInterviewsInterviewIdCancelPost
        >
      >,
      {
        interviewId: string;
        data: CancelInterviewApiV1RecruitingInterviewsInterviewIdCancelPostBody;
      }
    > = (props) => {
      const { interviewId, data } = props ?? {};

      return cancelInterviewApiV1RecruitingInterviewsInterviewIdCancelPost(
        interviewId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CancelInterviewApiV1RecruitingInterviewsInterviewIdCancelPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof cancelInterviewApiV1RecruitingInterviewsInterviewIdCancelPost
      >
    >
  >;
export type CancelInterviewApiV1RecruitingInterviewsInterviewIdCancelPostMutationBody =
  CancelInterviewApiV1RecruitingInterviewsInterviewIdCancelPostBody;
export type CancelInterviewApiV1RecruitingInterviewsInterviewIdCancelPostMutationError =
  HTTPValidationError;

/**
 * @summary Cancel Interview
 */
export const useCancelInterviewApiV1RecruitingInterviewsInterviewIdCancelPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof cancelInterviewApiV1RecruitingInterviewsInterviewIdCancelPost
          >
        >,
        TError,
        {
          interviewId: string;
          data: CancelInterviewApiV1RecruitingInterviewsInterviewIdCancelPostBody;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof cancelInterviewApiV1RecruitingInterviewsInterviewIdCancelPost
      >
    >,
    TError,
    {
      interviewId: string;
      data: CancelInterviewApiV1RecruitingInterviewsInterviewIdCancelPostBody;
    },
    TContext
  > => {
    const mutationOptions =
      getCancelInterviewApiV1RecruitingInterviewsInterviewIdCancelPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Mark an interview as completed.
 * @summary Complete Interview
 */
export const completeInterviewApiV1RecruitingInterviewsInterviewIdCompletePost =
  (interviewId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/recruiting/interviews/${interviewId}/complete`,
      method: 'POST',
      signal
    });
  };

export const getCompleteInterviewApiV1RecruitingInterviewsInterviewIdCompletePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof completeInterviewApiV1RecruitingInterviewsInterviewIdCompletePost
        >
      >,
      TError,
      { interviewId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof completeInterviewApiV1RecruitingInterviewsInterviewIdCompletePost
      >
    >,
    TError,
    { interviewId: string },
    TContext
  > => {
    const mutationKey = [
      'completeInterviewApiV1RecruitingInterviewsInterviewIdCompletePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof completeInterviewApiV1RecruitingInterviewsInterviewIdCompletePost
        >
      >,
      { interviewId: string }
    > = (props) => {
      const { interviewId } = props ?? {};

      return completeInterviewApiV1RecruitingInterviewsInterviewIdCompletePost(
        interviewId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CompleteInterviewApiV1RecruitingInterviewsInterviewIdCompletePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof completeInterviewApiV1RecruitingInterviewsInterviewIdCompletePost
      >
    >
  >;

export type CompleteInterviewApiV1RecruitingInterviewsInterviewIdCompletePostMutationError =
  HTTPValidationError;

/**
 * @summary Complete Interview
 */
export const useCompleteInterviewApiV1RecruitingInterviewsInterviewIdCompletePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof completeInterviewApiV1RecruitingInterviewsInterviewIdCompletePost
          >
        >,
        TError,
        { interviewId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof completeInterviewApiV1RecruitingInterviewsInterviewIdCompletePost
      >
    >,
    TError,
    { interviewId: string },
    TContext
  > => {
    const mutationOptions =
      getCompleteInterviewApiV1RecruitingInterviewsInterviewIdCompletePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Download ICS calendar file for an interview.
 * @summary Download Interview Ics
 */
export const downloadInterviewIcsApiV1RecruitingInterviewsInterviewIdIcsGet = (
  interviewId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/interviews/${interviewId}/ics`,
    method: 'GET',
    signal
  });
};

export const getDownloadInterviewIcsApiV1RecruitingInterviewsInterviewIdIcsGetQueryKey =
  (interviewId?: string) => {
    return [`/api/v1/recruiting/interviews/${interviewId}/ics`] as const;
  };

export const getDownloadInterviewIcsApiV1RecruitingInterviewsInterviewIdIcsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof downloadInterviewIcsApiV1RecruitingInterviewsInterviewIdIcsGet
      >
    >,
    TError = HTTPValidationError
  >(
    interviewId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof downloadInterviewIcsApiV1RecruitingInterviewsInterviewIdIcsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getDownloadInterviewIcsApiV1RecruitingInterviewsInterviewIdIcsGetQueryKey(
        interviewId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof downloadInterviewIcsApiV1RecruitingInterviewsInterviewIdIcsGet
        >
      >
    > = ({ signal }) =>
      downloadInterviewIcsApiV1RecruitingInterviewsInterviewIdIcsGet(
        interviewId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!interviewId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof downloadInterviewIcsApiV1RecruitingInterviewsInterviewIdIcsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type DownloadInterviewIcsApiV1RecruitingInterviewsInterviewIdIcsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof downloadInterviewIcsApiV1RecruitingInterviewsInterviewIdIcsGet
      >
    >
  >;
export type DownloadInterviewIcsApiV1RecruitingInterviewsInterviewIdIcsGetQueryError =
  HTTPValidationError;

export function useDownloadInterviewIcsApiV1RecruitingInterviewsInterviewIdIcsGet<
  TData = Awaited<
    ReturnType<
      typeof downloadInterviewIcsApiV1RecruitingInterviewsInterviewIdIcsGet
    >
  >,
  TError = HTTPValidationError
>(
  interviewId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof downloadInterviewIcsApiV1RecruitingInterviewsInterviewIdIcsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof downloadInterviewIcsApiV1RecruitingInterviewsInterviewIdIcsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof downloadInterviewIcsApiV1RecruitingInterviewsInterviewIdIcsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useDownloadInterviewIcsApiV1RecruitingInterviewsInterviewIdIcsGet<
  TData = Awaited<
    ReturnType<
      typeof downloadInterviewIcsApiV1RecruitingInterviewsInterviewIdIcsGet
    >
  >,
  TError = HTTPValidationError
>(
  interviewId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof downloadInterviewIcsApiV1RecruitingInterviewsInterviewIdIcsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof downloadInterviewIcsApiV1RecruitingInterviewsInterviewIdIcsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof downloadInterviewIcsApiV1RecruitingInterviewsInterviewIdIcsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDownloadInterviewIcsApiV1RecruitingInterviewsInterviewIdIcsGet<
  TData = Awaited<
    ReturnType<
      typeof downloadInterviewIcsApiV1RecruitingInterviewsInterviewIdIcsGet
    >
  >,
  TError = HTTPValidationError
>(
  interviewId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof downloadInterviewIcsApiV1RecruitingInterviewsInterviewIdIcsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Download Interview Ics
 */

export function useDownloadInterviewIcsApiV1RecruitingInterviewsInterviewIdIcsGet<
  TData = Awaited<
    ReturnType<
      typeof downloadInterviewIcsApiV1RecruitingInterviewsInterviewIdIcsGet
    >
  >,
  TError = HTTPValidationError
>(
  interviewId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof downloadInterviewIcsApiV1RecruitingInterviewsInterviewIdIcsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getDownloadInterviewIcsApiV1RecruitingInterviewsInterviewIdIcsGetQueryOptions(
      interviewId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get external calendar links (Google, Outlook, Yahoo) for an interview.
 * @summary Get Interview Calendar Links
 */
export const getInterviewCalendarLinksApiV1RecruitingInterviewsInterviewIdCalendarLinksGet =
  (interviewId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/recruiting/interviews/${interviewId}/calendar-links`,
      method: 'GET',
      signal
    });
  };

export const getGetInterviewCalendarLinksApiV1RecruitingInterviewsInterviewIdCalendarLinksGetQueryKey =
  (interviewId?: string) => {
    return [
      `/api/v1/recruiting/interviews/${interviewId}/calendar-links`
    ] as const;
  };

export const getGetInterviewCalendarLinksApiV1RecruitingInterviewsInterviewIdCalendarLinksGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getInterviewCalendarLinksApiV1RecruitingInterviewsInterviewIdCalendarLinksGet
      >
    >,
    TError = HTTPValidationError
  >(
    interviewId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getInterviewCalendarLinksApiV1RecruitingInterviewsInterviewIdCalendarLinksGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetInterviewCalendarLinksApiV1RecruitingInterviewsInterviewIdCalendarLinksGetQueryKey(
        interviewId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getInterviewCalendarLinksApiV1RecruitingInterviewsInterviewIdCalendarLinksGet
        >
      >
    > = ({ signal }) =>
      getInterviewCalendarLinksApiV1RecruitingInterviewsInterviewIdCalendarLinksGet(
        interviewId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!interviewId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getInterviewCalendarLinksApiV1RecruitingInterviewsInterviewIdCalendarLinksGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetInterviewCalendarLinksApiV1RecruitingInterviewsInterviewIdCalendarLinksGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getInterviewCalendarLinksApiV1RecruitingInterviewsInterviewIdCalendarLinksGet
      >
    >
  >;
export type GetInterviewCalendarLinksApiV1RecruitingInterviewsInterviewIdCalendarLinksGetQueryError =
  HTTPValidationError;

export function useGetInterviewCalendarLinksApiV1RecruitingInterviewsInterviewIdCalendarLinksGet<
  TData = Awaited<
    ReturnType<
      typeof getInterviewCalendarLinksApiV1RecruitingInterviewsInterviewIdCalendarLinksGet
    >
  >,
  TError = HTTPValidationError
>(
  interviewId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getInterviewCalendarLinksApiV1RecruitingInterviewsInterviewIdCalendarLinksGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getInterviewCalendarLinksApiV1RecruitingInterviewsInterviewIdCalendarLinksGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getInterviewCalendarLinksApiV1RecruitingInterviewsInterviewIdCalendarLinksGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetInterviewCalendarLinksApiV1RecruitingInterviewsInterviewIdCalendarLinksGet<
  TData = Awaited<
    ReturnType<
      typeof getInterviewCalendarLinksApiV1RecruitingInterviewsInterviewIdCalendarLinksGet
    >
  >,
  TError = HTTPValidationError
>(
  interviewId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getInterviewCalendarLinksApiV1RecruitingInterviewsInterviewIdCalendarLinksGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getInterviewCalendarLinksApiV1RecruitingInterviewsInterviewIdCalendarLinksGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getInterviewCalendarLinksApiV1RecruitingInterviewsInterviewIdCalendarLinksGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetInterviewCalendarLinksApiV1RecruitingInterviewsInterviewIdCalendarLinksGet<
  TData = Awaited<
    ReturnType<
      typeof getInterviewCalendarLinksApiV1RecruitingInterviewsInterviewIdCalendarLinksGet
    >
  >,
  TError = HTTPValidationError
>(
  interviewId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getInterviewCalendarLinksApiV1RecruitingInterviewsInterviewIdCalendarLinksGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Interview Calendar Links
 */

export function useGetInterviewCalendarLinksApiV1RecruitingInterviewsInterviewIdCalendarLinksGet<
  TData = Awaited<
    ReturnType<
      typeof getInterviewCalendarLinksApiV1RecruitingInterviewsInterviewIdCalendarLinksGet
    >
  >,
  TError = HTTPValidationError
>(
  interviewId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getInterviewCalendarLinksApiV1RecruitingInterviewsInterviewIdCalendarLinksGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetInterviewCalendarLinksApiV1RecruitingInterviewsInterviewIdCalendarLinksGetQueryOptions(
      interviewId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Send or resend interview invitation email to the candidate.
 * @summary Send Interview Invite
 */
export const sendInterviewInviteApiV1RecruitingInterviewsInterviewIdSendInvitePost =
  (interviewId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/recruiting/interviews/${interviewId}/send-invite`,
      method: 'POST',
      signal
    });
  };

export const getSendInterviewInviteApiV1RecruitingInterviewsInterviewIdSendInvitePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof sendInterviewInviteApiV1RecruitingInterviewsInterviewIdSendInvitePost
        >
      >,
      TError,
      { interviewId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof sendInterviewInviteApiV1RecruitingInterviewsInterviewIdSendInvitePost
      >
    >,
    TError,
    { interviewId: string },
    TContext
  > => {
    const mutationKey = [
      'sendInterviewInviteApiV1RecruitingInterviewsInterviewIdSendInvitePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof sendInterviewInviteApiV1RecruitingInterviewsInterviewIdSendInvitePost
        >
      >,
      { interviewId: string }
    > = (props) => {
      const { interviewId } = props ?? {};

      return sendInterviewInviteApiV1RecruitingInterviewsInterviewIdSendInvitePost(
        interviewId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type SendInterviewInviteApiV1RecruitingInterviewsInterviewIdSendInvitePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof sendInterviewInviteApiV1RecruitingInterviewsInterviewIdSendInvitePost
      >
    >
  >;

export type SendInterviewInviteApiV1RecruitingInterviewsInterviewIdSendInvitePostMutationError =
  HTTPValidationError;

/**
 * @summary Send Interview Invite
 */
export const useSendInterviewInviteApiV1RecruitingInterviewsInterviewIdSendInvitePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof sendInterviewInviteApiV1RecruitingInterviewsInterviewIdSendInvitePost
          >
        >,
        TError,
        { interviewId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof sendInterviewInviteApiV1RecruitingInterviewsInterviewIdSendInvitePost
      >
    >,
    TError,
    { interviewId: string },
    TContext
  > => {
    const mutationOptions =
      getSendInterviewInviteApiV1RecruitingInterviewsInterviewIdSendInvitePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List feedback for an interview.
 * @summary List Interview Feedback
 */
export const listInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackGet =
  (interviewId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/recruiting/interviews/${interviewId}/feedback`,
      method: 'GET',
      signal
    });
  };

export const getListInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackGetQueryKey =
  (interviewId?: string) => {
    return [`/api/v1/recruiting/interviews/${interviewId}/feedback`] as const;
  };

export const getListInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackGet
      >
    >,
    TError = HTTPValidationError
  >(
    interviewId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackGetQueryKey(
        interviewId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackGet
        >
      >
    > = ({ signal }) =>
      listInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackGet(
        interviewId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!interviewId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackGet
      >
    >
  >;
export type ListInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackGetQueryError =
  HTTPValidationError;

export function useListInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackGet<
  TData = Awaited<
    ReturnType<
      typeof listInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackGet
    >
  >,
  TError = HTTPValidationError
>(
  interviewId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackGet<
  TData = Awaited<
    ReturnType<
      typeof listInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackGet
    >
  >,
  TError = HTTPValidationError
>(
  interviewId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackGet<
  TData = Awaited<
    ReturnType<
      typeof listInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackGet
    >
  >,
  TError = HTTPValidationError
>(
  interviewId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Interview Feedback
 */

export function useListInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackGet<
  TData = Awaited<
    ReturnType<
      typeof listInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackGet
    >
  >,
  TError = HTTPValidationError
>(
  interviewId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackGetQueryOptions(
      interviewId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Submit feedback for an interview.
 * @summary Submit Interview Feedback
 */
export const submitInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackPost =
  (
    interviewId: string,
    submitInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackPostBody: SubmitInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackPostBody,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/recruiting/interviews/${interviewId}/feedback`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: submitInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackPostBody,
      signal
    });
  };

export const getSubmitInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof submitInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackPost
        >
      >,
      TError,
      {
        interviewId: string;
        data: SubmitInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackPostBody;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof submitInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackPost
      >
    >,
    TError,
    {
      interviewId: string;
      data: SubmitInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackPostBody;
    },
    TContext
  > => {
    const mutationKey = [
      'submitInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof submitInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackPost
        >
      >,
      {
        interviewId: string;
        data: SubmitInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackPostBody;
      }
    > = (props) => {
      const { interviewId, data } = props ?? {};

      return submitInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackPost(
        interviewId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type SubmitInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof submitInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackPost
      >
    >
  >;
export type SubmitInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackPostMutationBody =
  SubmitInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackPostBody;
export type SubmitInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackPostMutationError =
  HTTPValidationError;

/**
 * @summary Submit Interview Feedback
 */
export const useSubmitInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof submitInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackPost
          >
        >,
        TError,
        {
          interviewId: string;
          data: SubmitInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackPostBody;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof submitInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackPost
      >
    >,
    TError,
    {
      interviewId: string;
      data: SubmitInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackPostBody;
    },
    TContext
  > => {
    const mutationOptions =
      getSubmitInterviewFeedbackApiV1RecruitingInterviewsInterviewIdFeedbackPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List all scorecard templates.
 * @summary List Scorecard Templates
 */
export const listScorecardTemplatesApiV1RecruitingScorecardTemplatesGet = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/scorecard-templates`,
    method: 'GET',
    signal
  });
};

export const getListScorecardTemplatesApiV1RecruitingScorecardTemplatesGetQueryKey =
  () => {
    return [`/api/v1/recruiting/scorecard-templates`] as const;
  };

export const getListScorecardTemplatesApiV1RecruitingScorecardTemplatesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listScorecardTemplatesApiV1RecruitingScorecardTemplatesGet
      >
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listScorecardTemplatesApiV1RecruitingScorecardTemplatesGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListScorecardTemplatesApiV1RecruitingScorecardTemplatesGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listScorecardTemplatesApiV1RecruitingScorecardTemplatesGet
        >
      >
    > = ({ signal }) =>
      listScorecardTemplatesApiV1RecruitingScorecardTemplatesGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listScorecardTemplatesApiV1RecruitingScorecardTemplatesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListScorecardTemplatesApiV1RecruitingScorecardTemplatesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listScorecardTemplatesApiV1RecruitingScorecardTemplatesGet
      >
    >
  >;
export type ListScorecardTemplatesApiV1RecruitingScorecardTemplatesGetQueryError =
  unknown;

export function useListScorecardTemplatesApiV1RecruitingScorecardTemplatesGet<
  TData = Awaited<
    ReturnType<
      typeof listScorecardTemplatesApiV1RecruitingScorecardTemplatesGet
    >
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listScorecardTemplatesApiV1RecruitingScorecardTemplatesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listScorecardTemplatesApiV1RecruitingScorecardTemplatesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listScorecardTemplatesApiV1RecruitingScorecardTemplatesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListScorecardTemplatesApiV1RecruitingScorecardTemplatesGet<
  TData = Awaited<
    ReturnType<
      typeof listScorecardTemplatesApiV1RecruitingScorecardTemplatesGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listScorecardTemplatesApiV1RecruitingScorecardTemplatesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listScorecardTemplatesApiV1RecruitingScorecardTemplatesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listScorecardTemplatesApiV1RecruitingScorecardTemplatesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListScorecardTemplatesApiV1RecruitingScorecardTemplatesGet<
  TData = Awaited<
    ReturnType<
      typeof listScorecardTemplatesApiV1RecruitingScorecardTemplatesGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listScorecardTemplatesApiV1RecruitingScorecardTemplatesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Scorecard Templates
 */

export function useListScorecardTemplatesApiV1RecruitingScorecardTemplatesGet<
  TData = Awaited<
    ReturnType<
      typeof listScorecardTemplatesApiV1RecruitingScorecardTemplatesGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listScorecardTemplatesApiV1RecruitingScorecardTemplatesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListScorecardTemplatesApiV1RecruitingScorecardTemplatesGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new scorecard template.
 * @summary Create Scorecard Template
 */
export const createScorecardTemplateApiV1RecruitingScorecardTemplatesPost = (
  createScorecardTemplateApiV1RecruitingScorecardTemplatesPostBody: CreateScorecardTemplateApiV1RecruitingScorecardTemplatesPostBody,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/scorecard-templates`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createScorecardTemplateApiV1RecruitingScorecardTemplatesPostBody,
    signal
  });
};

export const getCreateScorecardTemplateApiV1RecruitingScorecardTemplatesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createScorecardTemplateApiV1RecruitingScorecardTemplatesPost
        >
      >,
      TError,
      {
        data: CreateScorecardTemplateApiV1RecruitingScorecardTemplatesPostBody;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createScorecardTemplateApiV1RecruitingScorecardTemplatesPost
      >
    >,
    TError,
    { data: CreateScorecardTemplateApiV1RecruitingScorecardTemplatesPostBody },
    TContext
  > => {
    const mutationKey = [
      'createScorecardTemplateApiV1RecruitingScorecardTemplatesPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createScorecardTemplateApiV1RecruitingScorecardTemplatesPost
        >
      >,
      { data: CreateScorecardTemplateApiV1RecruitingScorecardTemplatesPostBody }
    > = (props) => {
      const { data } = props ?? {};

      return createScorecardTemplateApiV1RecruitingScorecardTemplatesPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateScorecardTemplateApiV1RecruitingScorecardTemplatesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createScorecardTemplateApiV1RecruitingScorecardTemplatesPost
      >
    >
  >;
export type CreateScorecardTemplateApiV1RecruitingScorecardTemplatesPostMutationBody =
  CreateScorecardTemplateApiV1RecruitingScorecardTemplatesPostBody;
export type CreateScorecardTemplateApiV1RecruitingScorecardTemplatesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Scorecard Template
 */
export const useCreateScorecardTemplateApiV1RecruitingScorecardTemplatesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createScorecardTemplateApiV1RecruitingScorecardTemplatesPost
        >
      >,
      TError,
      {
        data: CreateScorecardTemplateApiV1RecruitingScorecardTemplatesPostBody;
      },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof createScorecardTemplateApiV1RecruitingScorecardTemplatesPost
    >
  >,
  TError,
  { data: CreateScorecardTemplateApiV1RecruitingScorecardTemplatesPostBody },
  TContext
> => {
  const mutationOptions =
    getCreateScorecardTemplateApiV1RecruitingScorecardTemplatesPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get a scorecard template by ID.
 * @summary Get Scorecard Template
 */
export const getScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdGet =
  (templateId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/recruiting/scorecard-templates/${templateId}`,
      method: 'GET',
      signal
    });
  };

export const getGetScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdGetQueryKey =
  (templateId?: string) => {
    return [`/api/v1/recruiting/scorecard-templates/${templateId}`] as const;
  };

export const getGetScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    templateId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdGetQueryKey(
        templateId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdGet
        >
      >
    > = ({ signal }) =>
      getScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdGet(
        templateId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!templateId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdGet
      >
    >
  >;
export type GetScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdGetQueryError =
  HTTPValidationError;

export function useGetScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdGet<
  TData = Awaited<
    ReturnType<
      typeof getScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdGet
    >
  >,
  TError = HTTPValidationError
>(
  templateId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdGet<
  TData = Awaited<
    ReturnType<
      typeof getScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdGet
    >
  >,
  TError = HTTPValidationError
>(
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdGet<
  TData = Awaited<
    ReturnType<
      typeof getScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdGet
    >
  >,
  TError = HTTPValidationError
>(
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Scorecard Template
 */

export function useGetScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdGet<
  TData = Awaited<
    ReturnType<
      typeof getScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdGet
    >
  >,
  TError = HTTPValidationError
>(
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdGetQueryOptions(
      templateId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a scorecard template.
 * @summary Update Scorecard Template
 */
export const updateScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdPut =
  (
    templateId: string,
    updateScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdPutBody: UpdateScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdPutBody
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/recruiting/scorecard-templates/${templateId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdPutBody
    });
  };

export const getUpdateScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdPut
        >
      >,
      TError,
      {
        templateId: string;
        data: UpdateScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdPutBody;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdPut
      >
    >,
    TError,
    {
      templateId: string;
      data: UpdateScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdPutBody;
    },
    TContext
  > => {
    const mutationKey = [
      'updateScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdPut
        >
      >,
      {
        templateId: string;
        data: UpdateScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdPutBody;
      }
    > = (props) => {
      const { templateId, data } = props ?? {};

      return updateScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdPut(
        templateId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdPut
      >
    >
  >;
export type UpdateScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdPutMutationBody =
  UpdateScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdPutBody;
export type UpdateScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Scorecard Template
 */
export const useUpdateScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdPut
          >
        >,
        TError,
        {
          templateId: string;
          data: UpdateScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdPutBody;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdPut
      >
    >,
    TError,
    {
      templateId: string;
      data: UpdateScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdPutBody;
    },
    TContext
  > => {
    const mutationOptions =
      getUpdateScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Delete a scorecard template.
 * @summary Delete Scorecard Template
 */
export const deleteScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdDelete =
  (templateId: string) => {
    return customInstance<void>({
      url: `/api/v1/recruiting/scorecard-templates/${templateId}`,
      method: 'DELETE'
    });
  };

export const getDeleteScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdDelete
        >
      >,
      TError,
      { templateId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdDelete
      >
    >,
    TError,
    { templateId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdDelete
        >
      >,
      { templateId: string }
    > = (props) => {
      const { templateId } = props ?? {};

      return deleteScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdDelete(
        templateId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdDelete
      >
    >
  >;

export type DeleteScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Scorecard Template
 */
export const useDeleteScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdDelete
          >
        >,
        TError,
        { templateId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdDelete
      >
    >,
    TError,
    { templateId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteScorecardTemplateApiV1RecruitingScorecardTemplatesTemplateIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Score how well a candidate matches the job requirements.
 * @summary Score Application Match
 */
export const scoreApplicationMatchApiV1RecruitingApplicationsApplicationIdAiMatchScorePost =
  (applicationId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/recruiting/applications/${applicationId}/ai/match-score`,
      method: 'POST',
      signal
    });
  };

export const getScoreApplicationMatchApiV1RecruitingApplicationsApplicationIdAiMatchScorePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof scoreApplicationMatchApiV1RecruitingApplicationsApplicationIdAiMatchScorePost
        >
      >,
      TError,
      { applicationId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof scoreApplicationMatchApiV1RecruitingApplicationsApplicationIdAiMatchScorePost
      >
    >,
    TError,
    { applicationId: string },
    TContext
  > => {
    const mutationKey = [
      'scoreApplicationMatchApiV1RecruitingApplicationsApplicationIdAiMatchScorePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof scoreApplicationMatchApiV1RecruitingApplicationsApplicationIdAiMatchScorePost
        >
      >,
      { applicationId: string }
    > = (props) => {
      const { applicationId } = props ?? {};

      return scoreApplicationMatchApiV1RecruitingApplicationsApplicationIdAiMatchScorePost(
        applicationId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ScoreApplicationMatchApiV1RecruitingApplicationsApplicationIdAiMatchScorePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof scoreApplicationMatchApiV1RecruitingApplicationsApplicationIdAiMatchScorePost
      >
    >
  >;

export type ScoreApplicationMatchApiV1RecruitingApplicationsApplicationIdAiMatchScorePostMutationError =
  HTTPValidationError;

/**
 * @summary Score Application Match
 */
export const useScoreApplicationMatchApiV1RecruitingApplicationsApplicationIdAiMatchScorePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof scoreApplicationMatchApiV1RecruitingApplicationsApplicationIdAiMatchScorePost
          >
        >,
        TError,
        { applicationId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof scoreApplicationMatchApiV1RecruitingApplicationsApplicationIdAiMatchScorePost
      >
    >,
    TError,
    { applicationId: string },
    TContext
  > => {
    const mutationOptions =
      getScoreApplicationMatchApiV1RecruitingApplicationsApplicationIdAiMatchScorePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Score a candidate against a specific job.
 * @summary Score Candidate For Job
 */
export const scoreCandidateForJobApiV1RecruitingCandidatesCandidateIdAiMatchScoreJobPostingIdPost =
  (candidateId: string, jobPostingId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/recruiting/candidates/${candidateId}/ai/match-score/${jobPostingId}`,
      method: 'POST',
      signal
    });
  };

export const getScoreCandidateForJobApiV1RecruitingCandidatesCandidateIdAiMatchScoreJobPostingIdPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof scoreCandidateForJobApiV1RecruitingCandidatesCandidateIdAiMatchScoreJobPostingIdPost
        >
      >,
      TError,
      { candidateId: string; jobPostingId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof scoreCandidateForJobApiV1RecruitingCandidatesCandidateIdAiMatchScoreJobPostingIdPost
      >
    >,
    TError,
    { candidateId: string; jobPostingId: string },
    TContext
  > => {
    const mutationKey = [
      'scoreCandidateForJobApiV1RecruitingCandidatesCandidateIdAiMatchScoreJobPostingIdPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof scoreCandidateForJobApiV1RecruitingCandidatesCandidateIdAiMatchScoreJobPostingIdPost
        >
      >,
      { candidateId: string; jobPostingId: string }
    > = (props) => {
      const { candidateId, jobPostingId } = props ?? {};

      return scoreCandidateForJobApiV1RecruitingCandidatesCandidateIdAiMatchScoreJobPostingIdPost(
        candidateId,
        jobPostingId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ScoreCandidateForJobApiV1RecruitingCandidatesCandidateIdAiMatchScoreJobPostingIdPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof scoreCandidateForJobApiV1RecruitingCandidatesCandidateIdAiMatchScoreJobPostingIdPost
      >
    >
  >;

export type ScoreCandidateForJobApiV1RecruitingCandidatesCandidateIdAiMatchScoreJobPostingIdPostMutationError =
  HTTPValidationError;

/**
 * @summary Score Candidate For Job
 */
export const useScoreCandidateForJobApiV1RecruitingCandidatesCandidateIdAiMatchScoreJobPostingIdPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof scoreCandidateForJobApiV1RecruitingCandidatesCandidateIdAiMatchScoreJobPostingIdPost
          >
        >,
        TError,
        { candidateId: string; jobPostingId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof scoreCandidateForJobApiV1RecruitingCandidatesCandidateIdAiMatchScoreJobPostingIdPost
      >
    >,
    TError,
    { candidateId: string; jobPostingId: string },
    TContext
  > => {
    const mutationOptions =
      getScoreCandidateForJobApiV1RecruitingCandidatesCandidateIdAiMatchScoreJobPostingIdPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Generate tailored interview questions for a candidate/role.
 * @summary Generate Interview Questions
 */
export const generateInterviewQuestionsApiV1RecruitingInterviewsAiGenerateQuestionsPost =
  (
    generateQuestionsRequest: GenerateQuestionsRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/recruiting/interviews/ai/generate-questions`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: generateQuestionsRequest,
      signal
    });
  };

export const getGenerateInterviewQuestionsApiV1RecruitingInterviewsAiGenerateQuestionsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof generateInterviewQuestionsApiV1RecruitingInterviewsAiGenerateQuestionsPost
        >
      >,
      TError,
      { data: GenerateQuestionsRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof generateInterviewQuestionsApiV1RecruitingInterviewsAiGenerateQuestionsPost
      >
    >,
    TError,
    { data: GenerateQuestionsRequest },
    TContext
  > => {
    const mutationKey = [
      'generateInterviewQuestionsApiV1RecruitingInterviewsAiGenerateQuestionsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof generateInterviewQuestionsApiV1RecruitingInterviewsAiGenerateQuestionsPost
        >
      >,
      { data: GenerateQuestionsRequest }
    > = (props) => {
      const { data } = props ?? {};

      return generateInterviewQuestionsApiV1RecruitingInterviewsAiGenerateQuestionsPost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type GenerateInterviewQuestionsApiV1RecruitingInterviewsAiGenerateQuestionsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof generateInterviewQuestionsApiV1RecruitingInterviewsAiGenerateQuestionsPost
      >
    >
  >;
export type GenerateInterviewQuestionsApiV1RecruitingInterviewsAiGenerateQuestionsPostMutationBody =
  GenerateQuestionsRequest;
export type GenerateInterviewQuestionsApiV1RecruitingInterviewsAiGenerateQuestionsPostMutationError =
  HTTPValidationError;

/**
 * @summary Generate Interview Questions
 */
export const useGenerateInterviewQuestionsApiV1RecruitingInterviewsAiGenerateQuestionsPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof generateInterviewQuestionsApiV1RecruitingInterviewsAiGenerateQuestionsPost
          >
        >,
        TError,
        { data: GenerateQuestionsRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof generateInterviewQuestionsApiV1RecruitingInterviewsAiGenerateQuestionsPost
      >
    >,
    TError,
    { data: GenerateQuestionsRequest },
    TContext
  > => {
    const mutationOptions =
      getGenerateInterviewQuestionsApiV1RecruitingInterviewsAiGenerateQuestionsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Generate comprehensive candidate assessment from all interview feedback.
 * @summary Generate Candidate Assessment
 */
export const generateCandidateAssessmentApiV1RecruitingApplicationsApplicationIdAiAssessmentPost =
  (applicationId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/recruiting/applications/${applicationId}/ai/assessment`,
      method: 'POST',
      signal
    });
  };

export const getGenerateCandidateAssessmentApiV1RecruitingApplicationsApplicationIdAiAssessmentPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof generateCandidateAssessmentApiV1RecruitingApplicationsApplicationIdAiAssessmentPost
        >
      >,
      TError,
      { applicationId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof generateCandidateAssessmentApiV1RecruitingApplicationsApplicationIdAiAssessmentPost
      >
    >,
    TError,
    { applicationId: string },
    TContext
  > => {
    const mutationKey = [
      'generateCandidateAssessmentApiV1RecruitingApplicationsApplicationIdAiAssessmentPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof generateCandidateAssessmentApiV1RecruitingApplicationsApplicationIdAiAssessmentPost
        >
      >,
      { applicationId: string }
    > = (props) => {
      const { applicationId } = props ?? {};

      return generateCandidateAssessmentApiV1RecruitingApplicationsApplicationIdAiAssessmentPost(
        applicationId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type GenerateCandidateAssessmentApiV1RecruitingApplicationsApplicationIdAiAssessmentPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof generateCandidateAssessmentApiV1RecruitingApplicationsApplicationIdAiAssessmentPost
      >
    >
  >;

export type GenerateCandidateAssessmentApiV1RecruitingApplicationsApplicationIdAiAssessmentPostMutationError =
  HTTPValidationError;

/**
 * @summary Generate Candidate Assessment
 */
export const useGenerateCandidateAssessmentApiV1RecruitingApplicationsApplicationIdAiAssessmentPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof generateCandidateAssessmentApiV1RecruitingApplicationsApplicationIdAiAssessmentPost
          >
        >,
        TError,
        { applicationId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof generateCandidateAssessmentApiV1RecruitingApplicationsApplicationIdAiAssessmentPost
      >
    >,
    TError,
    { applicationId: string },
    TContext
  > => {
    const mutationOptions =
      getGenerateCandidateAssessmentApiV1RecruitingApplicationsApplicationIdAiAssessmentPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Research a candidate's online presence.
 * @summary Research Candidate
 */
export const researchCandidateApiV1RecruitingCandidatesCandidateIdAiResearchPost =
  (candidateId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/recruiting/candidates/${candidateId}/ai/research`,
      method: 'POST',
      signal
    });
  };

export const getResearchCandidateApiV1RecruitingCandidatesCandidateIdAiResearchPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof researchCandidateApiV1RecruitingCandidatesCandidateIdAiResearchPost
        >
      >,
      TError,
      { candidateId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof researchCandidateApiV1RecruitingCandidatesCandidateIdAiResearchPost
      >
    >,
    TError,
    { candidateId: string },
    TContext
  > => {
    const mutationKey = [
      'researchCandidateApiV1RecruitingCandidatesCandidateIdAiResearchPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof researchCandidateApiV1RecruitingCandidatesCandidateIdAiResearchPost
        >
      >,
      { candidateId: string }
    > = (props) => {
      const { candidateId } = props ?? {};

      return researchCandidateApiV1RecruitingCandidatesCandidateIdAiResearchPost(
        candidateId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ResearchCandidateApiV1RecruitingCandidatesCandidateIdAiResearchPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof researchCandidateApiV1RecruitingCandidatesCandidateIdAiResearchPost
      >
    >
  >;

export type ResearchCandidateApiV1RecruitingCandidatesCandidateIdAiResearchPostMutationError =
  HTTPValidationError;

/**
 * @summary Research Candidate
 */
export const useResearchCandidateApiV1RecruitingCandidatesCandidateIdAiResearchPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof researchCandidateApiV1RecruitingCandidatesCandidateIdAiResearchPost
          >
        >,
        TError,
        { candidateId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof researchCandidateApiV1RecruitingCandidatesCandidateIdAiResearchPost
      >
    >,
    TError,
    { candidateId: string },
    TContext
  > => {
    const mutationOptions =
      getResearchCandidateApiV1RecruitingCandidatesCandidateIdAiResearchPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Get recruiting dashboard statistics.

Served through the shared KPI substrate (schema-first ``response_model`` +
``cached_kpi``); see docs/platform/dashboard-kpi-endpoints.md. The accessible-job /
accessible-candidate sets are resolved HERE, outside ``cached_kpi``, per the
substrate's ordering invariant — resolution writes the bounded ``admin_override_read``
audit row for a Full-Access admin's universal read, which a cache hit must not skip.
Sharing §5: every KPI is scoped to those sets (None ⇒ everyone mode for that axis, no
filter — byte-for-byte today), so the payload is per-viewer and keyed on admin_scope.
 * @summary Get Dashboard Stats
 */
export const getDashboardStatsApiV1RecruitingReportsDashboardGet = (
  params?: GetDashboardStatsApiV1RecruitingReportsDashboardGetParams,
  signal?: AbortSignal
) => {
  return customInstance<RecruitingDashboard>({
    url: `/api/v1/recruiting/reports/dashboard`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetDashboardStatsApiV1RecruitingReportsDashboardGetQueryKey = (
  params?: GetDashboardStatsApiV1RecruitingReportsDashboardGetParams
) => {
  return [
    `/api/v1/recruiting/reports/dashboard`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetDashboardStatsApiV1RecruitingReportsDashboardGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getDashboardStatsApiV1RecruitingReportsDashboardGet>
    >,
    TError = HTTPValidationError
  >(
    params?: GetDashboardStatsApiV1RecruitingReportsDashboardGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getDashboardStatsApiV1RecruitingReportsDashboardGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetDashboardStatsApiV1RecruitingReportsDashboardGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getDashboardStatsApiV1RecruitingReportsDashboardGet>
      >
    > = ({ signal }) =>
      getDashboardStatsApiV1RecruitingReportsDashboardGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getDashboardStatsApiV1RecruitingReportsDashboardGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetDashboardStatsApiV1RecruitingReportsDashboardGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getDashboardStatsApiV1RecruitingReportsDashboardGet>
    >
  >;
export type GetDashboardStatsApiV1RecruitingReportsDashboardGetQueryError =
  HTTPValidationError;

export function useGetDashboardStatsApiV1RecruitingReportsDashboardGet<
  TData = Awaited<
    ReturnType<typeof getDashboardStatsApiV1RecruitingReportsDashboardGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | GetDashboardStatsApiV1RecruitingReportsDashboardGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDashboardStatsApiV1RecruitingReportsDashboardGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDashboardStatsApiV1RecruitingReportsDashboardGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDashboardStatsApiV1RecruitingReportsDashboardGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDashboardStatsApiV1RecruitingReportsDashboardGet<
  TData = Awaited<
    ReturnType<typeof getDashboardStatsApiV1RecruitingReportsDashboardGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetDashboardStatsApiV1RecruitingReportsDashboardGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDashboardStatsApiV1RecruitingReportsDashboardGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDashboardStatsApiV1RecruitingReportsDashboardGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDashboardStatsApiV1RecruitingReportsDashboardGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDashboardStatsApiV1RecruitingReportsDashboardGet<
  TData = Awaited<
    ReturnType<typeof getDashboardStatsApiV1RecruitingReportsDashboardGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetDashboardStatsApiV1RecruitingReportsDashboardGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDashboardStatsApiV1RecruitingReportsDashboardGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Dashboard Stats
 */

export function useGetDashboardStatsApiV1RecruitingReportsDashboardGet<
  TData = Awaited<
    ReturnType<typeof getDashboardStatsApiV1RecruitingReportsDashboardGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetDashboardStatsApiV1RecruitingReportsDashboardGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDashboardStatsApiV1RecruitingReportsDashboardGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetDashboardStatsApiV1RecruitingReportsDashboardGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get pipeline funnel data.
 * @summary Get Pipeline Funnel
 */
export const getPipelineFunnelApiV1RecruitingReportsPipelineFunnelGet = (
  params?: GetPipelineFunnelApiV1RecruitingReportsPipelineFunnelGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/reports/pipeline-funnel`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetPipelineFunnelApiV1RecruitingReportsPipelineFunnelGetQueryKey =
  (params?: GetPipelineFunnelApiV1RecruitingReportsPipelineFunnelGetParams) => {
    return [
      `/api/v1/recruiting/reports/pipeline-funnel`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetPipelineFunnelApiV1RecruitingReportsPipelineFunnelGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getPipelineFunnelApiV1RecruitingReportsPipelineFunnelGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: GetPipelineFunnelApiV1RecruitingReportsPipelineFunnelGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getPipelineFunnelApiV1RecruitingReportsPipelineFunnelGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetPipelineFunnelApiV1RecruitingReportsPipelineFunnelGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getPipelineFunnelApiV1RecruitingReportsPipelineFunnelGet
        >
      >
    > = ({ signal }) =>
      getPipelineFunnelApiV1RecruitingReportsPipelineFunnelGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getPipelineFunnelApiV1RecruitingReportsPipelineFunnelGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetPipelineFunnelApiV1RecruitingReportsPipelineFunnelGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getPipelineFunnelApiV1RecruitingReportsPipelineFunnelGet
      >
    >
  >;
export type GetPipelineFunnelApiV1RecruitingReportsPipelineFunnelGetQueryError =
  HTTPValidationError;

export function useGetPipelineFunnelApiV1RecruitingReportsPipelineFunnelGet<
  TData = Awaited<
    ReturnType<typeof getPipelineFunnelApiV1RecruitingReportsPipelineFunnelGet>
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | GetPipelineFunnelApiV1RecruitingReportsPipelineFunnelGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPipelineFunnelApiV1RecruitingReportsPipelineFunnelGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getPipelineFunnelApiV1RecruitingReportsPipelineFunnelGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getPipelineFunnelApiV1RecruitingReportsPipelineFunnelGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetPipelineFunnelApiV1RecruitingReportsPipelineFunnelGet<
  TData = Awaited<
    ReturnType<typeof getPipelineFunnelApiV1RecruitingReportsPipelineFunnelGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetPipelineFunnelApiV1RecruitingReportsPipelineFunnelGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPipelineFunnelApiV1RecruitingReportsPipelineFunnelGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getPipelineFunnelApiV1RecruitingReportsPipelineFunnelGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getPipelineFunnelApiV1RecruitingReportsPipelineFunnelGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetPipelineFunnelApiV1RecruitingReportsPipelineFunnelGet<
  TData = Awaited<
    ReturnType<typeof getPipelineFunnelApiV1RecruitingReportsPipelineFunnelGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetPipelineFunnelApiV1RecruitingReportsPipelineFunnelGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPipelineFunnelApiV1RecruitingReportsPipelineFunnelGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Pipeline Funnel
 */

export function useGetPipelineFunnelApiV1RecruitingReportsPipelineFunnelGet<
  TData = Awaited<
    ReturnType<typeof getPipelineFunnelApiV1RecruitingReportsPipelineFunnelGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetPipelineFunnelApiV1RecruitingReportsPipelineFunnelGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPipelineFunnelApiV1RecruitingReportsPipelineFunnelGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetPipelineFunnelApiV1RecruitingReportsPipelineFunnelGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get source channel effectiveness stats.
 * @summary Get Source Effectiveness
 */
export const getSourceEffectivenessApiV1RecruitingReportsSourceEffectivenessGet =
  (
    params?: GetSourceEffectivenessApiV1RecruitingReportsSourceEffectivenessGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/recruiting/reports/source-effectiveness`,
      method: 'GET',
      params,
      signal
    });
  };

export const getGetSourceEffectivenessApiV1RecruitingReportsSourceEffectivenessGetQueryKey =
  (
    params?: GetSourceEffectivenessApiV1RecruitingReportsSourceEffectivenessGetParams
  ) => {
    return [
      `/api/v1/recruiting/reports/source-effectiveness`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetSourceEffectivenessApiV1RecruitingReportsSourceEffectivenessGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getSourceEffectivenessApiV1RecruitingReportsSourceEffectivenessGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: GetSourceEffectivenessApiV1RecruitingReportsSourceEffectivenessGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getSourceEffectivenessApiV1RecruitingReportsSourceEffectivenessGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetSourceEffectivenessApiV1RecruitingReportsSourceEffectivenessGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getSourceEffectivenessApiV1RecruitingReportsSourceEffectivenessGet
        >
      >
    > = ({ signal }) =>
      getSourceEffectivenessApiV1RecruitingReportsSourceEffectivenessGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getSourceEffectivenessApiV1RecruitingReportsSourceEffectivenessGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetSourceEffectivenessApiV1RecruitingReportsSourceEffectivenessGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getSourceEffectivenessApiV1RecruitingReportsSourceEffectivenessGet
      >
    >
  >;
export type GetSourceEffectivenessApiV1RecruitingReportsSourceEffectivenessGetQueryError =
  HTTPValidationError;

export function useGetSourceEffectivenessApiV1RecruitingReportsSourceEffectivenessGet<
  TData = Awaited<
    ReturnType<
      typeof getSourceEffectivenessApiV1RecruitingReportsSourceEffectivenessGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | GetSourceEffectivenessApiV1RecruitingReportsSourceEffectivenessGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSourceEffectivenessApiV1RecruitingReportsSourceEffectivenessGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getSourceEffectivenessApiV1RecruitingReportsSourceEffectivenessGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getSourceEffectivenessApiV1RecruitingReportsSourceEffectivenessGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetSourceEffectivenessApiV1RecruitingReportsSourceEffectivenessGet<
  TData = Awaited<
    ReturnType<
      typeof getSourceEffectivenessApiV1RecruitingReportsSourceEffectivenessGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: GetSourceEffectivenessApiV1RecruitingReportsSourceEffectivenessGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSourceEffectivenessApiV1RecruitingReportsSourceEffectivenessGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getSourceEffectivenessApiV1RecruitingReportsSourceEffectivenessGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getSourceEffectivenessApiV1RecruitingReportsSourceEffectivenessGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSourceEffectivenessApiV1RecruitingReportsSourceEffectivenessGet<
  TData = Awaited<
    ReturnType<
      typeof getSourceEffectivenessApiV1RecruitingReportsSourceEffectivenessGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: GetSourceEffectivenessApiV1RecruitingReportsSourceEffectivenessGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSourceEffectivenessApiV1RecruitingReportsSourceEffectivenessGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Source Effectiveness
 */

export function useGetSourceEffectivenessApiV1RecruitingReportsSourceEffectivenessGet<
  TData = Awaited<
    ReturnType<
      typeof getSourceEffectivenessApiV1RecruitingReportsSourceEffectivenessGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: GetSourceEffectivenessApiV1RecruitingReportsSourceEffectivenessGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSourceEffectivenessApiV1RecruitingReportsSourceEffectivenessGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetSourceEffectivenessApiV1RecruitingReportsSourceEffectivenessGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get time-to-hire analytics.
 * @summary Get Time To Hire
 */
export const getTimeToHireApiV1RecruitingReportsTimeToHireGet = (
  params?: GetTimeToHireApiV1RecruitingReportsTimeToHireGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/reports/time-to-hire`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetTimeToHireApiV1RecruitingReportsTimeToHireGetQueryKey = (
  params?: GetTimeToHireApiV1RecruitingReportsTimeToHireGetParams
) => {
  return [
    `/api/v1/recruiting/reports/time-to-hire`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetTimeToHireApiV1RecruitingReportsTimeToHireGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getTimeToHireApiV1RecruitingReportsTimeToHireGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetTimeToHireApiV1RecruitingReportsTimeToHireGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTimeToHireApiV1RecruitingReportsTimeToHireGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTimeToHireApiV1RecruitingReportsTimeToHireGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTimeToHireApiV1RecruitingReportsTimeToHireGet>>
  > = ({ signal }) =>
    getTimeToHireApiV1RecruitingReportsTimeToHireGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<typeof getTimeToHireApiV1RecruitingReportsTimeToHireGet>
    >,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTimeToHireApiV1RecruitingReportsTimeToHireGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getTimeToHireApiV1RecruitingReportsTimeToHireGet>>
  >;
export type GetTimeToHireApiV1RecruitingReportsTimeToHireGetQueryError =
  HTTPValidationError;

export function useGetTimeToHireApiV1RecruitingReportsTimeToHireGet<
  TData = Awaited<
    ReturnType<typeof getTimeToHireApiV1RecruitingReportsTimeToHireGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | GetTimeToHireApiV1RecruitingReportsTimeToHireGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTimeToHireApiV1RecruitingReportsTimeToHireGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getTimeToHireApiV1RecruitingReportsTimeToHireGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getTimeToHireApiV1RecruitingReportsTimeToHireGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTimeToHireApiV1RecruitingReportsTimeToHireGet<
  TData = Awaited<
    ReturnType<typeof getTimeToHireApiV1RecruitingReportsTimeToHireGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetTimeToHireApiV1RecruitingReportsTimeToHireGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTimeToHireApiV1RecruitingReportsTimeToHireGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getTimeToHireApiV1RecruitingReportsTimeToHireGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getTimeToHireApiV1RecruitingReportsTimeToHireGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTimeToHireApiV1RecruitingReportsTimeToHireGet<
  TData = Awaited<
    ReturnType<typeof getTimeToHireApiV1RecruitingReportsTimeToHireGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetTimeToHireApiV1RecruitingReportsTimeToHireGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTimeToHireApiV1RecruitingReportsTimeToHireGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Time To Hire
 */

export function useGetTimeToHireApiV1RecruitingReportsTimeToHireGet<
  TData = Awaited<
    ReturnType<typeof getTimeToHireApiV1RecruitingReportsTimeToHireGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetTimeToHireApiV1RecruitingReportsTimeToHireGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTimeToHireApiV1RecruitingReportsTimeToHireGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetTimeToHireApiV1RecruitingReportsTimeToHireGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new job offer.
 * @summary Create Offer
 */
export const createOfferApiV1RecruitingOffersPost = (
  createOfferRequest: CreateOfferRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/offers`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createOfferRequest,
    signal
  });
};

export const getCreateOfferApiV1RecruitingOffersPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOfferApiV1RecruitingOffersPost>>,
    TError,
    { data: CreateOfferRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOfferApiV1RecruitingOffersPost>>,
  TError,
  { data: CreateOfferRequest },
  TContext
> => {
  const mutationKey = ['createOfferApiV1RecruitingOffersPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOfferApiV1RecruitingOffersPost>>,
    { data: CreateOfferRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createOfferApiV1RecruitingOffersPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateOfferApiV1RecruitingOffersPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOfferApiV1RecruitingOffersPost>>
>;
export type CreateOfferApiV1RecruitingOffersPostMutationBody =
  CreateOfferRequest;
export type CreateOfferApiV1RecruitingOffersPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Offer
 */
export const useCreateOfferApiV1RecruitingOffersPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createOfferApiV1RecruitingOffersPost>>,
      TError,
      { data: CreateOfferRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createOfferApiV1RecruitingOffersPost>>,
  TError,
  { data: CreateOfferRequest },
  TContext
> => {
  const mutationOptions =
    getCreateOfferApiV1RecruitingOffersPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * List offers with optional filters.
 * @summary List Offers
 */
export const listOffersApiV1RecruitingOffersGet = (
  params?: ListOffersApiV1RecruitingOffersGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/offers`,
    method: 'GET',
    params,
    signal
  });
};

export const getListOffersApiV1RecruitingOffersGetQueryKey = (
  params?: ListOffersApiV1RecruitingOffersGetParams
) => {
  return [`/api/v1/recruiting/offers`, ...(params ? [params] : [])] as const;
};

export const getListOffersApiV1RecruitingOffersGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listOffersApiV1RecruitingOffersGet>>,
  TError = HTTPValidationError
>(
  params?: ListOffersApiV1RecruitingOffersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOffersApiV1RecruitingOffersGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListOffersApiV1RecruitingOffersGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOffersApiV1RecruitingOffersGet>>
  > = ({ signal }) => listOffersApiV1RecruitingOffersGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listOffersApiV1RecruitingOffersGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListOffersApiV1RecruitingOffersGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOffersApiV1RecruitingOffersGet>>
>;
export type ListOffersApiV1RecruitingOffersGetQueryError = HTTPValidationError;

export function useListOffersApiV1RecruitingOffersGet<
  TData = Awaited<ReturnType<typeof listOffersApiV1RecruitingOffersGet>>,
  TError = HTTPValidationError
>(
  params: undefined | ListOffersApiV1RecruitingOffersGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOffersApiV1RecruitingOffersGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOffersApiV1RecruitingOffersGet>>,
          TError,
          Awaited<ReturnType<typeof listOffersApiV1RecruitingOffersGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListOffersApiV1RecruitingOffersGet<
  TData = Awaited<ReturnType<typeof listOffersApiV1RecruitingOffersGet>>,
  TError = HTTPValidationError
>(
  params?: ListOffersApiV1RecruitingOffersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOffersApiV1RecruitingOffersGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOffersApiV1RecruitingOffersGet>>,
          TError,
          Awaited<ReturnType<typeof listOffersApiV1RecruitingOffersGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListOffersApiV1RecruitingOffersGet<
  TData = Awaited<ReturnType<typeof listOffersApiV1RecruitingOffersGet>>,
  TError = HTTPValidationError
>(
  params?: ListOffersApiV1RecruitingOffersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOffersApiV1RecruitingOffersGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Offers
 */

export function useListOffersApiV1RecruitingOffersGet<
  TData = Awaited<ReturnType<typeof listOffersApiV1RecruitingOffersGet>>,
  TError = HTTPValidationError
>(
  params?: ListOffersApiV1RecruitingOffersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOffersApiV1RecruitingOffersGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListOffersApiV1RecruitingOffersGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a single offer.
 * @summary Get Offer
 */
export const getOfferApiV1RecruitingOffersOfferIdGet = (
  offerId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/offers/${offerId}`,
    method: 'GET',
    signal
  });
};

export const getGetOfferApiV1RecruitingOffersOfferIdGetQueryKey = (
  offerId?: string
) => {
  return [`/api/v1/recruiting/offers/${offerId}`] as const;
};

export const getGetOfferApiV1RecruitingOffersOfferIdGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getOfferApiV1RecruitingOffersOfferIdGet>>,
  TError = HTTPValidationError
>(
  offerId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOfferApiV1RecruitingOffersOfferIdGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetOfferApiV1RecruitingOffersOfferIdGetQueryKey(offerId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOfferApiV1RecruitingOffersOfferIdGet>>
  > = ({ signal }) => getOfferApiV1RecruitingOffersOfferIdGet(offerId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!offerId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getOfferApiV1RecruitingOffersOfferIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetOfferApiV1RecruitingOffersOfferIdGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOfferApiV1RecruitingOffersOfferIdGet>>
>;
export type GetOfferApiV1RecruitingOffersOfferIdGetQueryError =
  HTTPValidationError;

export function useGetOfferApiV1RecruitingOffersOfferIdGet<
  TData = Awaited<ReturnType<typeof getOfferApiV1RecruitingOffersOfferIdGet>>,
  TError = HTTPValidationError
>(
  offerId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOfferApiV1RecruitingOffersOfferIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOfferApiV1RecruitingOffersOfferIdGet>>,
          TError,
          Awaited<ReturnType<typeof getOfferApiV1RecruitingOffersOfferIdGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetOfferApiV1RecruitingOffersOfferIdGet<
  TData = Awaited<ReturnType<typeof getOfferApiV1RecruitingOffersOfferIdGet>>,
  TError = HTTPValidationError
>(
  offerId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOfferApiV1RecruitingOffersOfferIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOfferApiV1RecruitingOffersOfferIdGet>>,
          TError,
          Awaited<ReturnType<typeof getOfferApiV1RecruitingOffersOfferIdGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetOfferApiV1RecruitingOffersOfferIdGet<
  TData = Awaited<ReturnType<typeof getOfferApiV1RecruitingOffersOfferIdGet>>,
  TError = HTTPValidationError
>(
  offerId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOfferApiV1RecruitingOffersOfferIdGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Offer
 */

export function useGetOfferApiV1RecruitingOffersOfferIdGet<
  TData = Awaited<ReturnType<typeof getOfferApiV1RecruitingOffersOfferIdGet>>,
  TError = HTTPValidationError
>(
  offerId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOfferApiV1RecruitingOffersOfferIdGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetOfferApiV1RecruitingOffersOfferIdGetQueryOptions(
    offerId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update an offer.
 * @summary Update Offer
 */
export const updateOfferApiV1RecruitingOffersOfferIdPut = (
  offerId: string,
  updateOfferRequest: UpdateOfferRequest
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/offers/${offerId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateOfferRequest
  });
};

export const getUpdateOfferApiV1RecruitingOffersOfferIdPutMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOfferApiV1RecruitingOffersOfferIdPut>>,
    TError,
    { offerId: string; data: UpdateOfferRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOfferApiV1RecruitingOffersOfferIdPut>>,
  TError,
  { offerId: string; data: UpdateOfferRequest },
  TContext
> => {
  const mutationKey = ['updateOfferApiV1RecruitingOffersOfferIdPut'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOfferApiV1RecruitingOffersOfferIdPut>>,
    { offerId: string; data: UpdateOfferRequest }
  > = (props) => {
    const { offerId, data } = props ?? {};

    return updateOfferApiV1RecruitingOffersOfferIdPut(offerId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateOfferApiV1RecruitingOffersOfferIdPutMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateOfferApiV1RecruitingOffersOfferIdPut>>
  >;
export type UpdateOfferApiV1RecruitingOffersOfferIdPutMutationBody =
  UpdateOfferRequest;
export type UpdateOfferApiV1RecruitingOffersOfferIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Offer
 */
export const useUpdateOfferApiV1RecruitingOffersOfferIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateOfferApiV1RecruitingOffersOfferIdPut>>,
      TError,
      { offerId: string; data: UpdateOfferRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateOfferApiV1RecruitingOffersOfferIdPut>>,
  TError,
  { offerId: string; data: UpdateOfferRequest },
  TContext
> => {
  const mutationOptions =
    getUpdateOfferApiV1RecruitingOffersOfferIdPutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Submit an offer for approval.
 * @summary Submit Offer For Approval
 */
export const submitOfferForApprovalApiV1RecruitingOffersOfferIdSubmitForApprovalPost =
  (offerId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/recruiting/offers/${offerId}/submit-for-approval`,
      method: 'POST',
      signal
    });
  };

export const getSubmitOfferForApprovalApiV1RecruitingOffersOfferIdSubmitForApprovalPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof submitOfferForApprovalApiV1RecruitingOffersOfferIdSubmitForApprovalPost
        >
      >,
      TError,
      { offerId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof submitOfferForApprovalApiV1RecruitingOffersOfferIdSubmitForApprovalPost
      >
    >,
    TError,
    { offerId: string },
    TContext
  > => {
    const mutationKey = [
      'submitOfferForApprovalApiV1RecruitingOffersOfferIdSubmitForApprovalPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof submitOfferForApprovalApiV1RecruitingOffersOfferIdSubmitForApprovalPost
        >
      >,
      { offerId: string }
    > = (props) => {
      const { offerId } = props ?? {};

      return submitOfferForApprovalApiV1RecruitingOffersOfferIdSubmitForApprovalPost(
        offerId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type SubmitOfferForApprovalApiV1RecruitingOffersOfferIdSubmitForApprovalPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof submitOfferForApprovalApiV1RecruitingOffersOfferIdSubmitForApprovalPost
      >
    >
  >;

export type SubmitOfferForApprovalApiV1RecruitingOffersOfferIdSubmitForApprovalPostMutationError =
  HTTPValidationError;

/**
 * @summary Submit Offer For Approval
 */
export const useSubmitOfferForApprovalApiV1RecruitingOffersOfferIdSubmitForApprovalPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof submitOfferForApprovalApiV1RecruitingOffersOfferIdSubmitForApprovalPost
          >
        >,
        TError,
        { offerId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof submitOfferForApprovalApiV1RecruitingOffersOfferIdSubmitForApprovalPost
      >
    >,
    TError,
    { offerId: string },
    TContext
  > => {
    const mutationOptions =
      getSubmitOfferForApprovalApiV1RecruitingOffersOfferIdSubmitForApprovalPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Approve an offer.
 * @summary Approve Offer
 */
export const approveOfferApiV1RecruitingOffersOfferIdApprovePost = (
  offerId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/offers/${offerId}/approve`,
    method: 'POST',
    signal
  });
};

export const getApproveOfferApiV1RecruitingOffersOfferIdApprovePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof approveOfferApiV1RecruitingOffersOfferIdApprovePost>
      >,
      TError,
      { offerId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof approveOfferApiV1RecruitingOffersOfferIdApprovePost>
    >,
    TError,
    { offerId: string },
    TContext
  > => {
    const mutationKey = ['approveOfferApiV1RecruitingOffersOfferIdApprovePost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof approveOfferApiV1RecruitingOffersOfferIdApprovePost>
      >,
      { offerId: string }
    > = (props) => {
      const { offerId } = props ?? {};

      return approveOfferApiV1RecruitingOffersOfferIdApprovePost(offerId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ApproveOfferApiV1RecruitingOffersOfferIdApprovePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof approveOfferApiV1RecruitingOffersOfferIdApprovePost>
    >
  >;

export type ApproveOfferApiV1RecruitingOffersOfferIdApprovePostMutationError =
  HTTPValidationError;

/**
 * @summary Approve Offer
 */
export const useApproveOfferApiV1RecruitingOffersOfferIdApprovePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof approveOfferApiV1RecruitingOffersOfferIdApprovePost>
      >,
      TError,
      { offerId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof approveOfferApiV1RecruitingOffersOfferIdApprovePost>
  >,
  TError,
  { offerId: string },
  TContext
> => {
  const mutationOptions =
    getApproveOfferApiV1RecruitingOffersOfferIdApprovePostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Mark an offer as sent to the candidate.
 * @summary Send Offer
 */
export const sendOfferApiV1RecruitingOffersOfferIdSendPost = (
  offerId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/offers/${offerId}/send`,
    method: 'POST',
    signal
  });
};

export const getSendOfferApiV1RecruitingOffersOfferIdSendPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendOfferApiV1RecruitingOffersOfferIdSendPost>>,
    TError,
    { offerId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendOfferApiV1RecruitingOffersOfferIdSendPost>>,
  TError,
  { offerId: string },
  TContext
> => {
  const mutationKey = ['sendOfferApiV1RecruitingOffersOfferIdSendPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendOfferApiV1RecruitingOffersOfferIdSendPost>>,
    { offerId: string }
  > = (props) => {
    const { offerId } = props ?? {};

    return sendOfferApiV1RecruitingOffersOfferIdSendPost(offerId);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendOfferApiV1RecruitingOffersOfferIdSendPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof sendOfferApiV1RecruitingOffersOfferIdSendPost>>
  >;

export type SendOfferApiV1RecruitingOffersOfferIdSendPostMutationError =
  HTTPValidationError;

/**
 * @summary Send Offer
 */
export const useSendOfferApiV1RecruitingOffersOfferIdSendPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sendOfferApiV1RecruitingOffersOfferIdSendPost>>,
      TError,
      { offerId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof sendOfferApiV1RecruitingOffersOfferIdSendPost>>,
  TError,
  { offerId: string },
  TContext
> => {
  const mutationOptions =
    getSendOfferApiV1RecruitingOffersOfferIdSendPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Record candidate response to an offer.
 * @summary Respond To Offer
 */
export const respondToOfferApiV1RecruitingOffersOfferIdRespondPost = (
  offerId: string,
  params: RespondToOfferApiV1RecruitingOffersOfferIdRespondPostParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/offers/${offerId}/respond`,
    method: 'POST',
    params,
    signal
  });
};

export const getRespondToOfferApiV1RecruitingOffersOfferIdRespondPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof respondToOfferApiV1RecruitingOffersOfferIdRespondPost>
      >,
      TError,
      {
        offerId: string;
        params: RespondToOfferApiV1RecruitingOffersOfferIdRespondPostParams;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof respondToOfferApiV1RecruitingOffersOfferIdRespondPost>
    >,
    TError,
    {
      offerId: string;
      params: RespondToOfferApiV1RecruitingOffersOfferIdRespondPostParams;
    },
    TContext
  > => {
    const mutationKey = [
      'respondToOfferApiV1RecruitingOffersOfferIdRespondPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof respondToOfferApiV1RecruitingOffersOfferIdRespondPost>
      >,
      {
        offerId: string;
        params: RespondToOfferApiV1RecruitingOffersOfferIdRespondPostParams;
      }
    > = (props) => {
      const { offerId, params } = props ?? {};

      return respondToOfferApiV1RecruitingOffersOfferIdRespondPost(
        offerId,
        params
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RespondToOfferApiV1RecruitingOffersOfferIdRespondPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof respondToOfferApiV1RecruitingOffersOfferIdRespondPost>
    >
  >;

export type RespondToOfferApiV1RecruitingOffersOfferIdRespondPostMutationError =
  HTTPValidationError;

/**
 * @summary Respond To Offer
 */
export const useRespondToOfferApiV1RecruitingOffersOfferIdRespondPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof respondToOfferApiV1RecruitingOffersOfferIdRespondPost>
      >,
      TError,
      {
        offerId: string;
        params: RespondToOfferApiV1RecruitingOffersOfferIdRespondPostParams;
      },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof respondToOfferApiV1RecruitingOffersOfferIdRespondPost>
  >,
  TError,
  {
    offerId: string;
    params: RespondToOfferApiV1RecruitingOffersOfferIdRespondPostParams;
  },
  TContext
> => {
  const mutationOptions =
    getRespondToOfferApiV1RecruitingOffersOfferIdRespondPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Withdraw an offer.
 * @summary Withdraw Offer
 */
export const withdrawOfferApiV1RecruitingOffersOfferIdWithdrawPost = (
  offerId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/offers/${offerId}/withdraw`,
    method: 'POST',
    signal
  });
};

export const getWithdrawOfferApiV1RecruitingOffersOfferIdWithdrawPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof withdrawOfferApiV1RecruitingOffersOfferIdWithdrawPost>
      >,
      TError,
      { offerId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof withdrawOfferApiV1RecruitingOffersOfferIdWithdrawPost>
    >,
    TError,
    { offerId: string },
    TContext
  > => {
    const mutationKey = [
      'withdrawOfferApiV1RecruitingOffersOfferIdWithdrawPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof withdrawOfferApiV1RecruitingOffersOfferIdWithdrawPost>
      >,
      { offerId: string }
    > = (props) => {
      const { offerId } = props ?? {};

      return withdrawOfferApiV1RecruitingOffersOfferIdWithdrawPost(offerId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type WithdrawOfferApiV1RecruitingOffersOfferIdWithdrawPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof withdrawOfferApiV1RecruitingOffersOfferIdWithdrawPost>
    >
  >;

export type WithdrawOfferApiV1RecruitingOffersOfferIdWithdrawPostMutationError =
  HTTPValidationError;

/**
 * @summary Withdraw Offer
 */
export const useWithdrawOfferApiV1RecruitingOffersOfferIdWithdrawPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof withdrawOfferApiV1RecruitingOffersOfferIdWithdrawPost>
      >,
      TError,
      { offerId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof withdrawOfferApiV1RecruitingOffersOfferIdWithdrawPost>
  >,
  TError,
  { offerId: string },
  TContext
> => {
  const mutationOptions =
    getWithdrawOfferApiV1RecruitingOffersOfferIdWithdrawPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Create a self-scheduling link for a candidate.
 * @summary Create Scheduling Link
 */
export const createSchedulingLinkApiV1RecruitingSchedulingCreateLinkPost = (
  createSchedulingLinkRequest: CreateSchedulingLinkRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/scheduling/create-link`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createSchedulingLinkRequest,
    signal
  });
};

export const getCreateSchedulingLinkApiV1RecruitingSchedulingCreateLinkPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createSchedulingLinkApiV1RecruitingSchedulingCreateLinkPost
        >
      >,
      TError,
      { data: CreateSchedulingLinkRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createSchedulingLinkApiV1RecruitingSchedulingCreateLinkPost
      >
    >,
    TError,
    { data: CreateSchedulingLinkRequest },
    TContext
  > => {
    const mutationKey = [
      'createSchedulingLinkApiV1RecruitingSchedulingCreateLinkPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createSchedulingLinkApiV1RecruitingSchedulingCreateLinkPost
        >
      >,
      { data: CreateSchedulingLinkRequest }
    > = (props) => {
      const { data } = props ?? {};

      return createSchedulingLinkApiV1RecruitingSchedulingCreateLinkPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateSchedulingLinkApiV1RecruitingSchedulingCreateLinkPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createSchedulingLinkApiV1RecruitingSchedulingCreateLinkPost
      >
    >
  >;
export type CreateSchedulingLinkApiV1RecruitingSchedulingCreateLinkPostMutationBody =
  CreateSchedulingLinkRequest;
export type CreateSchedulingLinkApiV1RecruitingSchedulingCreateLinkPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Scheduling Link
 */
export const useCreateSchedulingLinkApiV1RecruitingSchedulingCreateLinkPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createSchedulingLinkApiV1RecruitingSchedulingCreateLinkPost
        >
      >,
      TError,
      { data: CreateSchedulingLinkRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof createSchedulingLinkApiV1RecruitingSchedulingCreateLinkPost
    >
  >,
  TError,
  { data: CreateSchedulingLinkRequest },
  TContext
> => {
  const mutationOptions =
    getCreateSchedulingLinkApiV1RecruitingSchedulingCreateLinkPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get scheduling link info, addressed by the candidate's link credential.

The credential arrives in ``X-Public-Token``
(``shared/dependencies/public_token.py``), never in the URL. It used to be the
route's path segment, and a path segment is recorded exactly like a query
string: browser history, ``Referer``, every intermediary, and — since
WI 3c4834eb — the ALB and CloudFront access logs at 90-day retention. This
token is bearer-equivalent for a candidate's name, the job they applied to and
the power to book an interview, so anyone with S3 read on that bucket could
lift a live one and act as the candidate.

The old ``/scheduling/{token}`` shape is GONE, not merely unread: it 404s, and a
request with no header 401s at the dependency. An already-issued link therefore
fails closed rather than working while logging the credential.

Documented "public endpoint - no auth required", and it is not: ``app.py``
includes ``recruiting_router`` behind ``require_module("recruiting")``, which
depends on ``require_auth``, so an anonymous candidate gets 401 before this body
runs. That is a separate defect from the one this route was converted for, and it
is deliberately left standing here rather than changed under a credential-channel
fix — see the ``set_request_sysadmin`` elevation below, which only makes sense for
the anonymous caller this was written for.
 * @summary Get Scheduling Info
 */
export const getSchedulingInfoApiV1RecruitingSchedulingLinkGet = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/scheduling/link`,
    method: 'GET',
    signal
  });
};

export const getGetSchedulingInfoApiV1RecruitingSchedulingLinkGetQueryKey =
  () => {
    return [`/api/v1/recruiting/scheduling/link`] as const;
  };

export const getGetSchedulingInfoApiV1RecruitingSchedulingLinkGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getSchedulingInfoApiV1RecruitingSchedulingLinkGet>
    >,
    TError = HTTPValidationError
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getSchedulingInfoApiV1RecruitingSchedulingLinkGet>
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetSchedulingInfoApiV1RecruitingSchedulingLinkGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getSchedulingInfoApiV1RecruitingSchedulingLinkGet>
      >
    > = ({ signal }) =>
      getSchedulingInfoApiV1RecruitingSchedulingLinkGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getSchedulingInfoApiV1RecruitingSchedulingLinkGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetSchedulingInfoApiV1RecruitingSchedulingLinkGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getSchedulingInfoApiV1RecruitingSchedulingLinkGet>
    >
  >;
export type GetSchedulingInfoApiV1RecruitingSchedulingLinkGetQueryError =
  HTTPValidationError;

export function useGetSchedulingInfoApiV1RecruitingSchedulingLinkGet<
  TData = Awaited<
    ReturnType<typeof getSchedulingInfoApiV1RecruitingSchedulingLinkGet>
  >,
  TError = HTTPValidationError
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getSchedulingInfoApiV1RecruitingSchedulingLinkGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getSchedulingInfoApiV1RecruitingSchedulingLinkGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getSchedulingInfoApiV1RecruitingSchedulingLinkGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetSchedulingInfoApiV1RecruitingSchedulingLinkGet<
  TData = Awaited<
    ReturnType<typeof getSchedulingInfoApiV1RecruitingSchedulingLinkGet>
  >,
  TError = HTTPValidationError
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getSchedulingInfoApiV1RecruitingSchedulingLinkGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getSchedulingInfoApiV1RecruitingSchedulingLinkGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getSchedulingInfoApiV1RecruitingSchedulingLinkGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSchedulingInfoApiV1RecruitingSchedulingLinkGet<
  TData = Awaited<
    ReturnType<typeof getSchedulingInfoApiV1RecruitingSchedulingLinkGet>
  >,
  TError = HTTPValidationError
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getSchedulingInfoApiV1RecruitingSchedulingLinkGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Scheduling Info
 */

export function useGetSchedulingInfoApiV1RecruitingSchedulingLinkGet<
  TData = Awaited<
    ReturnType<typeof getSchedulingInfoApiV1RecruitingSchedulingLinkGet>
  >,
  TError = HTTPValidationError
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getSchedulingInfoApiV1RecruitingSchedulingLinkGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetSchedulingInfoApiV1RecruitingSchedulingLinkGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Candidate selects a time slot, addressed by their link credential.

Same channel and same reasoning as ``get_scheduling_info`` above: the credential
is ``X-Public-Token``, the old ``/scheduling/{token}/select-slot`` path is gone,
and the auth posture is untouched.
 * @summary Select Scheduling Slot
 */
export const selectSchedulingSlotApiV1RecruitingSchedulingLinkSelectSlotPost = (
  selectSlotRequest: SelectSlotRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/scheduling/link/select-slot`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: selectSlotRequest,
    signal
  });
};

export const getSelectSchedulingSlotApiV1RecruitingSchedulingLinkSelectSlotPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof selectSchedulingSlotApiV1RecruitingSchedulingLinkSelectSlotPost
        >
      >,
      TError,
      { data: SelectSlotRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof selectSchedulingSlotApiV1RecruitingSchedulingLinkSelectSlotPost
      >
    >,
    TError,
    { data: SelectSlotRequest },
    TContext
  > => {
    const mutationKey = [
      'selectSchedulingSlotApiV1RecruitingSchedulingLinkSelectSlotPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof selectSchedulingSlotApiV1RecruitingSchedulingLinkSelectSlotPost
        >
      >,
      { data: SelectSlotRequest }
    > = (props) => {
      const { data } = props ?? {};

      return selectSchedulingSlotApiV1RecruitingSchedulingLinkSelectSlotPost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type SelectSchedulingSlotApiV1RecruitingSchedulingLinkSelectSlotPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof selectSchedulingSlotApiV1RecruitingSchedulingLinkSelectSlotPost
      >
    >
  >;
export type SelectSchedulingSlotApiV1RecruitingSchedulingLinkSelectSlotPostMutationBody =
  SelectSlotRequest;
export type SelectSchedulingSlotApiV1RecruitingSchedulingLinkSelectSlotPostMutationError =
  HTTPValidationError;

/**
 * @summary Select Scheduling Slot
 */
export const useSelectSchedulingSlotApiV1RecruitingSchedulingLinkSelectSlotPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof selectSchedulingSlotApiV1RecruitingSchedulingLinkSelectSlotPost
          >
        >,
        TError,
        { data: SelectSlotRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof selectSchedulingSlotApiV1RecruitingSchedulingLinkSelectSlotPost
      >
    >,
    TError,
    { data: SelectSlotRequest },
    TContext
  > => {
    const mutationOptions =
      getSelectSchedulingSlotApiV1RecruitingSchedulingLinkSelectSlotPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Get interview questions for a specific job-stage combination.
 * @summary Get Job Stage Questions
 */
export const getJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsGet =
  (jobId: string, stageId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/recruiting/jobs/${jobId}/stages/${stageId}/questions`,
      method: 'GET',
      signal
    });
  };

export const getGetJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsGetQueryKey =
  (jobId?: string, stageId?: string) => {
    return [
      `/api/v1/recruiting/jobs/${jobId}/stages/${stageId}/questions`
    ] as const;
  };

export const getGetJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsGet
      >
    >,
    TError = HTTPValidationError
  >(
    jobId: string,
    stageId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsGetQueryKey(
        jobId,
        stageId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsGet
        >
      >
    > = ({ signal }) =>
      getJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsGet(
        jobId,
        stageId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(jobId && stageId),
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsGet
      >
    >
  >;
export type GetJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsGetQueryError =
  HTTPValidationError;

export function useGetJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsGet<
  TData = Awaited<
    ReturnType<
      typeof getJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsGet
    >
  >,
  TError = HTTPValidationError
>(
  jobId: string,
  stageId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsGet<
  TData = Awaited<
    ReturnType<
      typeof getJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsGet
    >
  >,
  TError = HTTPValidationError
>(
  jobId: string,
  stageId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsGet<
  TData = Awaited<
    ReturnType<
      typeof getJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsGet
    >
  >,
  TError = HTTPValidationError
>(
  jobId: string,
  stageId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Job Stage Questions
 */

export function useGetJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsGet<
  TData = Awaited<
    ReturnType<
      typeof getJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsGet
    >
  >,
  TError = HTTPValidationError
>(
  jobId: string,
  stageId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsGetQueryOptions(
      jobId,
      stageId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update interview questions for a job-stage combination.
 * @summary Update Job Stage Questions
 */
export const updateJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsPut =
  (
    jobId: string,
    stageId: string,
    updateJobStageQuestionsRequest: UpdateJobStageQuestionsRequest
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/recruiting/jobs/${jobId}/stages/${stageId}/questions`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateJobStageQuestionsRequest
    });
  };

export const getUpdateJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsPut
        >
      >,
      TError,
      { jobId: string; stageId: string; data: UpdateJobStageQuestionsRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsPut
      >
    >,
    TError,
    { jobId: string; stageId: string; data: UpdateJobStageQuestionsRequest },
    TContext
  > => {
    const mutationKey = [
      'updateJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsPut
        >
      >,
      { jobId: string; stageId: string; data: UpdateJobStageQuestionsRequest }
    > = (props) => {
      const { jobId, stageId, data } = props ?? {};

      return updateJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsPut(
        jobId,
        stageId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsPut
      >
    >
  >;
export type UpdateJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsPutMutationBody =
  UpdateJobStageQuestionsRequest;
export type UpdateJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Job Stage Questions
 */
export const useUpdateJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsPut
          >
        >,
        TError,
        {
          jobId: string;
          stageId: string;
          data: UpdateJobStageQuestionsRequest;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsPut
      >
    >,
    TError,
    { jobId: string; stageId: string; data: UpdateJobStageQuestionsRequest },
    TContext
  > => {
    const mutationOptions =
      getUpdateJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Get all stage questions for a job posting.
 * @summary Get All Job Stage Questions
 */
export const getAllJobStageQuestionsApiV1RecruitingJobsJobIdStageQuestionsGet =
  (jobId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/recruiting/jobs/${jobId}/stage-questions`,
      method: 'GET',
      signal
    });
  };

export const getGetAllJobStageQuestionsApiV1RecruitingJobsJobIdStageQuestionsGetQueryKey =
  (jobId?: string) => {
    return [`/api/v1/recruiting/jobs/${jobId}/stage-questions`] as const;
  };

export const getGetAllJobStageQuestionsApiV1RecruitingJobsJobIdStageQuestionsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getAllJobStageQuestionsApiV1RecruitingJobsJobIdStageQuestionsGet
      >
    >,
    TError = HTTPValidationError
  >(
    jobId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getAllJobStageQuestionsApiV1RecruitingJobsJobIdStageQuestionsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetAllJobStageQuestionsApiV1RecruitingJobsJobIdStageQuestionsGetQueryKey(
        jobId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getAllJobStageQuestionsApiV1RecruitingJobsJobIdStageQuestionsGet
        >
      >
    > = ({ signal }) =>
      getAllJobStageQuestionsApiV1RecruitingJobsJobIdStageQuestionsGet(
        jobId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!jobId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getAllJobStageQuestionsApiV1RecruitingJobsJobIdStageQuestionsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetAllJobStageQuestionsApiV1RecruitingJobsJobIdStageQuestionsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getAllJobStageQuestionsApiV1RecruitingJobsJobIdStageQuestionsGet
      >
    >
  >;
export type GetAllJobStageQuestionsApiV1RecruitingJobsJobIdStageQuestionsGetQueryError =
  HTTPValidationError;

export function useGetAllJobStageQuestionsApiV1RecruitingJobsJobIdStageQuestionsGet<
  TData = Awaited<
    ReturnType<
      typeof getAllJobStageQuestionsApiV1RecruitingJobsJobIdStageQuestionsGet
    >
  >,
  TError = HTTPValidationError
>(
  jobId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAllJobStageQuestionsApiV1RecruitingJobsJobIdStageQuestionsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getAllJobStageQuestionsApiV1RecruitingJobsJobIdStageQuestionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getAllJobStageQuestionsApiV1RecruitingJobsJobIdStageQuestionsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAllJobStageQuestionsApiV1RecruitingJobsJobIdStageQuestionsGet<
  TData = Awaited<
    ReturnType<
      typeof getAllJobStageQuestionsApiV1RecruitingJobsJobIdStageQuestionsGet
    >
  >,
  TError = HTTPValidationError
>(
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAllJobStageQuestionsApiV1RecruitingJobsJobIdStageQuestionsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getAllJobStageQuestionsApiV1RecruitingJobsJobIdStageQuestionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getAllJobStageQuestionsApiV1RecruitingJobsJobIdStageQuestionsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAllJobStageQuestionsApiV1RecruitingJobsJobIdStageQuestionsGet<
  TData = Awaited<
    ReturnType<
      typeof getAllJobStageQuestionsApiV1RecruitingJobsJobIdStageQuestionsGet
    >
  >,
  TError = HTTPValidationError
>(
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAllJobStageQuestionsApiV1RecruitingJobsJobIdStageQuestionsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get All Job Stage Questions
 */

export function useGetAllJobStageQuestionsApiV1RecruitingJobsJobIdStageQuestionsGet<
  TData = Awaited<
    ReturnType<
      typeof getAllJobStageQuestionsApiV1RecruitingJobsJobIdStageQuestionsGet
    >
  >,
  TError = HTTPValidationError
>(
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAllJobStageQuestionsApiV1RecruitingJobsJobIdStageQuestionsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetAllJobStageQuestionsApiV1RecruitingJobsJobIdStageQuestionsGetQueryOptions(
      jobId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Copy interview questions from pipeline stage templates to job-stage level.
 * @summary Copy Stage Questions From Template
 */
export const copyStageQuestionsFromTemplateApiV1RecruitingJobsJobIdCopyStageQuestionsPost =
  (jobId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/recruiting/jobs/${jobId}/copy-stage-questions`,
      method: 'POST',
      signal
    });
  };

export const getCopyStageQuestionsFromTemplateApiV1RecruitingJobsJobIdCopyStageQuestionsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof copyStageQuestionsFromTemplateApiV1RecruitingJobsJobIdCopyStageQuestionsPost
        >
      >,
      TError,
      { jobId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof copyStageQuestionsFromTemplateApiV1RecruitingJobsJobIdCopyStageQuestionsPost
      >
    >,
    TError,
    { jobId: string },
    TContext
  > => {
    const mutationKey = [
      'copyStageQuestionsFromTemplateApiV1RecruitingJobsJobIdCopyStageQuestionsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof copyStageQuestionsFromTemplateApiV1RecruitingJobsJobIdCopyStageQuestionsPost
        >
      >,
      { jobId: string }
    > = (props) => {
      const { jobId } = props ?? {};

      return copyStageQuestionsFromTemplateApiV1RecruitingJobsJobIdCopyStageQuestionsPost(
        jobId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CopyStageQuestionsFromTemplateApiV1RecruitingJobsJobIdCopyStageQuestionsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof copyStageQuestionsFromTemplateApiV1RecruitingJobsJobIdCopyStageQuestionsPost
      >
    >
  >;

export type CopyStageQuestionsFromTemplateApiV1RecruitingJobsJobIdCopyStageQuestionsPostMutationError =
  HTTPValidationError;

/**
 * @summary Copy Stage Questions From Template
 */
export const useCopyStageQuestionsFromTemplateApiV1RecruitingJobsJobIdCopyStageQuestionsPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof copyStageQuestionsFromTemplateApiV1RecruitingJobsJobIdCopyStageQuestionsPost
          >
        >,
        TError,
        { jobId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof copyStageQuestionsFromTemplateApiV1RecruitingJobsJobIdCopyStageQuestionsPost
      >
    >,
    TError,
    { jobId: string },
    TContext
  > => {
    const mutationOptions =
      getCopyStageQuestionsFromTemplateApiV1RecruitingJobsJobIdCopyStageQuestionsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Get planned questions for an interview.
 * @summary Get Interview Planned Questions
 */
export const getInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsGet =
  (interviewId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/recruiting/interviews/${interviewId}/planned-questions`,
      method: 'GET',
      signal
    });
  };

export const getGetInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsGetQueryKey =
  (interviewId?: string) => {
    return [
      `/api/v1/recruiting/interviews/${interviewId}/planned-questions`
    ] as const;
  };

export const getGetInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsGet
      >
    >,
    TError = HTTPValidationError
  >(
    interviewId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsGetQueryKey(
        interviewId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsGet
        >
      >
    > = ({ signal }) =>
      getInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsGet(
        interviewId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!interviewId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsGet
      >
    >
  >;
export type GetInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsGetQueryError =
  HTTPValidationError;

export function useGetInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsGet<
  TData = Awaited<
    ReturnType<
      typeof getInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsGet
    >
  >,
  TError = HTTPValidationError
>(
  interviewId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsGet<
  TData = Awaited<
    ReturnType<
      typeof getInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsGet
    >
  >,
  TError = HTTPValidationError
>(
  interviewId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsGet<
  TData = Awaited<
    ReturnType<
      typeof getInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsGet
    >
  >,
  TError = HTTPValidationError
>(
  interviewId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Interview Planned Questions
 */

export function useGetInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsGet<
  TData = Awaited<
    ReturnType<
      typeof getInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsGet
    >
  >,
  TError = HTTPValidationError
>(
  interviewId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsGetQueryOptions(
      interviewId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update planned questions for an interview.
 * @summary Update Interview Planned Questions
 */
export const updateInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsPut =
  (
    interviewId: string,
    updateJobStageQuestionsRequest: UpdateJobStageQuestionsRequest
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/recruiting/interviews/${interviewId}/planned-questions`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateJobStageQuestionsRequest
    });
  };

export const getUpdateInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsPut
        >
      >,
      TError,
      { interviewId: string; data: UpdateJobStageQuestionsRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsPut
      >
    >,
    TError,
    { interviewId: string; data: UpdateJobStageQuestionsRequest },
    TContext
  > => {
    const mutationKey = [
      'updateInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsPut
        >
      >,
      { interviewId: string; data: UpdateJobStageQuestionsRequest }
    > = (props) => {
      const { interviewId, data } = props ?? {};

      return updateInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsPut(
        interviewId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsPut
      >
    >
  >;
export type UpdateInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsPutMutationBody =
  UpdateJobStageQuestionsRequest;
export type UpdateInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Interview Planned Questions
 */
export const useUpdateInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsPut
          >
        >,
        TError,
        { interviewId: string; data: UpdateJobStageQuestionsRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsPut
      >
    >,
    TError,
    { interviewId: string; data: UpdateJobStageQuestionsRequest },
    TContext
  > => {
    const mutationOptions =
      getUpdateInterviewPlannedQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Use AI to refine interview questions for a job-stage combination.
 * @summary Ai Refine Job Stage Questions
 */
export const aiRefineJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsAiRefinePost =
  (
    jobId: string,
    stageId: string,
    refineQuestionsRequest: RefineQuestionsRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/recruiting/jobs/${jobId}/stages/${stageId}/questions/ai-refine`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: refineQuestionsRequest,
      signal
    });
  };

export const getAiRefineJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsAiRefinePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof aiRefineJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsAiRefinePost
        >
      >,
      TError,
      { jobId: string; stageId: string; data: RefineQuestionsRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof aiRefineJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsAiRefinePost
      >
    >,
    TError,
    { jobId: string; stageId: string; data: RefineQuestionsRequest },
    TContext
  > => {
    const mutationKey = [
      'aiRefineJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsAiRefinePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof aiRefineJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsAiRefinePost
        >
      >,
      { jobId: string; stageId: string; data: RefineQuestionsRequest }
    > = (props) => {
      const { jobId, stageId, data } = props ?? {};

      return aiRefineJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsAiRefinePost(
        jobId,
        stageId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AiRefineJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsAiRefinePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof aiRefineJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsAiRefinePost
      >
    >
  >;
export type AiRefineJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsAiRefinePostMutationBody =
  RefineQuestionsRequest;
export type AiRefineJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsAiRefinePostMutationError =
  HTTPValidationError;

/**
 * @summary Ai Refine Job Stage Questions
 */
export const useAiRefineJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsAiRefinePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof aiRefineJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsAiRefinePost
          >
        >,
        TError,
        { jobId: string; stageId: string; data: RefineQuestionsRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof aiRefineJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsAiRefinePost
      >
    >,
    TError,
    { jobId: string; stageId: string; data: RefineQuestionsRequest },
    TContext
  > => {
    const mutationOptions =
      getAiRefineJobStageQuestionsApiV1RecruitingJobsJobIdStagesStageIdQuestionsAiRefinePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Use AI to refine planned questions for a specific interview (candidate-aware).
 * @summary Ai Refine Interview Questions
 */
export const aiRefineInterviewQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsAiRefinePost =
  (
    interviewId: string,
    refineQuestionsRequest: RefineQuestionsRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/recruiting/interviews/${interviewId}/planned-questions/ai-refine`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: refineQuestionsRequest,
      signal
    });
  };

export const getAiRefineInterviewQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsAiRefinePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof aiRefineInterviewQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsAiRefinePost
        >
      >,
      TError,
      { interviewId: string; data: RefineQuestionsRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof aiRefineInterviewQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsAiRefinePost
      >
    >,
    TError,
    { interviewId: string; data: RefineQuestionsRequest },
    TContext
  > => {
    const mutationKey = [
      'aiRefineInterviewQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsAiRefinePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof aiRefineInterviewQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsAiRefinePost
        >
      >,
      { interviewId: string; data: RefineQuestionsRequest }
    > = (props) => {
      const { interviewId, data } = props ?? {};

      return aiRefineInterviewQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsAiRefinePost(
        interviewId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AiRefineInterviewQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsAiRefinePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof aiRefineInterviewQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsAiRefinePost
      >
    >
  >;
export type AiRefineInterviewQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsAiRefinePostMutationBody =
  RefineQuestionsRequest;
export type AiRefineInterviewQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsAiRefinePostMutationError =
  HTTPValidationError;

/**
 * @summary Ai Refine Interview Questions
 */
export const useAiRefineInterviewQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsAiRefinePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof aiRefineInterviewQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsAiRefinePost
          >
        >,
        TError,
        { interviewId: string; data: RefineQuestionsRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof aiRefineInterviewQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsAiRefinePost
      >
    >,
    TError,
    { interviewId: string; data: RefineQuestionsRequest },
    TContext
  > => {
    const mutationOptions =
      getAiRefineInterviewQuestionsApiV1RecruitingInterviewsInterviewIdPlannedQuestionsAiRefinePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List recruiting agency companies with recruiter and assigned job counts.
 * @summary List Agents
 */
export const listAgentsApiV1RecruitingAgentsGet = (
  params?: ListAgentsApiV1RecruitingAgentsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/agents`,
    method: 'GET',
    params,
    signal
  });
};

export const getListAgentsApiV1RecruitingAgentsGetQueryKey = (
  params?: ListAgentsApiV1RecruitingAgentsGetParams
) => {
  return [`/api/v1/recruiting/agents`, ...(params ? [params] : [])] as const;
};

export const getListAgentsApiV1RecruitingAgentsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listAgentsApiV1RecruitingAgentsGet>>,
  TError = HTTPValidationError
>(
  params?: ListAgentsApiV1RecruitingAgentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAgentsApiV1RecruitingAgentsGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListAgentsApiV1RecruitingAgentsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAgentsApiV1RecruitingAgentsGet>>
  > = ({ signal }) => listAgentsApiV1RecruitingAgentsGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAgentsApiV1RecruitingAgentsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListAgentsApiV1RecruitingAgentsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAgentsApiV1RecruitingAgentsGet>>
>;
export type ListAgentsApiV1RecruitingAgentsGetQueryError = HTTPValidationError;

export function useListAgentsApiV1RecruitingAgentsGet<
  TData = Awaited<ReturnType<typeof listAgentsApiV1RecruitingAgentsGet>>,
  TError = HTTPValidationError
>(
  params: undefined | ListAgentsApiV1RecruitingAgentsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAgentsApiV1RecruitingAgentsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAgentsApiV1RecruitingAgentsGet>>,
          TError,
          Awaited<ReturnType<typeof listAgentsApiV1RecruitingAgentsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListAgentsApiV1RecruitingAgentsGet<
  TData = Awaited<ReturnType<typeof listAgentsApiV1RecruitingAgentsGet>>,
  TError = HTTPValidationError
>(
  params?: ListAgentsApiV1RecruitingAgentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAgentsApiV1RecruitingAgentsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAgentsApiV1RecruitingAgentsGet>>,
          TError,
          Awaited<ReturnType<typeof listAgentsApiV1RecruitingAgentsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListAgentsApiV1RecruitingAgentsGet<
  TData = Awaited<ReturnType<typeof listAgentsApiV1RecruitingAgentsGet>>,
  TError = HTTPValidationError
>(
  params?: ListAgentsApiV1RecruitingAgentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAgentsApiV1RecruitingAgentsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Agents
 */

export function useListAgentsApiV1RecruitingAgentsGet<
  TData = Awaited<ReturnType<typeof listAgentsApiV1RecruitingAgentsGet>>,
  TError = HTTPValidationError
>(
  params?: ListAgentsApiV1RecruitingAgentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAgentsApiV1RecruitingAgentsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListAgentsApiV1RecruitingAgentsGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get agency companies assigned to a job.
 * @summary Get Job Agency Companies
 */
export const getJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesGet = (
  jobId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/jobs/${jobId}/agency-companies`,
    method: 'GET',
    signal
  });
};

export const getGetJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesGetQueryKey =
  (jobId?: string) => {
    return [`/api/v1/recruiting/jobs/${jobId}/agency-companies`] as const;
  };

export const getGetJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesGet
      >
    >,
    TError = HTTPValidationError
  >(
    jobId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesGetQueryKey(
        jobId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesGet
        >
      >
    > = ({ signal }) =>
      getJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesGet(
        jobId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!jobId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesGet
      >
    >
  >;
export type GetJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesGetQueryError =
  HTTPValidationError;

export function useGetJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesGet<
  TData = Awaited<
    ReturnType<
      typeof getJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesGet
    >
  >,
  TError = HTTPValidationError
>(
  jobId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesGet<
  TData = Awaited<
    ReturnType<
      typeof getJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesGet
    >
  >,
  TError = HTTPValidationError
>(
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesGet<
  TData = Awaited<
    ReturnType<
      typeof getJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesGet
    >
  >,
  TError = HTTPValidationError
>(
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Job Agency Companies
 */

export function useGetJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesGet<
  TData = Awaited<
    ReturnType<
      typeof getJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesGet
    >
  >,
  TError = HTTPValidationError
>(
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesGetQueryOptions(
      jobId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Link agency companies to a job, naming ONLY the agencies being added.

Re-linking an agency already linked is a no-op rather than an error, so a
double-click or a retried request is idempotent — but it DOES re-assert
``has_portal_access``, which is how that flag is toggled.
 * @summary Add Job Agency Companies
 */
export const addJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesPost =
  (
    jobId: string,
    recruitingJobAgencyCompanyLinkCreate: RecruitingJobAgencyCompanyLinkCreate,
    signal?: AbortSignal
  ) => {
    return customInstance<RecruitingJobAgencyCompanyLinksResponse>({
      url: `/api/v1/recruiting/jobs/${jobId}/agency-companies`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: recruitingJobAgencyCompanyLinkCreate,
      signal
    });
  };

export const getAddJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof addJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesPost
        >
      >,
      TError,
      { jobId: string; data: RecruitingJobAgencyCompanyLinkCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof addJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesPost
      >
    >,
    TError,
    { jobId: string; data: RecruitingJobAgencyCompanyLinkCreate },
    TContext
  > => {
    const mutationKey = [
      'addJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof addJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesPost
        >
      >,
      { jobId: string; data: RecruitingJobAgencyCompanyLinkCreate }
    > = (props) => {
      const { jobId, data } = props ?? {};

      return addJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesPost(
        jobId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AddJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof addJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesPost
      >
    >
  >;
export type AddJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesPostMutationBody =
  RecruitingJobAgencyCompanyLinkCreate;
export type AddJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesPostMutationError =
  HTTPValidationError;

/**
 * @summary Add Job Agency Companies
 */
export const useAddJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof addJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesPost
          >
        >,
        TError,
        { jobId: string; data: RecruitingJobAgencyCompanyLinkCreate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof addJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesPost
      >
    >,
    TError,
    { jobId: string; data: RecruitingJobAgencyCompanyLinkCreate },
    TContext
  > => {
    const mutationOptions =
      getAddJobAgencyCompaniesApiV1RecruitingJobsJobIdAgencyCompaniesPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Unlink ONE agency company from a job.

EDITOR on the job only — deliberately NO VIEWER check on the agency (§5
remove-link): revoking a share would otherwise leave the job's owner unable to
detach a now-invisible agency, and removal reveals nothing.
 * @summary Remove Job Agency Company
 */
export const removeJobAgencyCompanyApiV1RecruitingJobsJobIdAgencyCompaniesOrganizationIdDelete =
  (jobId: string, organizationId: string) => {
    return customInstance<RecruitingJobAgencyCompanyLinksResponse>({
      url: `/api/v1/recruiting/jobs/${jobId}/agency-companies/${organizationId}`,
      method: 'DELETE'
    });
  };

export const getRemoveJobAgencyCompanyApiV1RecruitingJobsJobIdAgencyCompaniesOrganizationIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof removeJobAgencyCompanyApiV1RecruitingJobsJobIdAgencyCompaniesOrganizationIdDelete
        >
      >,
      TError,
      { jobId: string; organizationId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof removeJobAgencyCompanyApiV1RecruitingJobsJobIdAgencyCompaniesOrganizationIdDelete
      >
    >,
    TError,
    { jobId: string; organizationId: string },
    TContext
  > => {
    const mutationKey = [
      'removeJobAgencyCompanyApiV1RecruitingJobsJobIdAgencyCompaniesOrganizationIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof removeJobAgencyCompanyApiV1RecruitingJobsJobIdAgencyCompaniesOrganizationIdDelete
        >
      >,
      { jobId: string; organizationId: string }
    > = (props) => {
      const { jobId, organizationId } = props ?? {};

      return removeJobAgencyCompanyApiV1RecruitingJobsJobIdAgencyCompaniesOrganizationIdDelete(
        jobId,
        organizationId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RemoveJobAgencyCompanyApiV1RecruitingJobsJobIdAgencyCompaniesOrganizationIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof removeJobAgencyCompanyApiV1RecruitingJobsJobIdAgencyCompaniesOrganizationIdDelete
      >
    >
  >;

export type RemoveJobAgencyCompanyApiV1RecruitingJobsJobIdAgencyCompaniesOrganizationIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Remove Job Agency Company
 */
export const useRemoveJobAgencyCompanyApiV1RecruitingJobsJobIdAgencyCompaniesOrganizationIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof removeJobAgencyCompanyApiV1RecruitingJobsJobIdAgencyCompaniesOrganizationIdDelete
          >
        >,
        TError,
        { jobId: string; organizationId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof removeJobAgencyCompanyApiV1RecruitingJobsJobIdAgencyCompaniesOrganizationIdDelete
      >
    >,
    TError,
    { jobId: string; organizationId: string },
    TContext
  > => {
    const mutationOptions =
      getRemoveJobAgencyCompanyApiV1RecruitingJobsJobIdAgencyCompaniesOrganizationIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Get candidate source statistics for a job.
 * @summary Get Job Source Stats
 */
export const getJobSourceStatsApiV1RecruitingJobsJobIdSourceStatsGet = (
  jobId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/recruiting/jobs/${jobId}/source-stats`,
    method: 'GET',
    signal
  });
};

export const getGetJobSourceStatsApiV1RecruitingJobsJobIdSourceStatsGetQueryKey =
  (jobId?: string) => {
    return [`/api/v1/recruiting/jobs/${jobId}/source-stats`] as const;
  };

export const getGetJobSourceStatsApiV1RecruitingJobsJobIdSourceStatsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getJobSourceStatsApiV1RecruitingJobsJobIdSourceStatsGet>
    >,
    TError = HTTPValidationError
  >(
    jobId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getJobSourceStatsApiV1RecruitingJobsJobIdSourceStatsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetJobSourceStatsApiV1RecruitingJobsJobIdSourceStatsGetQueryKey(jobId);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getJobSourceStatsApiV1RecruitingJobsJobIdSourceStatsGet
        >
      >
    > = ({ signal }) =>
      getJobSourceStatsApiV1RecruitingJobsJobIdSourceStatsGet(jobId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!jobId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getJobSourceStatsApiV1RecruitingJobsJobIdSourceStatsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetJobSourceStatsApiV1RecruitingJobsJobIdSourceStatsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getJobSourceStatsApiV1RecruitingJobsJobIdSourceStatsGet>
    >
  >;
export type GetJobSourceStatsApiV1RecruitingJobsJobIdSourceStatsGetQueryError =
  HTTPValidationError;

export function useGetJobSourceStatsApiV1RecruitingJobsJobIdSourceStatsGet<
  TData = Awaited<
    ReturnType<typeof getJobSourceStatsApiV1RecruitingJobsJobIdSourceStatsGet>
  >,
  TError = HTTPValidationError
>(
  jobId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getJobSourceStatsApiV1RecruitingJobsJobIdSourceStatsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getJobSourceStatsApiV1RecruitingJobsJobIdSourceStatsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getJobSourceStatsApiV1RecruitingJobsJobIdSourceStatsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetJobSourceStatsApiV1RecruitingJobsJobIdSourceStatsGet<
  TData = Awaited<
    ReturnType<typeof getJobSourceStatsApiV1RecruitingJobsJobIdSourceStatsGet>
  >,
  TError = HTTPValidationError
>(
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getJobSourceStatsApiV1RecruitingJobsJobIdSourceStatsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getJobSourceStatsApiV1RecruitingJobsJobIdSourceStatsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getJobSourceStatsApiV1RecruitingJobsJobIdSourceStatsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetJobSourceStatsApiV1RecruitingJobsJobIdSourceStatsGet<
  TData = Awaited<
    ReturnType<typeof getJobSourceStatsApiV1RecruitingJobsJobIdSourceStatsGet>
  >,
  TError = HTTPValidationError
>(
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getJobSourceStatsApiV1RecruitingJobsJobIdSourceStatsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Job Source Stats
 */

export function useGetJobSourceStatsApiV1RecruitingJobsJobIdSourceStatsGet<
  TData = Awaited<
    ReturnType<typeof getJobSourceStatsApiV1RecruitingJobsJobIdSourceStatsGet>
  >,
  TError = HTTPValidationError
>(
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getJobSourceStatsApiV1RecruitingJobsJobIdSourceStatsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetJobSourceStatsApiV1RecruitingJobsJobIdSourceStatsGetQueryOptions(
      jobId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
